// French for the HEVN Portal — GENERATED by scripts/i18n_langs.cjs from flat translations of `en` in
// i18n.js (2026-10-21). Edit a string here or re-run the script; a key absent here falls back to English.
// Acronyms, system and product names stay as written (EXF, FOB, MOQ, SAP, NetSuite, Helinox …).
const fr = {
  "common": {
    "notif": {
      "title": "Notifications",
      "unreadCount": "{{count}} notifications non lues",
      "markAll": "Tout marquer comme lu",
      "markRead": "Marquer comme lu",
      "loading": "Chargement…",
      "empty": "Rien pour vous pour le moment. Lorsque le portail vous envoie un e-mail au sujet de votre travail, il s'affiche aussi ici.",
      "open": "Ouvrir la page concernée",
      "by": "par {{name}}",
      "settings": "Choisir ce qui sonne",
      "settingsHint": "Sélectionnez les groupes que vous souhaitez voir dans la cloche. Les e-mails continuent d'arriver comme avant ; un groupe désactivé est seulement masqué ici et réapparaît dès que vous le réactivez.",
      "save": "Enregistrer",
      "cancel": "Retour",
      "saved": "Enregistré",
      "unreadIn": "{{count}} non lues",
      "g_approvals": "Approbations et décisions",
      "g_access": "Demandes d'accès (nouveaux utilisateurs)",
      "g_tickets": "Tickets",
      "g_samples": "Échéances des échantillons",
      "g_projects": "Projets (SKU ajoutés, déplacés, abandonnés)",
      "g_cycletime": "Contrôles du temps de cycle",
      "g_ceo": "Bureau du CEO",
      "g_chat": "Chat de groupe (GCC)",
      "g_tasks": "Projets système",
      "g_other": "Autre",
      "hidden": "{{count}} groupe(s) masqué(s)",
      "merged": "{{who}} a apporté {{count}} modifications à « {{subject}} »",
      "mergedNoWho": "{{count}} modifications à « {{subject}} »",
      "loadMore": "Afficher plus",
      "showHidden": "Les afficher",
      "hideHidden": "Les masquer à nouveau",
      "fromHidden": "groupe masqué"
    },
    "common": {
      "language": "Langue",
      "theme": "Thème",
      "light": "Clair",
      "dark": "Sombre",
      "allRoles": "Tous les rôles"
    },
    "cpAtt": {
      "photos": "Photos",
      "messages": "Messages",
      "you": "Vous",
      "pendingTag": "envoyé à l'enregistrement",
      "noMessages": "Aucun message pour le moment.",
      "placeholder": "Écrivez une note sur ce devis…",
      "send": "Envoyer",
      "withdraw": "Supprimer",
      "deleteConfirm": "Supprimer ce message ? Il sera supprimé pour tout le monde et ne pourra pas être récupéré.",
      "saveFailed": "Le message n'a pas pu être enregistré.",
      "deleteFailed": "Le message n'a pas pu être supprimé."
    },
    "bench": {
      "title": "Fiches de coûts Inline",
      "sub": "Les fiches de coûts fournisseur lues dans le benchmark Inline, conservées pour pouvoir comparer un devis à l'une d'elles sans le fichier.",
      "search": "Rechercher un style, un fichier, un fournisseur, une saison…",
      "empty": "Aucune fiche de coûts n'a encore été lue. Utilisez « Importer une fiche de coûts » ci-dessus : ce qui est lu est conservé ici et proposé à chaque remplissage du benchmark Inline d'un devis.",
      "noHit": "Aucun résultat pour « {{q}} ».",
      "loading": "Lecture de la fiche…",
      "lines": "{{n}} ligne(s)",
      "edit": "Modifier les détails",
      "remove": "Retirer",
      "save": "Enregistrer",
      "saved": "Enregistré.",
      "removed": "Retiré de la bibliothèque.",
      "editTitle": "Saison, fournisseur et note",
      "editBody": "Les trois informations que le classeur n'indique pas. Les coûts ne sont pas modifiables : ce sont ceux déclarés par le fournisseur, et le coût d'achat à côté est celui auquel ils ont été comparés.",
      "season": "Saison",
      "vendor": "Fournisseur",
      "note": "Note",
      "removeTitle": "Retirer cette fiche de coûts ?",
      "removeBody": "{{file}} quitte la bibliothèque et n'est plus proposé lors du remplissage d'un benchmark. Les devis déjà comparés à cette fiche conservent leurs chiffres et la ligne imprimée à côté.",
      "colLine": "Ligne",
      "colVariant": "Version du coût",
      "colStated": "Coût d'achat de la fiche",
      "import": "Importer une fiche de coûts",
      "readOk": "{{file}} — {{n}} ligne(s) lue(s) et conservée(s).",
      "readRefused": "{{n}} ligne(s) refusée(s) : leurs colonnes ne correspondent pas au coût d'achat imprimé à côté."
    },
    "ceo": {
      "title": "Bureau du CEO",
      "sub": "Tout ce qui est ouvert, suivi jusqu'à sa clôture. Un e-mail transféré à ceo.office@ devient un ticket ; les compteurs sont calculés à partir du journal d'événements propre à chaque ticket.",
      "desk": "Pôle",
      "bothDesks": "Les deux",
      "desk_business": "Affaires",
      "desk_executive": "Direction",
      "refresh": "Actualiser",
      "newTicket": "Nouveau ticket",
      "newSub": "Un ticket est créé sur un pôle et y reste. L'entité et le contact interne peuvent rester vides : la plupart des éléments démarrent sans rattachement.",
      "create": "Créer",
      "cancel": "Annuler",
      "close": "Clôturer",
      "needTitle": "Le ticket doit avoir un titre.",
      "fromWho": "De",
      "notSet": "non défini",
      "noTickets": "Aucun ticket sur ce pôle pour le moment.",
      "noDesk": "Vous n'êtes sur aucun pôle, il n'y a donc rien à afficher. Demandez à Young de vous ajouter à Business ou à Executive.",
      "filteredBy": "Affichage de {{name}} uniquement — {{n}} ticket(s).",
      "clearFilter": "Tout afficher",
      "cardOpen": "En cours",
      "cardOpenRule": "ni clôturé ni abandonné",
      "cardOverdue": "Échéance dépassée",
      "cardOverdueRule": "toujours ouvert, échéance passée",
      "cardUntouched": "Sans suite depuis 3 jours et +",
      "cardUntouchedRule": "depuis le dernier événement de contact",
      "cardWaiting": "En attente du CEO",
      "cardWaitingRule": "selon le statut",
      "cardNoEntity": "Entité non définie",
      "cardNoEntityRule": "pas encore de rattachement",
      "cardClosed": "Clôturés cette semaine",
      "cardClosedRule": "clôturés ces 7 derniers jours",
      "colTicket": "Ticket",
      "colTitle": "Titre / expéditeur",
      "colDesk": "Pôle",
      "colType": "Type",
      "colEntity": "Entité",
      "colContact": "Contact interne",
      "colOwner": "Responsable",
      "colDue": "Échéance",
      "colStatus": "Statut",
      "colLast": "Dernier contact",
      "colDday": "D-day",
      "logTitle": "Journal d'événements",
      "logContacted": "Nous les avons contactés",
      "logReply": "Ils ont répondu",
      "ev_created": "créé",
      "ev_contacted": "contacté",
      "ev_reply": "réponse",
      "ev_status": "statut",
      "ev_field": "modifié",
      "ev_closed": "clôturé",
      "ev_reopened": "rouvert",
      "ev_note": "note",
      "closeTicket": "Clôturer le ticket",
      "reopenTicket": "Rouvrir",
      "closeTitle": "Clôturer {{id}}",
      "reopenTitle": "Rouvrir {{id}}",
      "closeSub": "Il quitte EN COURS et ÉCHÉANCE DÉPASSÉE et compte dans CLÔTURÉS CETTE SEMAINE. Il reste dans la liste et dans la recherche, avec tout son historique, et peut être rouvert.",
      "reopenSub": "Il revient au statut dont il a été clôturé et compte de nouveau comme ouvert.",
      "closeNote": "Note de clôture (facultatif)",
      "reopenNote": "Motif de la réouverture (facultatif)",
      "closeNotePh": "ex. Convenu lors de l'appel — rien de plus n'est nécessaire.",
      "reopenNotePh": "ex. Ils ont répondu avec une nouvelle demande.",
      "closedBy": "Clôturé par {{who}} · {{when}}",
      "statusClosedHint": "Clôturé — cliquez sur Rouvrir pour changer le statut.",
      "logNote": "Ajouter une note interne",
      "logNoteSub": "Visible dans le portail par toute personne pouvant ouvrir ce ticket, et envoyée à personne par e-mail. Ce n'est pas un contact et cela ne modifie pas Dernier contact. Ctrl+Entrée pour enregistrer.",
      "logNoteWhy": "Une note pour le pôle et le CEO. Elle ne modifie ni date ni compteur.",
      "notePh": "Ce qui s'est passé, ce qui a été décidé, la suite.",
      "historyTitle": "Historique",
      "hist_all": "Tout",
      "hist_mail": "E-mails",
      "hist_note": "Notes",
      "hist_change": "Modifications",
      "historyEmpty": "Rien de ce type sur le ticket pour le moment.",
      "hSent": "E-mail envoyé",
      "hReceived": "E-mail reçu",
      "hSentWhy": "Envoyé depuis la boîte CEO Office ou par un membre d'un pôle.",
      "hReceivedWhy": "Envoyé au CEO Office depuis l'extérieur.",
      "hTo": "À",
      "hCc": "Cc",
      "hQuoted": "Afficher les messages précédents cités dans cet e-mail",
      "hQuotedHide": "Masquer les messages cités",
      "hNote": "Note interne",
      "hCreated": "Ticket créé",
      "hCreatedMail": "Ticket créé à partir de la boîte CEO Office",
      "hClosed": "Clôturé (était {{from}})",
      "hReopened": "Rouvert → {{to}}",
      "hFile": "Fichier joint",
      "historyScope": "Les e-mails apparaissent ici lorsqu'ils atteignent {{mailbox}} — envoyés à cette adresse, en copie, ou envoyés depuis celle-ci. Un e-mail qu'un membre d'un pôle envoie depuis sa propre boîte sans mettre {{mailbox}} en copie n'est pas visible par le portail.",
      "restricted": "restreint — l'autre pôle",
      "otherDesk": "Ce ticket appartient à l'autre pôle. Vous pouvez voir qu'il existe ; son historique ne vous est pas accessible.",
      "entityTitle": "Adresses CC par entité",
      "entityFilled": "{{n}} sur {{total}} renseignées",
      "entitySub": "L'entité et le contact interne sont les destinataires mis en copie des e-mails sortants d'un ticket. Ces champs restent vides tant que Young n'a pas envoyé les huit adresses — une adresse saisie ici reçoit de vrais e-mails, donc aucune n'est devinée.",
      "entityPh": "pas encore défini",
      "fTitle": "Titre",
      "fTitlePh": "Ce qui a été ouvert — l'objet suivi par ce ticket",
      "fFromPh": "De qui cela provient, le cas échéant",
      "fTypePh": "Suivi, Juridique, Document…",
      "newLater": "Tout sauf le titre peut rester vide et être complété plus tard — la plupart des éléments démarrent sans rattachement.",
      "fLaterPh": "Laisser vide si pas encore connu",
      "tabTickets": "Tickets",
      "allDesks": "Tous",
      "unassigned": "Non attribué",
      "choosedesk": "Placer sur…",
      "deskRule": "Un pôle ne voit que ses propres tickets. Le CEO voit les deux.",
      "open": "Ouvrir",
      "fAllStatuses": "Tous les statuts",
      "fAllTypes": "Tous les types",
      "fAllEntities": "Toutes les entités",
      "fAllContacts": "Tous les contacts internes",
      "fAllOwners": "Tous les responsables",
      "searchPh": "Rechercher un titre ou un expéditeur…",
      "searchLeadPh": "Rechercher une contrepartie…",
      "ddayWhat": "Compté à partir de l'échéance. + = jours de dépassement, - = jours restants.",
      "ddayLegend": "Le D-day est compté à partir de l'échéance : +5 signifie cinq jours de dépassement, -5 signifie cinq jours restants. Il n'est compté que tant qu'un ticket est ouvert.",
      "ev_file": "fichier",
      "fileUnreadable": "Ce fichier n'a pas pu être lu.",
      "files": "Pièces jointes",
      "filesSub": "Ce que ce ticket attend, ou ce qui l'accompagne. 10 Mo chacune, {{n}} par ticket.",
      "addFile": "Ajouter un fichier",
      "removeFile": "Retirer",
      "removeFileSub": "Le fichier est supprimé du serveur. Cette action est irréversible.",
      "uploading": "Importation…",
      "logContactedSub": "Par quel canal cela est parti et ce que vous avez dit. Les deux sont facultatifs — la date est enregistrée dans tous les cas. Ctrl+Entrée pour enregistrer.",
      "logReplySub": "Par quel canal la réponse est revenue et ce qu'ils ont dit. Les deux sont facultatifs — la date est enregistrée dans tous les cas. Ctrl+Entrée pour enregistrer.",
      "channel": "Comment",
      "channelPh": "E-mail, Téléphone, Réunion…",
      "contactNote": "Note",
      "contactNotePh": "ex. relancé pour la copie signée",
      "replyNotePh": "ex. ils ont besoin de deux semaines de plus",
      "record": "Enregistrer",
      "colDwell": "Jours au statut actuel",
      "nDays": "{{n}} j",
      "atStageN": "{{n}} j à cette étape",
      "worstN": "pire : {{n}} j",
      "lateShape": "Où se trouvent les retards",
      "lateShapeSub": "une seule file bloquée, ou toutes",
      "nothingLate": "Rien n'a dépassé sa date.",
      "howLong": "Délais de ce pôle",
      "howLongSub": "d'après le journal d'événements — rien n'est saisi à la main",
      "toFirstAnswer": "Création → première réponse",
      "toClose": "Création → clôture",
      "neverAnswered": "Ouverts et jamais répondus",
      "medianOf": "médiane de {{n}}",
      "notEnough": "pas assez de données — {{n}} pour l'instant",
      "loading": "Chargement…",
      "noHistory": "Rien d'enregistré pour le moment.",
      "reset": "Réinitialiser",
      "resetN": "Réinitialiser ({{n}})",
      "sortedBy": "trié par {{col}}",
      "showingN": "Affichage de {{n}} sur {{total}} —",
      "leadContactHint": "Enregistre la date — Dernier contact et « sans réponse » sont tous deux comptés à partir de celle-ci.",
      "exportExcel": "Exporter vers Excel",
      "contactHint": "Enregistre la date — Dernier contact et SANS SUITE DEPUIS 3 JOURS ET + sont tous deux comptés à partir de celle-ci.",
      "logContactedWhy": "Nous avons pris contact. Date du jour apposée sur ce ticket et le décompte « sans suite » repart de zéro.",
      "logReplyWhy": "Ils ont répondu. La date du jour est également apposée — séparé car être relancé et être répondu sont deux faits différents.",
      "tab_tickets": "Tickets",
      "tab_leads": "Prospects",
      "tab_daily": "Quotidien",
      "sub_tickets": "Tout ce qui est ouvert, suivi jusqu'à sa clôture. Un e-mail transféré à ceo.office@ devient un ticket ; les compteurs sont calculés à partir du journal d'événements propre à chaque ticket.",
      "sub_leads": "Pipeline de nouveaux comptes. Le CEO fixe où nous cherchons et à quelles conditions ; le pôle prend contact et vérifie la réponse par rapport aux critères.",
      "sub_daily": "Quatre blocs chaque matin. L'écran et l'e-mail automatique affichent la même chose.",
      "newLead": "Nouveau prospect",
      "newLeadSub": "Les prospects relèvent du pôle Business. Un prospect peut indiquer le ticket auquel il appartient, ou être ouvert avant qu'il n'en existe un.",
      "needCounterparty": "Le prospect doit avoir une contrepartie.",
      "counterpartyPh": "Avec qui nous parlons",
      "sectorPh": "Distribution, Retail, En ligne…",
      "leadTicketPh": "Choisissez le ticket auquel ce prospect appartient, s'il y en a un",
      "countryPh": "Thaïlande, Vietnam…",
      "criteriaPh": "Par rapport aux conditions du CEO…",
      "noLeads": "Aucun prospect pour le moment.",
      "noReply": "sans réponse {{n}} j",
      "colLead": "Prospect",
      "colCounterparty": "Contrepartie",
      "colCountry": "Pays",
      "colSector": "Secteur",
      "colStage": "Étape",
      "colCriteria": "Critères",
      "colNext": "Prochain contact",
      "leadsNote": "Les prospects relèvent uniquement du pôle Business. Le CEO fixe les marchés et les conditions ; le pôle prend contact, obtient une réponse et la vérifie par rapport aux critères.",
      "stageRule_Contacted": "premier e-mail envoyé",
      "stageRule_Replied": "la contrepartie a répondu",
      "stageRule_Checking_criteria": "par rapport aux conditions du CEO",
      "stageRule_With_CEO": "validé, en attente de décision",
      "stageRule_Closed": "gagné ou sous les critères",
      "dOpened": "Ouverts depuis hier",
      "dMoved": "Déplacés",
      "dOverdue": "Échéance dépassée",
      "dWaiting": "En attente du CEO",
      "nItems": "{{n}} élément(s)",
      "reachFirst": "à contacter en premier",
      "nothingHere": "Rien.",
      "dailyNote": "Envoyé à 08:30 KL chaque jour ouvré. Chaque pôle reçoit son propre e-mail couvrant ses propres tickets ; le CEO reçoit les deux. L'écran et l'e-mail affichent la même chose."
    },
    "pricing": {
      "title": "Calculateur de prix Collab",
      "subtitle": "Coût, T1, MSRP et redevance sur un seul écran — chiffrage en USD",
      "modeGeneral": "Collab générale · OEM / ODM",
      "modeGeneralSub": "Sans redevance · Base de majoration → T1 → MSRP",
      "modeLicensed": "Collab sous licence (redevance)",
      "modeLicensedSub": "MSRP global → prix local → redevance",
      "padClose": "Fermer",
      "padNeedInstruction": "Rédigez les conditions dans la zone Consigne ci-dessous, puis cliquez de nouveau ici.",
      "padOptionN": "Option {{n}}",
      "padInlineRrp": "Prix de vente Inline",
      "padPremium": "Prime Collab",
      "padTargetMsrp": "MSRP cible",
      "padOwnRetailRef": "Inline, à titre de référence",
      "padPartnerNa": "n/d — l'Inline n'est pas vendu aux partenaires",
      "padGapOwn": "Vente directe : la collab conserve {{c}} % contre {{i}} % pour l'Inline",
      "padGapPartnerBelow": "Vente en gros partenaire : sous le coût de {{amt}} une fois le supplément inclus",
      "padGapPartnerOk": "Vente en gros partenaire : {{pct}} % après le supplément",
      "padToB7": "→ Bloc 7 : qui paie ces {{amt}} par unité côté partenaire ?",
      "padSkuN": "SKU {{n}}",
      "padB7NoteMany": "Une seule décision pour tout le devis : {{n}} SKU, {{e}} de supplément sur l'ensemble de la commande. Entre A, B et C, le MSRP et les prix unitaires partenaire restent identiques — seul change celui qui supporte ce supplément.",
      "padFrameModel": "Modèle de cadre",
      "padB1": "1 · La commande",
      "padKindOrder": "base sur laquelle ces chiffres ont été établis",
      "padLeadDays": "{{d}} jours → délai court {{r}}",
      "padWhyShow": "pourquoi ils diffèrent ({{n}})",
      "padWhyHide": "masquer",
      "padNoReason": "aucun motif indiqué",
      "padMoqNote": "La majoration MOQ représente à elle seule {{amt}} — {{pct}} % du supplément pour cette quantité.",
      "padB2": "2 · Coût usine",
      "padB3": "3 · Coût du cadre",
      "padB4": "4 · Coût supplémentaire",
      "padB5": "5 · Coût total",
      "padB6": "6 · Prix et marge",
      "padB7": "7 · Qui supporte le supplément — {{amt}} sur l'ensemble de la commande de {{n}} EA",
      "padB7Kind": "décision · un clic · bénéfice net après O.H",
      "padB7KindCalc": "lecture seule · les cartes sur lesquelles l'approbateur décide",
      "method": "Méthode de tarification",
      "methodCbd": "CBD coût majoré (HEVN Costing)",
      "methodGuideline": "Guide de chiffrage (O.H 15 % + ratio par niveau)",
      "methodCbdHint": "Prix usine issu du CBD, frais généraux HPAC et majoration T2 définis dans les Paramètres, prix arrondis au dollar supérieur.",
      "methodGuidelineHint": "Base de majoration, O.H fixe de 15 % et ratios T1 / T2 saisis sur ce devis.",
      "cbdSub": "Comme la feuille Calculation : frais généraux HPAC {{oh}} % de Base + Cadre, T2 = (Base + Cadre + O.H) × {{x}}. Les majorations sont répercutées au coût ; cochez-en une si HPAC l'absorbe.",
      "cbdBase": "Prix de base",
      "cbdBaseSub": "Skin + CMT + O.H et profit fournisseur, plus manutention et transport local",
      "cbdFrame": "Cadre",
      "cbdBaseFrame": "Base + Cadre",
      "cbdOh": "Frais généraux HPAC ({{pct}} %)",
      "cbdOhSub": "arrondi au dollar",
      "cbdMoq": "Majoration MOQ de production",
      "cbdSl": "Majoration délai court",
      "cbdAbsorb": "HPAC absorbe",
      "cbdAbsorbed": "(absorbé par HPAC)",
      "cbdT1": "T1 · HPAC → entité Helinox",
      "cbdT1Sub": "Base + Cadre + O.H + majorations, arrondi au supérieur",
      "cbdT2": "T2 · HPAC → partenaire",
      "cbdT2Unit": "Prix partenaire T2 / unité",
      "cbdT2Sub": "(Base + Cadre + O.H) × {{x}} + majorations, arrondi au supérieur",
      "cbdFactory": "Coût fournisseur",
      "cbdFactorySub": "Base + Cadre + les deux majorations — ce que facture l'usine",
      "cbdGp": "Marge brute vs coût fournisseur",
      "cbdMargin": "Marge % (sur T2)",
      "cbdExtraSub": "Avec la méthode CBD, les frais de manutention, le transport, les matières supplémentaires et le CMT FF sont inclus dans le prix de base ; seules les majorations MOQ et délai court s'y ajoutent.",
      "cbdMsrpNote": "Le MSRP cible {{msrp}} vaut {{x}} × T2.",
      "cbdSetMarkup": "Majoration T2",
      "cbdOrderValue": "Valeur de la commande en T2",
      "cbdOrderValueRule": "T2 × quantité, additionné sur tous les SKU",
      "cbdFactoryAmt": "Coût fournisseur total",
      "cbdFactoryAmtRule": "Coût fournisseur × quantité — le fournisseur facture les deux majorations quel que soit celui qui les supporte",
      "cbdAbsorbedAmt": "Majorations absorbées par HPAC",
      "cbdAbsorbedRule": "Les majorations exclues du T2 sur cette carte, sur l'ensemble de la commande",
      "cbdGpRule": "Valeur de la commande en T2 − coût fournisseur total",
      "cbdMarginRule": "Marge brute ÷ valeur de la commande en T2",
      "cbdCard_A": "Le partenaire paie les deux majorations",
      "cbdCard_B": "HPAC absorbe les deux majorations",
      "cbdCard_HM": "HPAC absorbe la majoration MOQ",
      "cbdCard_HL": "HPAC absorbe la majoration délai court",
      "cbdCardWho_A": "Les majorations MOQ et délai court sont ajoutées à T1 et T2.",
      "cbdCardWho_B": "Les deux majorations sont exclues de T1 et T2 ; HPAC les règle à l'usine.",
      "cbdCardWho_HM": "La majoration MOQ est exclue de T1 et T2 ; la majoration délai court est facturée.",
      "cbdCardWho_HL": "La majoration délai court est exclue de T1 et T2 ; la majoration MOQ est facturée.",
      "padPerUnitHead": "Par unité",
      "cbdOfferBox": "L'offre — devis complet",
      "padLiveDraft": "Pas encore soumis — voici le devis tel qu'il est actuellement dans le calculateur, et non une copie figée.",
      "cbdSlYesHint": "Délai court = Oui : {{pct}} % du CMT fournisseur (main-d'œuvre), comme le facture l'Offer Sheet.",
      "cbdSlNoHint": "Délai court = Non : pas de majoration.",
      "cbdPartner": "Partenaire",
      "cbdSeason": "Saison",
      "cbdTerm": "Conditions de prix",
      "cbdValidFrom": "Valable du",
      "cbdValidTo": "Valable jusqu'au",
      "cbdColor": "Couleur",
      "cbdSlFlag": "Délai court",
      "cbdSlAuto": "Automatique selon le délai ({{rate}})",
      "cbdSlYes": "Oui — 50 % du CMT",
      "cbdSlNo": "Non",
      "cbdKeyPoints": "Points clés pour la décision",
      "cbdKpMargin": "Marge pondérée (sur T2) {{pct}} % sur le total des ventes T2 {{rev}} (marge brute vs coût fournisseur {{gp}}).",
      "cbdKpLowest": "Marge la plus faible : {{name}} à {{pct}} %.",
      "cbdKpT0": "Coût fournisseur = Base + Cadre + majoration MOQ + majoration délai court.",
      "cbdStripTitle": "Prix, bénéfice et marge",
      "cbdStripWhole": "Le devis complet",
      "cbdStripAsCard": "Le devis complet, chiffré selon : {{card}}",
      "cbdStripTry": "Tester une marge",
      "cbdStripTryHint": "Prix de vente = coût fournisseur ÷ (1 − marge), arrondi au dollar supérieur. Tester une marge ne modifie pas le devis.",
      "cbdStripClear": "Effacer",
      "cbdStripNow": "Tel que devisé",
      "cbdStripAt": "À {{pct}} % de marge",
      "cbdStripPrice": "Prix de vente (T2)",
      "cbdStripProfit": "Bénéfice / unité",
      "cbdStripMargin": "Marge",
      "cbdStripInline": "Prix de vente Inline",
      "cbdStripTotal": "Commande",
      "cbdStripQty": "Qté (EA)",
      "paS1": "1. Options de prix vs Inline — USD/pc",
      "paS1Kind": "Options 1–2 préparées par Sales/Costing · dernière option : YL saisit la marge brute %",
      "paOption": "Option",
      "paOptionN": "Option {{n}}",
      "paItem": "Nom de l'article / Couleur",
      "paStyle": "Code style",
      "paQty": "Qté (pcs)",
      "paCost": "Coût d'achat",
      "paOh": "Frais généraux HPAC",
      "paT1": "Prix T1 (HPAC → autre entité Helinox)",
      "paInlineT1": "Prix T1 Inline",
      "paT1vs": "T1 vs T1 Inline",
      "paInlineMsrp": "MSRP Inline",
      "paPartnerMsrp": "MSRP partenaire (réf.)",
      "paGmIn": "Marge brute % (saisie YL)",
      "paT2": "Prix T2",
      "paGp": "Marge brute /pc",
      "paGm": "Marge brute % (sur T2)",
      "paNet": "Marge nette % (après frais généraux HPAC)",
      "paNetTot": "Marge nette % (total)",
      "paSales": "Ventes totales (USD)",
      "paGpTot": "Marge brute totale (USD)",
      "paOfMsrp": "T2 en % du MSRP partenaire (réf.)",
      "paCheck": "Contrôle T2 ≥ T1",
      "paApprove": "Approuver (YL ✔)",
      "paBelow": "Sous T1",
      "paOptTotal": "Total de l'option",
      "paOpt1": "Le partenaire paie les majorations",
      "paOpt1Sub": "formule standard, majorations répercutées",
      "paOpt2": "HPAC absorbe les majorations",
      "paOpt2Sub": "formule standard",
      "paOptGm": "Décision de YL",
      "paOptGmSub": "Marge brute % sur T2 — à saisir ici",
      "paOptOSub": "chiffrage préparé par Sales/Costing, tarifé avec le partenaire qui paie les majorations",
      "paTick": "Approuver cette option",
      "paApproved": "Option approuvée",
      "paApproveOne": "choisissez UNE option",
      "paGmAll": "une marge pour tous les articles",
      "paGmEach": "une marge par article",
      "paGmToAll": "identique pour tous",
      "paYlOnly": "YL choisit une option ici, dans Pricing Approval",
      "paSwitch": "Choisir celle-ci à la place",
      "paNote1": "Coût d'achat = prix payé par Helinox à l'usine, majorations MOQ + délai court incluses. T1 vs T1 Inline = écart en % par rapport au style Inline équivalent.",
      "paNote2": "Marge brute % = (T2 − Coût d'achat) ÷ T2 (marge sur le prix de vente, et non majoration). Marge nette % = (T2 − Coût d'achat − Frais généraux HPAC) ÷ T2. YL saisit la marge brute % pour l'Option {{n}} ; tous les résultats se mettent à jour immédiatement.",
      "paNote3": "MSRP {{partner}} (réf.) = MSRP Inline × {{pct}} %, à titre indicatif uniquement. « Sous T1 » = T2 inférieur au T1 de la collab. Cochez ✔ dans la colonne Approuver pour UNE seule option.",
      "paNoInlineT1": "Aucun prix T1 Inline sur ce devis pour le moment — Sales/Costing le renseignent dans le calculateur (Prix T1 Inline) afin de pouvoir lire T1 par rapport au style Inline.",
      "paGrpShow": "Afficher les colonnes Inline (T1 Inline, T1 vs Inline, MSRP Inline, MSRP partenaire)",
      "paGrpHide": "Replier les colonnes Inline",
      "paPartnerWord": "Partenaire",
      "paHProject": "Projet",
      "paHPartner": "Partenaire (client T2)",
      "paHSeason": "Saison",
      "paHFactory": "Usine",
      "paHPrepared": "Préparé par",
      "paHReviewed": "Revu par",
      "paHPriceTerm": "Conditions de prix",
      "paHCurrency": "Devise",
      "paHLead": "Délai total (jours)",
      "paHApprover": "Approbateur",
      "paApprovedBy": "Approuvé par",
      "paApprovalDate": "Date d'approbation",
      "paYlComments": "Commentaires de YL",
      "paYlCommentsPh": "Facultatif — enregistré avec l'option cochée",
      "paS2": "2. Sensibilité de la marge — T2 et bénéfice selon la marge brute %",
      "paS2Kind": "T2 = Coût d'achat ÷ (1 − marge), arrondi au supérieur",
      "paS3": "3. Approbation",
      "paApprovedOpt": "Option approuvée",
      "paApprovedT2": "T2 approuvé — {{name}} (USD/pc)",
      "paNoneYet": "Pas encore approuvé — cochez UNE option ci-dessus",
      "paExport": "Exporter Price Approval (Excel)",
      "paExportHint": "Ce devis sur le modèle Price Approval de Linda, avec ses formules — YL peut encore saisir une marge dans le fichier.",
      "inlineT1": "Prix T1 Inline",
      "inlineT1Hint": "T1 du style Inline équivalent — la feuille d'approbation lit le T1 de la collab par rapport à celui-ci",
      "styleCode": "Code style",
      "cbdFactoryName": "Usine",
      "cbdStripVsInline": "% du prix de vente Inline",
      "cbdKpInline": "Le prix de vente (T2) représente {{pct}} % du prix de vente Inline.",
      "cbdKpInlineSome": "({{n}} SKU sans prix de vente Inline.)",
      "cbdStripUse": "Reporter ces prix dans ma consigne",
      "cbdStripUseHint": "Ils sont insérés dans la zone Consigne ci-dessous ; approuvez-les avec la carte des conditions.",
      "cbdStripInstr": "Prix à {{pct}} % de marge sur T2 (coût fournisseur ÷ (1 − marge), arrondi au supérieur) : {{list}}. Commande {{rev}}, bénéfice {{gp}}.",
      "cbdKpLead": "Délai {{days}} jours (PO {{po}} → sortie d'usine {{xf}}).",
      "cbdKpAbsorbs": "HPAC absorbe : {{what}}.",
      "cbdKpAbsorbsNone": "HPAC absorbe : rien — toutes les majorations sont facturées au partenaire.",
      "cbdOffer": "Offre partenaire (Excel)",
      "cbdOfferTitle": "L'offre au partenaire : article, couleur, quantité et prix T2 uniquement — aucune donnée de coût",
      "cbdOfferNeedSave": "Enregistrez d'abord le devis",
      "cbdOfferNeedApproval": "Disponible une fois le devis approuvé",
      "cbdOfferNeedCard": "Disponible une fois une carte choisie",
      "cbdOfferTerms": "D'autres conditions ont été choisies — rédigez l'offre à partir de la consigne",
      "cbdB7": "Qui supporte les majorations — {{amt}} sur l'ensemble de la commande de {{n}} EA",
      "cbdB7Note": "L'usine facture les majorations MOQ et délai court quel que soit celui qui les supporte. A à D sont les quatre réponses de la feuille Calculation ; une option ci-dessus est une carte de plus, chiffrée avec le partenaire qui paie les deux.",
      "padOrderHead": "Commande ({{qty}} EA)",
      "rule_cbd_oh_pct": "CBD · Frais généraux HPAC %",
      "rule_cbd_t2_markup_pct": "CBD · Majoration T2 % (30 = × 1.3)",
      "padB7NoteCalc": "A, B et C figurent sur chaque devis. Ajoutez une option ci-dessus pour toute autre répartition du supplément — elle devient une carte de plus ici et sur l'écran de l'approbateur.",
      "padB7Note": "S'applique uniquement au canal de vente en gros partenaire. Entre A, B et C, le MSRP {{m}} et le prix unitaire partenaire {{p}} restent identiques — seuls les {{e}} de supplément par unité changent de main.",
      "padKindCompare": "comparaison",
      "padKindSolo": "collab uniquement · sans comparaison",
      "padThisQuote": "ce devis",
      "padCompareOnly": "comparaison uniquement",
      "padInlineShort": "Inline",
      "padSameWord": "identique",
      "padNoBench": "pas de benchmark",
      "padNoneWord": "aucun",
      "padFactory": "Coût usine",
      "padFrame": "Coût du cadre",
      "padFactoryN": "Coût usine (2)",
      "padFrameN": "Coût du cadre (3)",
      "padExtraN": "Coût supplémentaire (4)",
      "padExtraPerUnit": "Coût supplémentaire par unité",
      "padBaseFrom": "= usine {{f}} + cadre {{r}}",
      "padBaseSub": "usine + cadre",
      "padPctOfTotal": "{{n}} % du total",
      "padMultBase": "Base seule : la collab vaut {{x}}× l'Inline",
      "padMultAll": "Avec supplément : {{x}}× l'Inline",
      "padLead": "La base est proche. Le problème, c'est le supplément.",
      "padOwnRetailSub": "HINC et autres vendent au MSRP",
      "padPartnerWs": "Vente en gros partenaire",
      "padPartnerWsSub": "fourni à {{p}} % du MSRP",
      "padCallout": "La vente directe supporte le supplément et conserve encore {{pct}} %. La vente en gros partenaire ne le peut pas — elle passe sous le coût. Le bloc 7 décide qui paie le supplément côté partenaire.",
      "padMsrp": "MSRP",
      "padPartnerUnit": "Prix unitaire partenaire",
      "padExtraBilledUnit": "+ supplément facturé",
      "padPerUnit": "/unité",
      "padExtraAbsorbed": "Supplément absorbé par Helinox",
      "padGrossSub": "= O.H + bénéfice net",
      "padWhoA": "Supplément facturé sur une ligne distincte au coût net. Sans marge dessus.",
      "padWhoB": "Supplément comptabilisé en coût marketing HPAC. Le partenaire ne voit que le prix unitaire.",
      "padWhoC": "Moitié facturée au partenaire, moitié absorbée par Helinox.",
      "padCeoDecision": "Décision du CEO",
      "padCeoDecisionSub": "Enregistrée avec l'approbation. Le demandeur finalise le devis selon ces conditions — aucune nouvelle soumission n'est nécessaire.",
      "padDrowFinal": "Conditions finales",
      "padDrowRecorded": "Enregistré",
      "padOpenCalc": "Ouvrir dans le calculateur",
      "approverView": "Ce que verra l'approbateur",
      "approverViewSub": "Les deux mêmes blocs que ceux de l'écran Pricing Approval, à partir des mêmes chiffres. Lecture seule — les chiffres sont saisis ci-dessus.",
      "padSubmittedBy": "soumis par",
      "padNoSnapshot": "Ce devis a été soumis avant que les chiffres ne soient figés ; il n'y a donc rien d'enregistré à afficher. Ouvrez-le dans le calculateur pour le voir dans son état actuel.",
      "padFrozen": "Les chiffres ci-dessous sont ceux soumis pour approbation.",
      "padEdited": "Le devis a été modifié depuis son envoi.",
      "padLine": "Ligne",
      "padCollab": "Collab",
      "padInline": "Inline",
      "padGap": "Écart",
      "padBase": "Coût de base",
      "padExtra": "Coût supplémentaire",
      "padExtraNote": "n'existe pas en production Inline",
      "padTotal": "Coût total par unité",
      "padOrder": "Total de la commande · {{qty}} EA",
      "padPriceMargin": "Prix et marge",
      "padOwnRetail": "Vente directe",
      "padPartner": "Vente en gros partenaire · {{pct}} % du MSRP",
      "padWeSell": "Nous vendons à",
      "padMarginPre": "Marge avant supplément",
      "padMarginPost": "Marge après supplément",
      "padWhoCarries": "Qui supporte le supplément — {{total}} sur {{qty}} EA",
      "padWhoSub": "Canal de vente en gros partenaire uniquement. Le MSRP {{msrp}} et le prix unitaire partenaire {{unit}} restent identiques dans toutes les options — seul le supplément change.",
      "padOptA": "A · Le partenaire paie le supplément",
      "padOptB": "B · Helinox l'absorbe",
      "padOptC": "C · Réparti 50 / 50",
      "fxBilledRule": "le supplément × la part supportée par le partenaire",
      "fxRevenueRule": "la quantité de chaque SKU × son MSRP, additionné sur la commande",
      "fxAbsorbedRule": "le supplément − ce qui est facturé au partenaire",
      "fxGrossRule": "chiffre d'affaires partenaire + supplément facturé − coût total",
      "fxOhRule": "coût de base de la commande × le taux d'O.H",
      "fxNetRule": "marge brute − O.H Helinox",
      "fxMarginRule": "bénéfice net ÷ chiffre d'affaires partenaire",
      "padGate": "Approuver ce devis ?",
      "padGateSub": "Il est au statut {{status}}. Vous déciderez SKU par SKU à l'étape suivante, et une note l'accompagne.",
      "padGateApprove": "Approuver",
      "padGateReject": "Renvoyer",
      "padGateCancel": "Laisser tel quel",
      "padOtherCostings": "Ce devis comporte aussi {{n}} autre(s) chiffrage(s)",
      "padOtherCostingsSub": "Le même devis chiffré autrement, construit dans le calculateur. Chacun est tarifé selon A afin de pouvoir être lu face à la carte A — en choisir un revient à retenir ce chiffrage avec le supplément supporté par le partenaire.",
      "padRefAt": "Tarifé selon A · le partenaire paie le supplément",
      "padSettings": "Paramètres avec lesquels ces chiffres ont été calculés",
      "padSetPremium": "Prime Collab",
      "padSetPartner": "Marge partenaire",
      "padSetSplitC": "Ratio de répartition (carte C)",
      "padSetOh": "Helinox O.H",
      "padSetOhVal": "{{pct}} % du coût de base",
      "padSetCase": "Cas",
      "padOptTerms": "Autres conditions",
      "padOptTermsSub": "Aucune des cartes ci-dessus ne convient ? Rédigez les conditions dans la zone Consigne ci-dessous. Le demandeur finalise le devis à partir de ce texte.",
      "padSrcPortal": "Valeur par défaut du portail",
      "padSrcQuote": "Ajouté par le demandeur",
      "padSrcApprover": "Vous rédigez les conditions",
      "padSumHead": "Vous approuvez {{n}} des {{all}} SKU de ce devis",
      "padSumCard": "Qui supporte le supplément",
      "padSumQty": "Quantité approuvée",
      "padSumNoCard": "Aucune carte n'a encore été choisie ; cette approbation règle donc les SKU et laisse le supplément non réparti.",
      "padSumNothing": "Tous les SKU sont barrés. Utilisez plutôt Renvoyer pour l'ensemble du devis.",
      "padSumUnread": "{{n}} d'entre eux ne sont pas encore ouverts.",
      "padSkuUnseen": "pas encore ouvert",
      "padSkuCut": "refusé",
      "padSkuSeen": "Vous avez ouvert {{n}} des {{all}} SKU de ce devis",
      "padSkuAllSeen": "Vous avez ouvert les {{n}} SKU",
      "padSkuCutN": "{{n}} refusé(s) précédemment",
      "padCardScope": "Ces chiffres couvrent les {{n}} SKU encore retenus, et non les {{all}} du devis.",
      "padCardGone": "— cette option ne figure plus sur le devis",
      "padBilled": "Supplément facturé",
      "padRevenue": "Chiffre d'affaires (QTÉ × MSRP)",
      "padAllIn": "Le partenaire paie tout compris",
      "padGross": "Marge brute sur la commande",
      "padOh": "O.H Helinox · {{pct}} % du coût de base",
      "padNetProfit": "Bénéfice net Helinox sur la commande",
      "padNetMargin": "Marge nette · % du prix partenaire",
      "padSelect": "Sélectionner {{key}}",
      "padDecision": "Décision enregistrée",
      "padChosen": "Qui supporte le supplément",
      "padUndecided": "Pas encore décidé",
      "padInstruction": "Consigne",
      "padInstructionPh": "ex. Retenir A, mais arrondir le prix unitaire partenaire à $60 et facturer le supplément en une somme forfaitaire.",
      "padSaveInstruction": "Enregistrer la consigne",
      "padDecisionSaved": "La décision est enregistrée.",
      "padMemo": "Mémo final Sales OP",
      "padMemoSub": "Le prix et les conditions finalement convenus, après lecture de la décision ci-dessus. Il peut être rédigé une seule fois et ne peut plus être modifié ensuite.",
      "padMemoPh": "Prix et conditions finaux tels que convenus…",
      "padMemoWaitShort": "Pas encore enregistré",
      "padMemoWait": "Rien n'a encore été décidé sur ce devis.",
      "padMemoSave": "Enregistrer le mémo",
      "padMemoSaved": "Le mémo est enregistré.",
      "modeRules": "Règles de tarification",
      "modeRulesSub": "Admin · les constantes sur lesquelles tous les devis sont chiffrés",
      "rulesTitle": "Règles de tarification",
      "rulesSub": "Une modification s'applique aux devis créés APRÈS son enregistrement. Les devis déjà émis conservent la règle sous laquelle ils ont été chiffrés ; rien de ce qui a déjà été devisé ne bouge.",
      "ruleName": "Règle",
      "ruleNow": "En vigueur",
      "ruleNew": "Nouvelle valeur",
      "ruleWhy": "Motif",
      "ruleWhyPh": "Pourquoi ce changement ?",
      "ruleSave": "Enregistrer",
      "ruleSaved": "Enregistré. Les devis créés à partir de maintenant utilisent la nouvelle règle.",
      "ruleHistory": "Toutes les modifications, les plus récentes en premier",
      "ruleValue": "Valeur",
      "ruleBy": "Modifié par",
      "ruleFrom": "En vigueur depuis",
      "rule_partner_ratio_pct": "Prix partenaire",
      "ruleHint_partner_ratio_pct": "Le prix partenaire en pourcentage du MSRP.",
      "rule_tier_oh_pct": "Helinox O.H",
      "ruleHint_tier_oh_pct": "La part de frais généraux d'un ratio par niveau. Sert de valeur initiale à un nouveau devis ; un devis enregistré conserve la sienne.",
      "rule_frame_profit_pct": "Profit sur cadre",
      "ruleHint_frame_profit_pct": "Coût du cadre × ce taux, sauf si le cadre est fourni gratuitement.",
      "modeSaved": "Projets enregistrés",
      "modeSavedSub": "Parcourir · charger · exporter vers Excel",
      "modeOpa": "OPA / SCT",
      "modeOpaSub": "Analyse des opérations · temps de cycle standard",
      "projectPlaceholder": "Nom du projet — ex. 26FW MICRO KICKBOARD x Chair One (re)",
      "template": "Importer le modèle",
      "importExcel": "Importer Excel",
      "importBom": "Importer la BOM du fournisseur",
      "bomRead": "Lu comme une BOM {{vendor}} — {{n}} SKU à partir de : {{names}}",
      "bomFailed": "Cette BOM n'a pas pu être lue",
      "bomLookedFor": "Le portail connaît deux formats de fournisseur et a cherché :",
      "bomSheets": "Feuilles de ce fichier : {{list}}",
      "dismiss": "fermer",
      "imported": "{{n}} SKU chargé(s) depuis le fichier — vérifiez les chiffres, puis Enregistrer le projet.",
      "save": "Enregistrer le projet",
      "saveChanges": "Enregistrer les modifications",
      "newProject": "Nouveau projet",
      "exportExcel": "Exporter Excel",
      "savedAs": "Enregistré sous {{id}} — l'écran est prêt pour le suivant.",
      "loaded": "{{id}} chargé — Enregistrer le mettra à jour, puis videra l'écran.",
      "needName": "Donnez d'abord un nom au projet.",
      "needSave": "Enregistrez d'abord le projet — l'export lit ce qui a été enregistré.",
      "deleteAsk": "Supprimer {{id}} ? Il quitte la liste ; le chiffrage lui-même est conservé.",
      "sku": "SKU",
      "addSku": "Ajouter un SKU",
      "duplicate": "Dupliquer",
      "del": "Supprimer",
      "inputs": "Saisies",
      "collapse": "Réduire",
      "expand": "Développer",
      "results": "Résultats",
      "skuName": "SKU / nom de l'article",
      "skuNameHint": "Un nom pour cet article au sein du projet.",
      "qty": "Quantité commandée (EA)",
      "qtyHint": "Détermine la majoration MOQ et le débit HPAC.",
      "poDate": "Date d'émission du PO",
      "poDateHint": "Début du délai.",
      "xfDate": "Date XF demandée",
      "xfDateHint": "XF − PO = délai.",
      "moqLabel": "MOQ",
      "moqNone": "500 pcs ou plus → pas de majoration",
      "moqApplied": "{{qty}} pcs → {{rate}} de {{of}}",
      "moqQtyPcs": "{{qty}} pcs →",
      "moqOfBase": "de {{of}}",
      "leadLabel": "Délai",
      "leadNone": "saisissez les deux dates pour calculer",
      "leadDays": "{{days}} jours → délai court {{rate}}",
      "leadWarn": "{{days}} jours, c'est moins de 60 — le guide ne le chiffre pas. 50 % sont appliqués à titre provisoire et la majoration doit être négociée.",
      "baseTitle": "Coût de base de la majoration",
      "baseSub": "La marge est construite sur ces éléments, les frais FM, et rien d'autre.",
      "skin": "Skin + Case + Emballage",
      "skinHint": "Skin en tissu, case et packaging réunis.",
      "cmt": "CMT fournisseur",
      "cmtHint": "Main-d'œuvre de couture du fournisseur (Cut · Make · Trim).",
      "ohp": "OH et profit fournisseur",
      "ohpHint": "Les frais généraux et la marge du fournisseur.",
      "frame": "Coût du cadre",
      "frameHint": "Choisissez un modèle pour le remplir depuis la liste de prix des cadres.",
      "framePick": "Choisir un modèle de cadre…",
      "frameSupply": "Approvisionnement du cadre",
      "supplySell": "Vendu au fournisseur",
      "supplySellHint": "Profit sur cadre + manutention $0.50 + fret (p.19)",
      "supplyFoc": "Fourni gratuitement (FOC)",
      "supplyFocHint": "Frais FM de $0.04 uniquement (p.13, p.20)",
      "matSupply": "Approvisionnement des matières",
      "matVendor": "Le fournisseur l'achète",
      "matVendorHint": "Le tissu, le case et le packaging sont des achats propres au fournisseur.",
      "matFf": "Helinox le fournit (FF)",
      "matFfHint": "La matière ne coûte rien au fournisseur ; il facture donc des frais de CMT FF à la place.",
      "frameProfitRate": "Taux de profit sur cadre",
      "excludedTitle": "Éléments exclus",
      "excludedSub": "Coûts qui n'existent pas en production Inline. Ils figurent dans la base de marge T1 et sont aussi récupérés auprès du partenaire sous forme de débit marketing HPAC ; T2 est chiffré sans eux. Saisir une valeur dans un champ remplace la règle pour ce champ uniquement.",
      "autoToggle": "Automatique selon le guide",
      "autoTag": "auto",
      "resetOverride": "manuel — réinitialiser",
      "fprofit": "Profit sur cadre",
      "fprofitHint": "Coût du cadre × taux de profit. Nul lorsque le cadre est fourni gratuitement.",
      "handling": "Manutention",
      "handlingHint": "$0.50 lorsque Helinox vend le cadre au fournisseur (p.19).",
      "fmfee": "Frais FM",
      "fmfeeHint": "$0.04 lorsque le cadre est fourni gratuitement (p.13, p.20). Fait partie du coût de base.",
      "transport": "Transport",
      "transportHint": "Fret réel — jamais estimé.",
      "moqCharge": "Majoration MOQ",
      "moqChargeHint": "Base de majoration x taux MOQ (p.15).",
      "addMat": "Matière supplémentaire",
      "addMatHint": "Tout ce dont la commande a besoin et que la base ne couvre pas.",
      "ffcmt": "Frais CMT FF",
      "ffcmtHint": "La main-d'œuvre du fournisseur sur la matière fournie par Helinox. Ajouté après la majoration.",
      "ffcmtOff": "Uniquement lorsque Helinox fournit la matière — voir Approvisionnement des matières.",
      "shortLead": "Majoration délai court",
      "shortLeadHint": "CMT fournisseur x (1 + taux MOQ) x taux délai court (p.21).",
      "moqBaseLabel": "La majoration MOQ s'applique sur",
      "moqBaseHint": "Décochez ce que ce fournisseur ajoute après la majoration au lieu de l'inclure dedans.",
      "part_skin": "Skin + Case + Emballage",
      "part_cmt": "CMT fournisseur",
      "part_ohp": "OH et profit",
      "part_frame": "Cadre",
      "part_fmfee": "Frais FM",
      "pricingTitle": "Tarification",
      "stepProfit": "Simulateur de profit / MSRP",
      "stepTarget": "MSRP cible",
      "t1Ratio": "Profit HPAC externe (ratio T2)",
      "t1RatioHint": "Marge SUR T2, et non une majoration sur la base. Obligatoire pour le cas A.",
      "t0Ratio": "Profit HPAC interne (ratio T1)",
      "t0RatioHint": "Le niveau de l'entité Helinox. Obligatoire pour le cas B.",
      "options": "Options",
      "optionsNote": "Chaque option est ce devis avec une ou deux réponses modifiées — elle suit tous les chiffres qui la précèdent.",
      "optionAdd": "Ajouter une option",
      "optionN": "Option {{n}}",
      "optAsQuoted": "Le devis",
      "optAsQuotedSub": "les chiffres saisis ci-dessus",
      "optNoCond": "rien de modifié pour le moment",
      "optSameAsQuote": "Identique au devis — modifiez une valeur à gauche et ces chiffres bougent.",
      "optEdit": "Conditions",
      "optCancel": "Annuler",
      "optDone": "Terminé",
      "optRemove": "Retirer",
      "optCondNote": "Modifiez ici n'importe quelle valeur. Tout ce qui reste inchangé suit le devis.",
      "optQuoteReadOnly": "Les réponses propres au devis, pour y comparer une option. Modifiez-les dans les blocs ci-dessus.",
      "optClose": "Fermer",
      "optOrderProfitT1": "Profit sur la commande en T1",
      "optOrderProfitT2": "Profit sur la commande en T2",
      "optQty": "Quantité commandée",
      "optBasis": "Marge calculée sur",
      "optT1Profit": "Profit T1",
      "optT2Ratio": "Ratio T2",
      "optCbdMargin": "Marge sur T2",
      "optT2Profit": "Profit T2",
      "optPremium": "Prime Collab",
      "optShortLead": "Majoration délai court",
      "benchTitle": "Benchmark Inline",
      "benchTag": "comparaison uniquement",
      "benchLine": "Ligne de coût",
      "benchThis": "Ce devis",
      "benchInline": "Produit Inline",
      "benchDiff": "Différence",
      "vsInline": "vs prix de vente Inline",
      "linesApplied": "Lignes de coût supplémentaire 1 facturées par cette option",
      "qtyWord": "quantité commandée",
      "targetHint": "Prix de vente Inline × (1 + prime collab)",
      "lineDropped": "non facturé",
      "inclTitle": "Dans le chiffre sur lequel la marge est calculée",
      "exclTitle": "En dehors — récupéré sous forme de débit marketing HPAC",
      "inclBoth": "aussi dans la base de marge, donc récupéré deux fois",
      "inclTotal": "marge calculée sur",
      "exclTotal": "débité au partenaire",
      "quotedIn": "marge sur",
      "quotedOut": "hors marge",
      "estIsCheck": "Un recoupement, et non le MSRP du devis — rien en aval ne le lit. Le MSRP que porte ce devis figure dans le bloc 6.",
      "msrpIsQuote": "le MSRP du devis",
      "factoryWord": "usine",
      "frameWord": "cadre",
      "marginAtQty": "Marge à {{n}} EA",
      "gapWord": "Écart",
      "collabCol": "Collab",
      "benchCol": "Inline",
      "benchTotal": "Coût usine",
      "benchWhy": "Pourquoi les deux diffèrent",
      "benchWhyHint": "Ce que la collaboration ajoute ou retire par rapport à la version Inline — la phrase que l'approbateur lit à côté de l'écart. Rien dans cette étape ne modifie le devis.",
      "ohPart": "O.H",
      "ohPartFixed": "O.H (fixe)",
      "frameModelLabel": "Modèle de cadre",
      "benchLinkedTo": "Lié à",
      "benchNoModel": "pas encore de modèle de cadre",
      "benchFollowsFrame": "suit le modèle de cadre choisi dans le bloc 3",
      "benchFromCollab": "depuis la Collab",
      "benchFrameHint": "Le cadre que porte le produit Inline, à son propre prix catalogue.",
      "benchModelHint": "Suit le bloc 3 — la même pièce, donc l'écart tient au prix et non à la conception.",
      "benchSame": "identique",
      "benchBase": "base",
      "blkExtra": "supplément",
      "fxBuying": "Ce que coûte une unité avant toute marge",
      "fxBuyingRule": "La base est usine + cadre — le chiffre sur lequel sont calculés les ratios par niveau. Le coût supplémentaire est ajouté APRÈS la marge et n'est jamais majoré. Les deux ensemble forment le coût d'achat.",
      "fxBenchBase": "Coût Inline (skin + CMT + OH et profit + cadre)",
      "fxBenchBaseRule": "Le coût usine propre du produit Inline plus le cadre qu'il porte, à son propre prix catalogue. Rien n'est ajouté ensuite — le côté Inline n'a aucun coût supplémentaire défini.",
      "benchFrameLabel": "Coût du cadre",
      "benchImport": "Remplir depuis une fiche de coûts",
      "benchImportHint": "Remplit cette colonne à partir d'une fiche de coûts déjà classée dans Fiches de coûts Inline.",
      "benchSrc": "Source",
      "benchPickTitle": "Par rapport à quelle ligne ce devis est-il mesuré ?",
      "benchPickBody": "{{file}} chiffre {{n}} ligne(s). Choisissez celle par rapport à laquelle ce devis est mesuré — le chiffre de chaque ligne est le coût d'achat indiqué par la fiche elle-même.",
      "benchVariant": "Version du coût",
      "benchApply": "Remplir le benchmark",
      "benchRefused": "{{n}} ligne(s) n'ont pas pu être lues, car les colonnes ne correspondent pas au coût d'achat imprimé à côté :",
      "benchLibBody": "Recherchez dans les fiches de coûts classées dans Fiches de coûts Inline par style, SKU, coloris ou fichier.",
      "benchSearch": "Rechercher un style, un SKU, un coloris, un fichier…",
      "benchNewFile": "Lire un nouveau fichier…",
      "benchBackToLib": "Retour à la bibliothèque",
      "benchLibEmpty": "Aucune fiche de coûts n'a encore été classée. Elles sont lues dans Sales Operation → Fiches de coûts Inline.",
      "benchNoHit": "Aucun résultat dans la bibliothèque pour « {{q}} ».",
      "benchLineCol": "Ligne",
      "benchWhyCol": "Explication",
      "benchWhyPh": "Pourquoi les deux diffèrent",
      "benchNoGap": "Pas d'écart — rien à expliquer",
      "benchAllLevel": "Toutes les lignes correspondent au produit Inline — rien à expliquer.",
      "benchNotFilled": "Remplissez le benchmark Inline pour voir où les deux diffèrent.",
      "benchElsePh": "Autre chose…",
      "benchBomSub": "Différence de BOM entre le prix collab et le prix Inline.",
      "stepExtra2": "Coût supplémentaire 2",
      "stepExtra2Sub": "(Comparaison des coûts)",
      "addMatWhat": "De quoi il s'agit…",
      "addLine": "Ajouter une ligne",
      "removeLine": "Retirer cette ligne",
      "ohLine": "O.H Helinox",
      "profitLine": "Profit Helinox",
      "extraLine": "Coût supplémentaire",
      "extraFromBlock": "du bloc 4",
      "inclExtra": "O.H + profit + coût supplémentaire — ce que paie le partenaire",
      "fxOpen": "Comment {{what}} est calculé",
      "fxFactory": "Coût usine",
      "fxFrame": "Coût du cadre",
      "fxExtra": "Coût supplémentaire 1",
      "t2Divide": "{{basis}} ÷ (1 − {{r}}%)",
      "t2ThisQuote": "ce devis",
      "t2Both": "Le même ratio selon chacune des deux conventions de chiffrage. Le devis retient celle qui est marquée — c'est dans une option que ce choix se fait.",
      "t2BasisFromOpt": "défini par option",
      "fxT2": "Comment T2 est tarifé",
      "fxT2Rule": "Une marge prélevée SUR le prix, et non ajoutée par-dessus : la base divisée par un moins le ratio T2. C'est la convention de tous les devis enregistrés — la construction utilisée pour T1 donne un chiffre différent.",
      "fxExtraAfter": "ajouté après la marge, jamais majoré",
      "fxT1Base": "Coût usine + Coût du cadre + Coût supplémentaire 1",
      "t1BaseLine": "Coût usine + Coût du cadre + Coût supplémentaire 1",
      "optExtraOff": "Lignes de coût supplémentaire 1 appliquées",
      "optExtraOffLbl": "non",
      "optExtraOffNone": "toutes",
      "optExtraOffSome": "{{n}} retirée(s)",
      "t1Sum": "base + O.H + profit",
      "fxT1On": "calculé sur {{n}}",
      "fxOh": "O.H Helinox",
      "fxProfit": "Profit Helinox",
      "fxTier": "Prix par niveau",
      "fxMsrp": "MSRP cible",
      "fxLead": "Délai",
      "fxBenchProfit": "Profit sur le produit Inline",
      "fxMoq": "Majoration MOQ",
      "fxSl": "Majoration délai court",
      "fxFprofit": "Profit sur cadre",
      "byOption": "Le même devis, option par option",
      "optPick": "Ce que cette option modifie :",
      "optName": "Nom de l'option",
      "optNamePh": "Option {{n}} — saisissez un nom que tout le monde reconnaîtra",
      "fxBenchRule": "Le coût propre du produit Inline, au taux de profit T1 de la collab — il n'existe pas de taux distinct pour le benchmark.",
      "optDropCond": "Retirer ceci de l'option",
      "tierSubAny": "O.H + profit + coût supplémentaire, aux taux propres de cette colonne",
      "tierSubOwn": "O.H + profit + coût supplémentaire",
      "fxTimesQty": "Par unité × la quantité commandée — la commande entière, et non une unité.",
      "fxDebitRule": "Chaque élément exclu, facturé au partenaire en plus du prix par niveau.",
      "fxDebitInPrice": "Rien n'est débité — avec cette convention, c'est déjà inclus dans le prix.",
      "profitSubOwn": "l'O.H et le profit que ce niveau rapporte, par unité",
      "ohShareAny": "dont O.H",
      "profitShareAny": "dont profit",
      "optSameShort": "identique au devis",
      "revenueSubAny": "le prix par niveau × la quantité commandée — la commande entière, et non une unité",
      "totalProfitSubAny": "profit par unité × la quantité commandée — chiffre d'affaires moins le coût de la commande",
      "fxExtraRule": "Chaque élément exclu, additionné.",
      "fxMoqRule": "La base MOQ multipliée par le taux correspondant à la quantité commandée.",
      "fxMoqBase": "Base MOQ",
      "fxSlRule": "CMT fournisseur multiplié par le taux de délai court correspondant au délai.",
      "extraInBase": "inclus dans la base",
      "unit": "unité",
      "totalWord": "Total",
      "estMsrp": "MSRP estimé : de",
      "estTo": "à",
      "estTimes": "fois →",
      "targetMsrp": "MSRP cible",
      "targetMsrpHint": "Prix de vente Inline × (1 + prime).",
      "msrpOverT1": "MSRP ÷ T1",
      "msrpOverT1Hint": "le multiple obtenu",
      "yTarget": "Cible de Y",
      "yTargetHint": "Une cible fixée par rapport au prix Inline. Facultatif.",
      "collabVsInline": "Collab vs Inline",
      "blockResult": "Résultat / Options",
      "blockDetail": "Comment les chiffres sont construits",
      "optConditions": "Conditions",
      "colCollab": "Collab",
      "colInline": "Benchmark Inline",
      "profitPart": "Profit",
      "ohShare": "dont O.H ({{pct}})",
      "profitShare": "dont profit ({{pct}})",
      "dealCase": "Cas",
      "dealCaseHint": "Le modèle de collaboration concerné — il détermine quel ratio par niveau est obligatoire.",
      "dealCasePick": "Sélectionner un cas…",
      "dealCaseBoth": "Les deux",
      "dealCaseA": "Cas A : Collaboration directe HPAC",
      "dealCaseB": "Cas B : Collaboration pilotée par une filiale",
      "dealCasePath_both": "Usine → HPAC → partenaire   ·   Usine → HPAC → filiale Helinox → son marché",
      "dealCasePath_a": "Usine → HPAC → partenaire de collaboration",
      "dealCasePath_b": "Usine → HPAC → filiale Helinox → son propre marché",
      "dealCasePathLbl": "Qui vend à qui",
      "dealCaseWhat_both": "Les deux circuits sont chiffrés : HPAC achète et revend, et une filiale Helinox vend aussi sur son propre marché. Les deux ratios par niveau sont obligatoires.",
      "dealCaseWhat_a": "HPAC achète les produits à l'usine et les vend directement au partenaire de collaboration. Aucune filiale Helinox ne s'intercale ; seul le niveau HPAC est donc chiffré.",
      "dealCaseWhat_b": "Une filiale Helinox — Helinox Inc., Helinox Japan, etc. — achète à HPAC et vend sur son propre marché. C'est cette seconde étape que chiffre le niveau filiale.",
      "needPhoto": "Ajoutez au moins une photo avant d'enregistrer.",
      "needCase": "{{sku}} : choisissez un cas.",
      "needT1": "{{sku}} : le ratio T1 est obligatoire pour ce cas.",
      "needT2": "{{sku}} : le ratio T2 est obligatoire pour ce cas.",
      "needInlineRrp": "{{sku}} : le prix de vente Inline est obligatoire.",
      "needPremium": "{{sku}} : la prime Collab est obligatoire.",
      "marginBasis": "Marge calculée sur",
      "marginBasisBase": "Base de majoration (guide)",
      "marginBasisBuying": "Coût d'achat total (feuille de devis)",
      "marginBasisBaseHint": "Les éléments exclus sont hors de la base de T2 — ils sont récupérés sous forme de débit HPAC.",
      "marginBasisBuyingHint": "Tout est majoré, rien n'est donc débité séparément.",
      "partnerRatio": "Ratio partenaire",
      "partnerRatioHint": "Prix partenaire en pourcentage du MSRP.",
      "inlineRrp": "Prix de vente conseillé Inline",
      "productPage": "Page produit",
      "folderPlaceholder": "Dossier — p. ex. 27SS",
      "folderNone": "Non classé",
      "newFolder": "Nouveau dossier",
      "newFolderPlaceholder": "Nom du dossier",
      "renameFolder": "Renommer",
      "renameFolderTitle": "Renommer {{name}}",
      "deleteFolderTitle": "Supprimer le dossier {{name}} ?",
      "deleteFolderBody": "Les devis qu'il contient sont conservés — ils repassent dans Non classé.",
      "dragHint": "Faites glisser une ligne sur un dossier pour l'y classer.",
      "approvePricing": "Approuver le prix",
      "inlineRrpHint": "Prix de vente conseillé du produit comparable de la gamme Inline.",
      "premium": "Prime collab",
      "premiumHint": "Ce que la collaboration ajoute, en % du RRP Inline.",
      "markupBase": "Markup Base",
      "markupBaseSub": "Le coût sur lequel la marge est calculée",
      "composition": "Composition du FOB fournisseur",
      "pricingResults": "Résultats de prix",
      "buyingCost": "Coût d'achat total",
      "buyingCostSub": "Base de majoration + éléments exclus",
      "hpacUnit": "Coût marketing HPAC",
      "hpacUnitSub": "par unité",
      "hpacTotal": "Coût marketing HPAC",
      "hpacTotalSub": "débit total · par unité × quantité commandée",
      "t1": "T2 (marque partenaire)",
      "t1Sub": "Base de majoration ÷ (1 − ratio T2)",
      "colStatus": "Statut",
      "stDraft": "Brouillon",
      "colNo": "N°",
      "countAll_one": "{{count}} devis",
      "countAll_other": "{{count}} devis",
      "countOf": "{{n}} sur {{total}}",
      "allTeams": "Toutes les équipes",
      "approvalTitle": "Approbation des prix",
      "approvalSub": "Deux niveaux : le responsable des ventes, puis le CEO. Un devis affiché ici est en attente de quelqu'un.",
      "colTeam": "Sales OP",
      "colTrail": "Historique",
      "colSubmittedBy": "Émetteur",
      "colNote": "Note",
      "colCreatedBy": "Créé par",
      "colCreatedAt": "Créé le",
      "colModifiedBy": "Modifié par",
      "colModifiedAt": "Modifié le",
      "selected": "{{n}} sélectionné(s)",
      "approveSelected": "Approuver la sélection",
      "clearSelection": "Effacer",
      "submitTitle": "Soumettre {{id}}",
      "submitBody": "Ajoutez une note pour {{who}} — pourquoi ce prix, ou ce qui a changé. Facultatif.",
      "submitPh": "p. ex. coût du cadre mis à jour après le devis du fournisseur du 9 sept.",
      "recall": "Rappeler",
      "recallTitle": "Rappeler {{id}}",
      "recallBody": "Le devis est retiré de la file de {{who}} et repasse en brouillon : vous pouvez le modifier puis le renvoyer. Cette personne reçoit un e-mail l'informant qu'il n'attend plus sa décision.",
      "recallPh": "Pourquoi vous le rappelez (facultatif)",
      "remind": "Relancer",
      "remindTitle": "Relancer au sujet de {{id}}",
      "remindBody": "{{who}} reçoit un e-mail indiquant que ce devis attend toujours sa décision, avec un lien vers celui-ci. L'auteur est en copie. Une relance par devis toutes les 4 heures.",
      "remindPh": "Un mot de votre part (facultatif), p. ex. le partenaire a besoin du prix d'ici vendredi",
      "remindSend": "Envoyer la relance",
      "remindSent": "Relance au sujet de {{id}} envoyée à {{to}}.",
      "reminded": "Relancé par {{who}} · {{at}}",
      "remindCount": "{{n}} relance(s) à ce jour",
      "remindSoon": "{{who}} a déjà envoyé une relance. La prochaine pourra partir à partir de {{at}}.",
      "noteFrom": "Note",
      "noteManager": "Responsable",
      "noteFinal": "Approbateur final",
      "gateBy": "soumis par {{who}}",
      "openMissing": "{{id}} ne figure pas dans cette liste — il est peut-être déjà approuvé.",
      "deleted": "{{id}} supprimé.",
      "deleteTitle": "Supprimer ce projet ?",
      "deleteBody": "{{id}} quitte la liste enregistrée. Le calcul des coûts est conservé et un administrateur peut le restaurer.",
      "confirmDelete": "Supprimer",
      "stagePending": "En attente",
      "stagePendingHint": "Chez son auteur — nouveaux brouillons et tout ce qui a été renvoyé. Le statut de la ligne indique lequel.",
      "stageManager": "Responsable des ventes — approbation",
      "stageManagerHint": "Soumis, en attente du responsable de l'équipe Sales OP.",
      "stageFinal": "CEO — approbation",
      "stageFinalHint": "Le responsable l'a approuvé. En attente de la décision finale.",
      "stageDone": "Approuvé",
      "stageDoneHint": "Approuvé et terminé. Rien ici n'attend personne.",
      "stageApproval": "approbation",
      "approvedElsewhere": "Les devis approuvés sont du travail terminé — ils se trouvent dans Projets enregistrés, avec Dupliquer.",
      "queueMine": "En attente de vous",
      "queueMineHint": "À vous de décider. Approuver le fait avancer ; le renvoyer exige un motif.",
      "queueBack": "Renvoyés",
      "queueBackHint": "Modifiez ce qui a été demandé, puis soumettez à nouveau.",
      "queueDraft": "Pas encore soumis",
      "queueDraftHint": "Des brouillons sur lesquels personne n'a été sollicité.",
      "queueWaiting": "En cours ailleurs",
      "queueWaitingHint": "En attente de quelqu'un d'autre — affichés ici pour qu'il ne soit pas nécessaire de demander « où est mon devis ».",
      "queueDone": "Approuvés",
      "queueDoneHint": "Définitif. Dupliquer crée un nouveau brouillon qui indique son origine.",
      "queueEmpty": "Rien ici.",
      "trailSubmitted": "{{who}} · {{on}}",
      "trailManager": "Responsable des ventes : {{who}} · {{on}}",
      "trailFinal": "CEO : {{who}} · {{on}}",
      "trailNone": "non soumis",
      "resubmit": "Soumettre à nouveau",
      "gate": "Approbation",
      "goApproval": "Ouvrir l'écran Approbation des prix",
      "reload": "Recharger",
      "loading": "Chargement…",
      "stPendingmanager": "En attente : responsable",
      "stPendingCEO": "En attente : CEO",
      "stPendingcalculation": "En attente : calcul",
      "stageCalc": "Responsable du projet — calcul",
      "stageCalcHint": "Le service Costing les a envoyés avec leur coût d'achat. L'étape de calcul fixe le HPAC Overhead % et le T2 Markup % de chaque article, puis envoie le devis au responsable des ventes — ou le renvoie à Costing.",
      "sentBackCalc": "renvoyé à Costing depuis l'étape de calcul",
      "submitBodyCalc": "Un devis CBD passe d'abord par {{who}} pour l'étape de calcul (HPAC Overhead % et T2 Markup % par article), puis par {{mgr}}. Ajoutez une note — pourquoi ce prix, ou ce qui a changé. Facultatif.",
      "calcOpen": "Calculer",
      "calcSaved": "Calcul enregistré.",
      "calcSent": "{{id}} transmis — {{status}}.",
      "calcReturned": "{{id}} renvoyé à Costing.",
      "calcTitle": "Calcul",
      "calcKindEdit": "Définissez les deux pourcentages de chaque article",
      "calcKind": "Calcul par {{who}}",
      "calcNote": "Coût d'achat issu de Costing. Le HPAC Overhead et le T2 Markup s'appliquent au prix de base + cadre ; les surcharges et les frais de matériel vendu par Helinox sont répercutés tels quels. Un pourcentage vide prend la règle ({{oh}} % / {{mk}} %).",
      "calcProduct": "Produit",
      "calcQty": "Quantité commandée (pcs)",
      "calcBase": "Prix de base",
      "calcFrame": "Cadre (matériel vendu par Helinox)",
      "calcOhPct": "HPAC Overhead %",
      "calcOh": "HPAC Overhead",
      "calcMoq": "Surcharge MOQ de production",
      "calcSl": "Surcharge délai court",
      "calcFees": "Frais de matériel vendu par Helinox",
      "calcT1": "Prix T1",
      "calcT1Amt": "Montant T1 (USD)",
      "calcMkPct": "T2 Markup %",
      "calcT2": "Prix T2",
      "calcT2Amt": "Montant T2 (USD)",
      "calcProfit": "Bénéfice (USD/pc)",
      "calcProfitAmt": "Montant du bénéfice (USD)",
      "calcMargin": "Marge %",
      "calcColor": "Coloris : {{c}}",
      "calcT2Raw": "{{v}} avant arrondi",
      "calcTotal": "Total",
      "calcFoot": "Le T2 est arrondi au dollar supérieur, comme dans la feuille Price Approval. Bénéfice = T2 − coût d'achat ; Marge = Bénéfice ÷ T2.",
      "calcBadPct": "Un pourcentage doit être compris entre 0 et 300.",
      "calcSave": "Enregistrer",
      "calcReturn": "Renvoyer à Costing",
      "calcSend": "Envoyer au responsable des ventes",
      "calcSendNote": "Une note pour le responsable des ventes (facultatif)",
      "calcReturnWhy": "Que doit modifier Costing ?",
      "calcSendPh": "p. ex. Table maintenue à 30 % — volume partenaire",
      "calcReturnPh": "p. ex. Le prix du cadre dans le tableau est celui de la saison dernière",
      "calcSendSaves": "Les pourcentages que vous avez modifiés sont d'abord enregistrés.",
      "calcCancel": "Annuler",
      "calcSendGo": "Envoyer",
      "calcReturnGo": "Renvoyer à Costing",
      "stApproved": "Approuvé",
      "stRejected": "Rejeté",
      "sentBackMgr": "rejeté par le responsable des ventes",
      "sentBackCeo": "rejeté par le CEO",
      "submit": "Soumettre",
      "reject": "Renvoyer",
      "revise": "Dupliquer",
      "view": "Afficher",
      "rejectTitle": "Renvoyer {{id}}",
      "rejectBody": "Indiquez ce qui doit changer. La personne à qui il est renvoyé n'a que cela pour travailler.",
      "nowStatus": "Terminé — le devis est maintenant {{status}}. {{to}}",
      "revisedInto": "Copié dans {{id}} comme nouveau brouillon.",
      "leadWorked": "XF − PO = {{days}} jours → délai court {{rate}}",
      "stepOrder": "La commande",
      "stepFactory": "Coût usine",
      "stepFrame": "Coût du cadre",
      "stepOthers": "Coût supplémentaire 1",
      "days": "jours",
      "unitCost": "Coût d'une unité",
      "share": "Part",
      "bothConventions": "Le même devis selon les deux conventions",
      "whatTheyPay": "Ce que paient les entités et le partenaire",
      "marginTakenOn": "La marge est calculée sur",
      "profitAtT1": "Bénéfice à T1",
      "profitAtT2": "Bénéfice à T2",
      "profitSub": "le prix du palier moins la base de calcul de la marge, par unité",
      "totalProfitAtT1": "Bénéfice total à T1",
      "totalProfitAtT2": "Bénéfice total à T2",
      "totalProfitSub": "bénéfice par unité × {{qty}} EA — chiffre d'affaires moins le coût de la commande",
      "revenueAtT1": "Chiffre d'affaires à T1",
      "revenueAtT2": "Chiffre d'affaires à T2",
      "revenueSub": "le prix du palier × {{qty}} EA — la commande entière, pas une unité",
      "gapNote": "Les deux conventions diffèrent de {{gap}} sur {{tier}}. Dans la directive, les autres coûts de {{unit}} par unité sont facturés séparément au partenaire — {{debit}} pour {{qty}} EA ; dans la feuille de devis, ils sont déjà inclus dans le prix. Même somme, deux endroits : c'est pourquoi le devis doit préciser lequel s'applique.",
      "basisLine": "Soumis sur {{name}} — la colonne en surbrillance est ce que l'approbateur doit accepter.",
      "t0": "T1 (entité Helinox)",
      "t0Sub": "Base de majoration ÷ (1 − ratio T1)",
      "t0SubBuying": "Coût d'achat total ÷ (1 − ratio T1)",
      "t1SubBuying": "Coût d'achat total ÷ (1 − ratio T2)",
      "marginOnBuying": "Coût d'achat total",
      "hpacTotalInPrice": "Déjà inclus dans le prix sur cette base de marge",
      "msrp": "MSRP",
      "msrpSub": "Prix de vente Inline × (1 + prime %)",
      "partnerPrice": "Prix partenaire",
      "partnerPriceSub": "MSRP × ratio partenaire",
      "allSkus": "Tous les SKU",
      "globalInputs": "Données globales",
      "licensedSub": "Le modèle sous licence est tarifé à partir du prix en rayon du partenaire. Une redevance est versée sur son prix de vente ; le chiffre qui compte est donc la marge restante après celle-ci.",
      "globalMsrp": "MSRP global (USD)",
      "t1Fob": "T1 FOB",
      "logistics": "Logistique %",
      "logisticsHint": "Ajouté au T1 FOB pour obtenir le coût rendu.",
      "wholesale": "Gros %",
      "wholesaleHint": "Prix de gros en pourcentage du SRP local.",
      "wsRoyalty": "Redevance WS %",
      "wsRoyaltyHint": "Redevance sur le prix de gros.",
      "dtcRoyalty": "Redevance DTC %",
      "dtcRoyaltyHint": "Redevance sur le prix de détail.",
      "landed": "Coût rendu",
      "landedSub": "T1 FOB × (1 + logistique %)",
      "entities": "Entités",
      "addEntity": "Ajouter une entité",
      "entity": "Entité",
      "fx": "Change / USD",
      "localSrp": "SRP local",
      "resultsByEntity": "Résultats par entité",
      "resultsByEntitySub": "Les marges sont affichées avant et après redevance. L'écart entre les deux correspond au coût de la licence.",
      "srpUsd": "SRP (USD)",
      "wholesaleCol": "Gros",
      "wsMargin": "Marge WS",
      "dtcMargin": "Marge DTC",
      "prePost": "avant → après",
      "fobMult": "FOB ×",
      "addEntityFirst": "Ajoutez une entité",
      "colProject": "Projet",
      "colName": "Nom",
      "openQuote": "Ouvrir le devis {{id}}",
      "colMode": "Mode",
      "colSkus": "SKU",
      "colSavedBy": "Enregistré par",
      "colSaved": "Enregistré",
      "general": "Général",
      "licensed": "Sous licence",
      "nothingSaved": "Rien d'enregistré pour l'instant",
      "skuField": "SKU",
      "skuFieldHint": "Un seul article à calculer.",
      "globalMsrpHint": "Un prix de détail global (USD). Les SRP locaux en sont convertis.",
      "t1FobHint": "Prix de cession à l'entité après négociation avec le fournisseur, avant logistique.",
      "royaltyNote": "La redevance n'est pas un coût. Ce n'est pas ce qu'il faut pour fabriquer le produit — c'est une redevance de marque payée sur les ventes, après la vente ; elle forme donc une ligne distincte sous le chiffre d'affaires plutôt qu'un élément ajouté au coût. Elle ne s'applique pas non plus aux cessions intragroupe T1 (HPAC → chaque entité) : elle n'apparaît que lorsque le produit part vers l'extérieur, chez un grossiste ou un consommateur.",
      "burdenNote": "Lorsque le prix de gros représente 50 % du SRP, une redevance de gros de 11 % correspond à la même charge réelle qu'une redevance DTC de 5,5 %. Si vous modifiez le ratio de gros, cette équivalence change : examinez donc les deux taux ensemble.",
      "autoFillSrp": "Remplir automatiquement le SRP local",
      "autoFillHint": "MSRP global × chaque taux de change.",
      "resetEntities": "Réinitialiser",
      "wholesalePrice": "Prix de gros",
      "dtcRoyaltyAmt": "Redevance DTC",
      "wsRoyaltyAmt": "redevance",
      "wsMarginLabel": "Marge de gros",
      "dtcMarginLabel": "Marge DTC",
      "pre": "avant",
      "lowMargin": "marge faible",
      "fobBadge": "FOB",
      "cancel": "Annuler",
      "colAction": "Action",
      "colBuying": "Coût d'achat",
      "colT1": "T2",
      "edit": "Modifier",
      "clearFilters": "Effacer tris et filtres",
      "discardTitle": "Abandonner ce calcul des coûts ?",
      "discardBody": "Ce qui est affiché n'a pas été enregistré. Abandonner l'efface et démarre un projet vierge.",
      "keepEditing": "Continuer à modifier",
      "discard": "Abandonner"
    },
    "ask": {
      "launch": "Demander à Catchy",
      "role": "Assistant IA de productivité",
      "note": "Les conversations servent à rendre Catchy plus performant.",
      "moveHint": "Faites glisser pour déplacer · double-cliquez pour le remettre en place",
      "hello": "Bonjour, je suis Catchy. Posez-moi vos questions sur les projets, les SKU et leurs étapes, les échantillons, les tickets, OPA / SCT, les jetons NFC et les ventes — tout ce que vos écrans vous permettent de voir. Vous pouvez aussi coller une capture d'écran.",
      "s1": "Quels échantillons sont à rendre cette semaine ?",
      "s2": "Quels tickets sont en retard ?",
      "s3": "Combien de SKU de Team 2 sont en retard (Delayed) ?",
      "hideSugs": "Masquer les questions suggérées",
      "showSugs": "Afficher les questions suggérées",
      "otherSugs": "Autres questions",
      "placeholder": "Posez une question ou collez une capture d'écran…",
      "send": "Envoyer",
      "attach": "Ajouter une capture d'écran",
      "screenshot": "Capture d'écran",
      "screenshotReady": "Capture d'écran jointe",
      "remove": "Retirer",
      "lookingAt": "Consulte :",
      "lookingAtHint": "Catchy comprend « ceci » comme l'élément ouvert sur cet écran",
      "dropContext": "Demander sans cela",
      "save": "Enregistrer la conversation",
      "newChat": "Nouvelle conversation",
      "expand": "Agrandir",
      "shrink": "Réduire",
      "close": "Fermer",
      "you": "Vous",
      "leftToday_one": "{{count}} question restante aujourd'hui",
      "leftToday_other": "{{count}} questions restantes aujourd'hui",
      "noneLeft": "Plus de questions aujourd'hui. Réessayez après minuit."
    },
    "ps": {
      "titleFor": "Sample Tracker {{org}}",
      "partner": "Partenaire",
      "loading": "Chargement…",
      "fills": "À renseigner par {{org}}",
      "requiresReview": "Nécessite la revue de {{reviewer}}",
      "reviewerDefault": "designer",
      "reviewerNote": "Revue de {{reviewer}} : saisissez la date de revue et le résultat dans Round Outcome ci-dessous.",
      "reviewDateHint": "Date à laquelle {{reviewer}} a effectué la revue",
      "internalOnly": "Revue interne {{org}} uniquement",
      "internalNote": "Utilisez la date de revue et les remarques pour le dossier de revue interne {{org}}. Ce tour n'est pas compté dans la charge de travail du designer ni dans les retours en attente.",
      "internalReview": "Revue interne {{org}}",
      "location": "Lieu",
      "allLocations": "Tous les lieux",
      "locationPh": "Sélectionnez ou saisissez un lieu...",
      "createTitle": "Nouvel échantillon — saisissez son style / article",
      "createSub": "Un nouveau style reçoit le Base ID suivant ({{prefix}}-00001, {{prefix}}-00002…) et nécessite une photo. Pour un style existant, ce tour est ajouté à son Base ID.",
      "styleTypedHint": "Saisi ici — le Base ID est attribué d'après le nom du style",
      "pickPh": "p. ex. {{prefix}}-00001-P1 ou {{prefix}}-00001...",
      "pickNone": "Aucun échantillon ne correspond. Pour en démarrer un nouveau, utilisez + Create Sample.",
      "pickCompany": "Choisissez la société concernée par cet échantillon",
      "allCompanies": "Toutes les sociétés",
      "empty": "Aucun échantillon {{org}} pour l'instant. Cliquez sur + Create Sample pour créer le premier.",
      "tourCreateB": "Saisissez le nom du style / article et ajoutez une photo. Un nouveau style reçoit le Base ID suivant ; pour un style existant, le tour est ajouté sous son propre Base ID. Renseignez ensuite le Sample Plan.",
      "tourFiltersB": "Par statut, développeur ou lieu, ou saisissez dans la zone de recherche. Effacer remet tout en place, y compris les filtres des en-têtes de colonnes.",
      "manual": "Manuel d'utilisation",
      "manualTitle": "Ouvre le manuel de ce tracker dans un nouvel onglet — Tiếng Việt, English, 한국어, 中文, Français, 日本語",
      "tourTabsT": "Deux façons de le lire",
      "tourTabsB": "All Samples liste chaque Base ID avec ses tours. Sample-level Summary donne une ligne par échantillon, avec ses tours R1 à R5 côte à côte."
    },
    "cr": {
      "requestTitle": "Demandes de courrier express",
      "requestSub": "Avant tout envoi sur un compte courrier express Helinox (FedEx, DHL, UPS …), faites-en la demande ici. Le portail compare le coût au contrat ; l'approbateur décide avant l'expédition. Ne concerne pas le fret maritime ou aérien ordinaire.",
      "approvalTitle": "Approbation courrier express",
      "approvalSub": "Envois par courrier express en attente de décision avant expédition, vérifiés par rapport aux tarifs contractuels FedEx de HINC et DHL de HPAC. Approbateur : {{who}}.",
      "new": "Nouvelle demande",
      "newTitle": "Nouvelle demande de courrier express",
      "close": "Fermer",
      "cancel": "Annuler",
      "send": "Envoyer pour approbation",
      "pick": "Choisir…",
      "loading": "Chargement…",
      "clear": "Effacer",
      "sendNote": "L'envoi pour approbation va à l'approbateur, {{who}}, qui approuve ou refuse ici. Vous et les personnes en copie recevez aussi l'e-mail.",
      "b_requester": "Demandeur",
      "b_carrier": "Transporteur et compte facturé",
      "b_route": "Origine et destination",
      "b_weight": "Poids et colis",
      "b_cost": "Coût estimé",
      "b_goods": "Les marchandises",
      "requester": "Demandé par",
      "department": "Service",
      "ccEmails": "Copie (entité titulaire du compte)",
      "ccHint": "Règle 1 de Young : l'entité titulaire du compte est en copie. Adresses @helinox.com uniquement, séparées par des virgules.",
      "carrier": "Transporteur",
      "carrierOther": "Nom du transporteur",
      "service": "Niveau de service",
      "accountHolder": "Compte Helinox facturé",
      "accountHint": "L'entité dont le compte de transport paie.",
      "accountNo": "Numéro de compte",
      "from": "De (origine)",
      "to": "Vers (destination)",
      "shipper": "Expéditeur",
      "receiver": "Destinataire",
      "country": "Pays",
      "city": "Ville",
      "address": "Adresse",
      "zipHint": "Indiquez le code postal.",
      "toIndividual": "Livré à l'adresse d'un particulier (domicile d'un collègue, site d'un client)",
      "importer": "Consignataire et importateur officiel",
      "importerHint": "Règle 5 de Young : l'entité Helinox, avec le particulier « aux bons soins de » — jamais le particulier seul.",
      "shipmentTo": "Envoi à destination de",
      "to_internal": "Une entité ou une équipe Helinox",
      "to_direct": "Un client ou un tiers (direct)",
      "toDirect": "Envoyé directement à un client ou à un tiers (pas à une entité Helinox)",
      "to_customer": "Un client (direct)",
      "to_partner": "Un partenaire ou un tiers (direct)",
      "freightPayer": "Qui supporte le fret",
      "payerHint": "Règle 6 de Young : indiquez qui paie, avant la réservation.",
      "incoterm": "Condition d'expédition (Incoterm)",
      "cartons": "Cartons",
      "actualKg": "Poids réel (brut), kg",
      "dimKg": "Poids volumétrique, kg",
      "dimPh": "Tous les cartons ensemble",
      "useBoxTitle": "Calculer le poids volumétrique à partir d'un carton (L × l × H ÷ 5 000) × le nombre de cartons",
      "boxSize": "Dimensions du carton, cm (L × l × H)",
      "useBox": "Utiliser",
      "estCost": "Coût de fret estimé",
      "currency": "Devise",
      "duties": "Droits / taxes estimés",
      "dutiesDdp": "DDP : Helinox les paie — saisissez l'estimation (0 s'il n'y en a pas).",
      "bulkyNote": "Fret volumineux (poids volumétrique supérieur au poids réel, ou plus de 100 kg) : l'express n'est pas le choix par défaut. Ajoutez au moins un devis de transitaire à comparer avant la réservation (règle 2 de Young). Les arceaux, tentes, cadres et meubles sont volumineux par définition.",
      "fwdName": "Transitaire",
      "fwdCost": "Devis du transitaire",
      "goodsFor": "Destinataire des marchandises",
      "goodsForHint": "La personne, l'équipe ou le client à qui les marchandises sont destinées.",
      "contents": "Contenu",
      "purpose": "Objet",
      "notes": "Notes",
      "checkTitle": "Contrôle du coût",
      "checkWhat": "Pendant que vous remplissez le formulaire, le portail compare votre coût estimé au tarif contractuel FedEx de HINC.",
      "checkNeed": "Encore nécessaire : {{list}}.",
      "need_courier": "transporteur",
      "need_dest": "pays de destination",
      "need_weight": "poids réel",
      "need_cost": "coût estimé",
      "need_currency": "devise",
      "chargeable": "Poids taxable",
      "bulky": "VOLUMINEUX",
      "quoted": "Votre estimation",
      "usdPerKg": "Par kg",
      "diff": "Par rapport au tarif contractuel",
      "fxWeek": "Taux de change (NetSuite)",
      "v_reasonable": "Raisonnable",
      "v_review": "Vérification recommandée",
      "v_high": "Potentiellement élevé",
      "v_nocontract": "Pas de tarif contractuel",
      "v_manual": "À vérifier manuellement",
      "v_undefined": "—",
      "s_waiting": "En attente",
      "s_approved": "Approuvé",
      "s_rejected": "Rejeté",
      "s_withdrawn": "Retiré",
      "tab_waiting": "En attente de décision",
      "tab_approved": "Approuvés",
      "tab_rejected": "Rejetés",
      "tab_all": "Tous",
      "tab_rates": "Tarifs",
      "empty_waiting": "Rien n'attend de décision.",
      "empty_approved": "Rien d'approuvé pour l'instant.",
      "empty_rejected": "Rien n'a été rejeté.",
      "empty_all": "Aucune demande de courrier express pour l'instant.",
      "emptyMine": "Vous n'avez pas encore envoyé de demande de courrier express.",
      "countRows": "{{n}} sur {{total}}",
      "c_no": "Demande",
      "c_created": "Envoyée",
      "c_requester": "Demandeur",
      "c_entity": "Entité",
      "c_route": "Trajet",
      "c_carrier": "Transporteur",
      "c_originCountry": "Pays d'origine",
      "c_originCity": "Ville d'origine",
      "c_destCountry": "Pays de destination",
      "c_destCity": "Ville de destination",
      "c_service": "Service",
      "c_account": "Compte",
      "c_kg": "Kg taxables",
      "c_cost": "Estimation",
      "c_check": "Contrôle",
      "c_status": "Statut",
      "c_decidedBy": "Décidé par",
      "c_decidedAt": "Décidé le",
      "f_route": "Trajet",
      "f_carrier": "Transporteur et service",
      "f_account": "Compte facturé",
      "f_weight": "Poids et colis",
      "f_cost": "Fret estimé",
      "f_fwd": "Devis du transitaire",
      "f_goodsFor": "Destinataire des marchandises",
      "f_purpose": "Objet",
      "f_contents": "Contenu",
      "f_shipper": "Expéditeur",
      "f_receiver": "Destinataire",
      "f_importer": "Importateur officiel",
      "f_direct": "Envoi direct (qui supporte le fret)",
      "f_incoterm": "Condition d'expédition",
      "ddpShort": "Helinox paie les droits et taxes",
      "f_requester": "Demandé par",
      "f_cc": "En copie",
      "f_notes": "Notes",
      "actualShort": "réel",
      "dimShort": "volumétrique",
      "chargeableShort": "taxable",
      "cartonsShort": "carton(s)",
      "dutiesShort": "droits/taxes",
      "raised": "Envoyée le {{at}} par {{by}}.",
      "approvedBy": "Approuvé par {{by}} · {{at}}",
      "rejectedBy": "Rejeté par {{by}} · {{at}}",
      "withdrawnAt": "Retirée le {{at}}.",
      "rule4": "Si le devis du transporteur à la réservation dépasse cette estimation, arrêtez-vous avant l'expédition et signalez-le (règle 4 de Young).",
      "approve": "Approuver",
      "reject": "Rejeter",
      "withdraw": "Retirer",
      "withdrawAsk": "Retirer {{no}} ? L'approbateur est informé qu'il n'y a plus rien à décider.",
      "didApprove": "{{no}} approuvé — le demandeur en est informé.",
      "didReject": "{{no}} rejeté — le demandeur est informé du motif.",
      "didWithdraw": "{{no}} retiré.",
      "s_draft": "Brouillon",
      "notSent": "Non envoyée",
      "saveDraft": "Enregistrer le brouillon",
      "c_createdBy": "Créé par",
      "c_createdAt": "Créé le",
      "checkSource": "Calculé à partir du fichier des tarifs contractuels FedEx de HINC — il ne s'agit pas d'une analyse par IA.",
      "noContract": "pas de prix contractuel sur cette liaison",
      "contractBase": "Tarif contractuel avant surcharge carburant",
      "h_shipment": "Envoi",
      "h_source": "Origine des chiffres",
      "h_findings": "Résultat du contrôle",
      "editTitle": "Modifier {{no}}",
      "copyTitle": "Nouvelle demande de courrier express — copiée de {{no}}",
      "savedDraft": "{{no}} enregistré comme brouillon — envoyez-le quand il sera prêt.",
      "didDelete": "{{no}} supprimé.",
      "didDeleteMailed": "{{no}} supprimé — l'approbateur est informé qu'il n'y a plus rien à décider.",
      "deleteAsk": "Supprimer {{no}} ? Cette action est irréversible.",
      "deleteAskWaiting": "Supprimer {{no}} ? Il est chez l'approbateur, qui sera informé qu'il n'y a plus rien à décider. Cette action est irréversible.",
      "saveWaiting": "Enregistrer",
      "changedByYou": "{{no}} modifié — le demandeur est informé des changements. Il attend toujours votre décision.",
      "changedBy": "Dernière modification par {{by}} · {{at}}.",
      "why_notWaiting": "Uniquement une demande en attente de décision",
      "c_managerNote": "Note du responsable",
      "c_action": "Action",
      "a_view": "Afficher",
      "a_edit": "Modifier",
      "a_submit": "Soumettre",
      "a_copy": "Dupliquer",
      "a_delete": "Supprimer",
      "a_withdraw": "Retirer",
      "why_waiting": "Chez l'approbateur — retirez-la d'abord pour la modifier",
      "why_approved": "Approuvée — dupliquez-la pour un autre envoi",
      "why_sent": "Déjà chez l'approbateur",
      "why_done": "Déjà décidée",
      "why_record": "Approuvée — conservée comme trace de l'approbation",
      "why_notMine": "Ce n'est pas votre demande",
      "sent": "{{no}} envoyé pour approbation.",
      "sentMailed": "{{no}} envoyé pour approbation — l'approbateur en est informé.",
      "billed": "Poids facturé",
      "lane": "Liaison sous contrat",
      "dir_export": "Export depuis la Corée",
      "dir_import": "Import vers la Corée",
      "dir_sg-export": "Export depuis Singapour",
      "dir_sg-import": "Import vers Singapour",
      "dhlFreightOnly": "Grille DHL : fret uniquement — carburant, droits et frais DHL en sus",
      "estSurcharge": "Coût estimé des surcharges",
      "estSurchargeHint": "Carburant, zone éloignée et autres surcharges en plus du fret — les tarifs contractuels ne portent que sur le fret",
      "dhlSettingsTitle": "HPAC DHL (Singapour) — la grille ne porte que sur le fret",
      "dhlFuelPct": "Surcharge carburant DHL %",
      "dhlRemarkLabel": "Remarque affichée sous chaque comparaison DHL",
      "ratesTitleDhl": "Tarifs contractuels HPAC DHL Express (SGD)",
      "ratesNoteDhl": "DHL Express Worldwide, d'après la grille tarifaire DHL Express Singapour de HPAC. Jusqu'à 30 kg, le prix couvre l'envoi entier, par demi-kilo ; à partir de 30,1 kg, c'est un prix par kg, par kilo entier. Fret uniquement : surcharge carburant, droits, taxes et frais DHL en sus. Les prix « documents uniquement » et DHL pour pays tiers ne sont pas chargés. La grille de l'an prochain (.pdf) s'importe de la même façon avec Importer.",
      "contract": "Tarif contractuel",
      "withFuel": "Avec surcharge carburant {{pct}} %",
      "prioRate": "Priority : le tarif Economy × {{f}}",
      "econRate": "Tarif Economy, tel que dans le fichier",
      "economyBase": "Tarif Economy du fichier",
      "h_remark": "Remarque",
      "priorityFactor": "Priority = tarif Economy ×",
      "remarkLabel": "Remarque affichée sous chaque comparaison avec le contrat",
      "rateFile": "Fichier de tarifs",
      "depPick": "Choisissez ou saisissez un service",
      "depNone": "Aucun résultat pour « {{name}} »",
      "depAddTo": "+ Ajouter « {{name}} » à la liste des services",
      "depAdded": "« {{name}} » ajouté à la liste.",
      "rateVersion": "Tarifs contractuels de {{file}} · chargés par {{by}} · {{at}}",
      "rateNone": "Aucun tarif contractuel chargé pour l'instant.",
      "settingsTitle": "Comment le contrôle juge un devis",
      "settingsNote": "Le fichier de tarifs est le tarif Economy de FedEx ; un service Priority coûte ce tarif multiplié par le facteur. Le contrat ne comporte pas de surcharge carburant, qui reste donc à 0 sauf changement. Un devis dans la limite de « Raisonnable jusqu'à » par rapport au tarif contractuel est raisonnable ; jusqu'à « À vérifier jusqu'à », il mérite un coup d'œil ; au-delà, il est potentiellement élevé.",
      "fuelPct": "Surcharge carburant %",
      "okPct": "Raisonnable jusqu'à (%)",
      "reviewPct": "À vérifier jusqu'à (%)",
      "saveSettings": "Enregistrer",
      "settingsSaved": "Enregistré.",
      "ratesTitle": "Tarifs contractuels HINC FedEx (KRW)",
      "ratesNote": "Jusqu'à 20,5 kg, le prix couvre l'envoi entier, par demi-kilo ; à partir de 21 kg, c'est un prix par kg, par kilo entier. Le fichier de l'an prochain s'importe avec Importer : il est d'abord lu, puis remplace cette liste.",
      "upload": "Importer un fichier de tarifs (FedEx .xlsx / DHL .pdf)",
      "previewCounts": "Export : {{el}} colonnes, {{ec}} destinations. Import : {{il}} codes de région, {{ic}} pays. {{rows}} prix.",
      "replaceRates": "Remplacer les tarifs",
      "ratesLoaded": "Tarifs chargés depuis {{file}}.",
      "weightCol": "Poids",
      "perKgShort": "(par kg)",
      "laneNoCountry": "Aucun pays associé à cette colonne",
      "countriesTitle": "Pays de chaque colonne"
    },
    "spl": {
      "title": "Planification des ventes",
      "loading": "Chargement…",
      "cycle": "Cycle de commande",
      "season": "Saison",
      "next": "Suivant",
      "orderDue": "Commande",
      "exf": "Sortie usine",
      "tab_format": "Format de commande",
      "tab_sheets": "Fiches de commande",
      "tab_stock": "Stock",
      "tab_production": "Production",
      "tab_overview": "Vue d'ensemble",
      "tab_setup": "Configuration",
      "fmtNone": "non importé",
      "fmtCount": "{{n}} SKU",
      "sheetsCount": "{{done}}/{{n}} terminées",
      "stockServed": "{{n}} pcs depuis le stock",
      "prodCount": "{{set}}/{{n}} usines attribuées",
      "st_open": "Ouverte",
      "st_closed": "Clôturée",
      "closedNote": "Cette commande est clôturée — rouvrez-la dans Format de commande (Modifier › Statut) pour la modifier.",
      "newOrder": "Créer une commande",
      "newOrderTitle": "Créer une commande",
      "open": "Ouvrir",
      "openFormat": "Ouvrir le format de cette commande",
      "delOrder": "Supprimer la commande",
      "col_id": "ID",
      "view": "Afficher",
      "viewOrder": "Afficher cette commande — lecture seule",
      "editOrder": "Modifier cette commande et son format",
      "modeView": "Lecture seule",
      "modeEdit": "Modification",
      "formatHead": "Format de commande · {{n}} SKU",
      "col_file": "Fichier de format de commande",
      "fileBy": "{{by}} · {{at}}",
      "fileNone": "Aucun fichier de format de commande pour l'instant.",
      "col_format": "SKU dans le format",
      "col_sheets": "Fiches terminées",
      "col_qty": "Commandé (pcs)",
      "col_createdBy": "Créé par",
      "col_createdAt": "Créé le",
      "col_action": "Action",
      "ordersCount": "{{n}} commandes sur {{total}}",
      "clearFilters": "Effacer les filtres",
      "noOrderYetMgr": "Aucune commande pour l'instant — cliquez sur Créer une commande et importez son format de commande.",
      "noOrderYet": "Aucune commande pour l'instant — le responsable de Sales Planning la crée dans Format de commande.",
      "fmtSource": "Format de commande",
      "src_file": "Importer le format de commande Master (.xlsx)",
      "src_copy": "Copier le format d'une commande précédente",
      "src_later": "L'ajouter plus tard",
      "copyOption": "{{date}} · ex-fty {{exf}} · {{n}} SKU",
      "datesFirst": "Renseignez la date de commande et l'Ex-factory — le fichier est lu dès que les deux sont saisis.",
      "pvFile": "Feuille « {{sheet}} » : {{rows}} SKU deviennent le format de cette commande.",
      "pvCopy": "{{n}} SKU seront copiés depuis la commande du {{date}}.",
      "orderCreated": "Commande {{date}} créée — {{n}} SKU dans son format.",
      "orderCreatedNoFmt": "Commande {{date}} créée — importez son format de commande quand il sera prêt.",
      "orderDeleted": "Commande {{date}} supprimée.",
      "delAsk": "Supprimer la commande due le {{date}} (ex-factory {{exf}}) et les {{n}} SKU de son format ? Personne n'a encore travaillé dessus.",
      "formatOf": "Format de commande · {{date}} ({{season}}) · Ex-fty {{exf}}",
      "seasonAuto": "Saison {{s}} — d'après la date de commande (d'octobre à septembre).",
      "seasonAutoTip": "Déduite de la date de commande : une saison va d'octobre à septembre.",
      "sh_none": "Non commencée",
      "sh_open": "En cours",
      "sh_done": "Terminée",
      "sh_checked": "Vérifiée",
      "st_done_done": "{{cust}} : marquée comme terminée — le responsable de Sales Planning peut maintenant la vérifier.",
      "st_check_done": "{{cust}} : vérifiée.",
      "st_reopen_done": "{{cust}} : rouverte.",
      "cancel": "Annuler",
      "close": "Fermer",
      "save": "Enregistrer",
      "saveN": "Enregistrer ({{n}})",
      "saved": "Enregistré.",
      "savedCells": "{{n}} modification(s) enregistrée(s).",
      "edit": "Modifier",
      "remove": "Retirer",
      "removed": "{{sap}} retiré de ce cycle.",
      "read": "Lire le fichier",
      "write": "Écrire",
      "writeN": "Écrire {{n}} modification(s)",
      "search": "Code SAP, produit, coloris…",
      "allCategories": "Toutes les catégories",
      "allLineups": "Toutes les gammes",
      "noRows": "Aucun résultat.",
      "noOrders": "Aucune commande dans ce cycle pour l'instant.",
      "sap": "Code SAP",
      "product": "Produit",
      "qty": "Qté commandée",
      "amountUsd": "Montant (USD)",
      "total": "Total",
      "buyer": "Acheteur",
      "pic": "Responsable",
      "status": "Statut",
      "fmtEmpty": "Aucun format de commande pour ce cycle pour l'instant.",
      "fmtEmptyHint": "Importez le format de commande Master du mois (.xlsx). Ses SKU et ses prix deviennent la liste de ce cycle — les fiches de commande proposent exactement ceux-ci. Un SKU peut être ajouté ou corrigé à tout moment.",
      "fmtWaiting": "Le responsable de Sales Planning l'importe.",
      "upload": "Importer le format de commande",
      "uploadNew": "Importer une nouvelle version",
      "copyFrom": "Copier le format de {{cycle}}",
      "addSku": "Ajouter un SKU",
      "fmtDownload": "Télécharger le format",
      "fmtDownloadTip": "Le format de commande de ce cycle en .xlsx, selon la mise en page du format de commande Master — modifiez-le puis réimportez-le.",
      "portalOnly": "Conservé par le portail — le format de commande Master n'a pas cette colonne ; reprise du dernier cycle contenant le SKU.",
      "fmtNote": "{{n}} SKU sur {{total}} · prix en USD",
      "fmtUploadTitle": "Importer le format de commande Master",
      "fmtUploadBody": "Le fichier est d'abord lu, et n'est écrit que lorsque vous cliquez sur Écrire. Les SKU déjà présents dans ce cycle reprennent les attributs et les prix du fichier ; un SKU absent du fichier est conservé, sauf si vous cochez la case ci-dessous.",
      "fmtSummary": "Feuille « {{sheet}} » : {{rows}} SKU — {{added}} nouveaux, {{changed}} modifiés, {{missing}} dans ce cycle mais absents du fichier.",
      "fmtAdded": "Nouveaux",
      "fmtChanged": "Modifiés",
      "fmtMissing": "Absents du fichier",
      "fmtUsed": "cochés ou commandés, conservés",
      "fmtRemove": "Retirer aussi les {{n}} absents du fichier que personne n'a cochés ni commandés",
      "fmtNoChange": "Le fichier correspond au format de ce cycle.",
      "fmtDone": "Format de commande écrit : {{added}} nouveaux, {{changed}} modifiés, {{removed}} retirés.",
      "fmtCopied": "{{n}} SKU copiés.",
      "skuNew": "Ajouter un SKU",
      "skuEdit": "Modifier {{sap}}",
      "skuRemoveAsk": "Retirer {{sap}} ({{product}}) du format de commande de ce cycle ?",
      "noFormatYet": "Importez d'abord le format de commande — chaque fiche propose ses SKU.",
      "priceCol": "Tarifé à",
      "pf_price_t1": "T1 FOB",
      "pf_price_t2": "T2 FOB",
      "pf_price_hema_dt": "Prix HEMA DT",
      "pf_null": "—",
      "ticked": "SKU cochés",
      "ordered": "Commandé",
      "updated": "Dernier enregistrement",
      "myBuyers": "Uniquement mes acheteurs",
      "allStatus": "Tous les statuts",
      "sheetsNote": "{{done}} fiches terminées sur {{n}}",
      "sapAll": "Import SAP (tous les acheteurs)",
      "sapOne": "Import SAP SO pour cet acheteur",
      "sheetTitle": "fiche de commande {{date}}",
      "customerRef": "Référence client (PO# de l'acheteur)",
      "showTicked": "Cochés ({{n}})",
      "showAll": "Tous les SKU ({{n}})",
      "tick": "Cocher",
      "tickShown": "Cocher tous les éléments affichés",
      "untickShown": "Décocher tous les éléments affichés",
      "fromLast": "Mêmes SKU que le cycle précédent",
      "fromLastDone": "{{n}} SKU cochés, comme au {{date}}.",
      "nothingTicked": "Rien de coché pour l'instant — cochez les SKU que cet acheteur peut commander (Tous les SKU), ou partez du cycle précédent.",
      "tickedN": "{{n}} coché(s)",
      "exportForm": "Formulaire pour l'acheteur",
      "exportTip": "Le format de commande avec uniquement les SKU cochés et le prix de cet acheteur — l'acheteur renseigne la Qté commandée.",
      "tickFirst": "Cochez d'abord les SKU que cet acheteur peut commander",
      "saveFirst": "Enregistrez d'abord vos modifications",
      "importForm": "Importer le formulaire de l'acheteur",
      "markDone": "Terminé",
      "markChecked": "Marquer comme vérifiée",
      "reopen": "Rouvrir",
      "doneBy": "terminée par {{who}}, {{at}}",
      "checkedBy": "vérifiée par {{who}}, {{at}}",
      "unsaved": "{{n}} modification(s) non enregistrée(s).",
      "keepEditing": "Continuer à modifier",
      "discard": "Abandonner",
      "sheetLocked": "Cette fiche a été transmise — le responsable de Sales Planning peut toujours la modifier ou la rouvrir.",
      "notYours": "Le PIC de cet acheteur est {{pic}} — seuls lui ou le responsable de Sales Planning remplissent cette fiche.",
      "flagCycle": "Format de commande : {{rule}} — non ouvert ce cycle",
      "flagPrice": "Pas de prix pour cet acheteur",
      "formTitle": "{{cust}} — importer le formulaire de l'acheteur",
      "formBody": "Le formulaire que vous avez envoyé, rempli par l'acheteur (.xlsx) : ses colonnes Code SAP et Qté commandée sont lues. Chaque SKU du formulaire reprend sa quantité — une cellule vide signifie rien de commandé — et un SKU absent du formulaire reste inchangé. Rien n'est écrit tant que vous ne cliquez pas sur Écrire.",
      "formSummary": "Feuille « {{sheet}} » : {{rows}} lignes de SKU, {{total}} pcs commandées — {{n}} SKU modifié(s).",
      "formUnknown": "Absents du format de commande de ce cycle (non importés) : {{list}}",
      "formDup": "Listés deux fois (le premier est retenu) : {{list}}",
      "formNoChange": "Le formulaire correspond à ce que la fiche contient déjà.",
      "formWritten": "{{cust}} : {{n}} SKU écrit(s) depuis le formulaire.",
      "was": "Actuel",
      "now": "Sur le formulaire",
      "stockNote": "Saisissez les trois réserves de stock, puis allouez : les acheteurs sont servis selon la priorité de stock (Configuration › Acheteurs), chacun d'abord depuis KR Domestic, puis EUSU, puis KR SOP.",
      "notAllDone": "{{n}} fiche(s) pas encore terminée(s) — allouez à nouveau une fois qu'elles seront remises.",
      "countOver": "{{n}} ligne(s) d'acheteur reçoivent plus du stock qu'elles n'ont commandé.",
      "pool_kr_dom": "KR national",
      "pool_eusu": "EUSU (SOP)",
      "pool_kr_sop": "KR (SOP)",
      "avail": "Disponible",
      "fromStock": "Depuis le stock",
      "left": "Reste",
      "allocation": "Servi à",
      "onlyActive": "Uniquement les SKU avec commande ou stock",
      "stockTpl": "Fichier de stock",
      "stockImport": "Importer un fichier de stock",
      "allocate": "Allouer le stock",
      "allocateTitle": "Allouer le stock",
      "allocateGo": "Allouer",
      "allocateBody": "Chaque SKU en stock est redistribué : les acheteurs dans l'ordre ci-dessous, chacun prélevant d'abord sur KR Domestic, puis EUSU, puis KR SOP, autant qu'il a commandé et que la réserve le permet. Un chiffre corrigé à la main sur ces SKU est remplacé.",
      "allocateOrder": "Ordre de service (Configuration › Acheteurs › Priorité de stock) :",
      "allocated": "Stock alloué sur {{skus}} SKU : {{pcs}} pcs depuis le stock.",
      "allocEdit": "Allocation de {{sap}}",
      "allocTotal": "Servi {{served}} sur {{avail}} disponibles",
      "stockImportBody": "Les SKU du fichier reprennent ses trois chiffres (une cellule vide signifie aucun stock) ; les SKU qu'il ne liste pas restent inchangés. Téléchargez le fichier de stock pour voir la mise en page.",
      "stockSummary": "Feuille « {{sheet}} » : {{rows}} lignes — {{n}} SKU modifié(s).",
      "stockWritten": "Stock écrit pour {{n}} SKU.",
      "prodNote": "Requis = commande − stock servi, par acheteur, additionné. Attribuez à chaque SKU son usine et tout surplus de production ; les cartes indiquent les pièces prévues par usine.",
      "required": "Requis",
      "overbuild": "Surplus de production",
      "planned": "Planifié",
      "factory": "Usine",
      "comment": "Commentaire",
      "needsOnly": "Uniquement les SKU à produire",
      "allFactories": "Toutes les usines",
      "unassigned": "Non attribué",
      "byBuyer": "Par acheteur",
      "m_order": "Commandes",
      "m_stock": "Depuis le stock",
      "m_prod": "Production",
      "total_order": "Total des commandes",
      "total_stock": "Total depuis le stock",
      "total_prod": "Requis",
      "mNote_order": "Ambre : commandé sur un SKU non ouvert ce cycle, ou sans prix pour cet acheteur.",
      "mNote_stock": "Rouge : plus depuis le stock que ce que l'acheteur a commandé.",
      "mNote_prod": "Commande − depuis le stock, par acheteur.",
      "c_orders": "Total des commandes",
      "c_stock": "Depuis le stock",
      "c_prod": "Production requise",
      "c_ob": "Surplus de production",
      "c_planned": "Production planifiée",
      "c_amount": "Montant de la commande",
      "customerReport": "Rapport client — par catégorie de produit",
      "priceRule": "Montant = Qté × le prix de l'acheteur : acheteurs T2 au T2 FOB, distributeurs HEMA au prix HEMA DT, tous les autres au T1 FOB.",
      "sub_customers": "Acheteurs",
      "sub_cycles": "Calendrier",
      "addCustomer": "Ajouter un acheteur",
      "active": "Actif",
      "discontinued": "Arrêté",
      "custNote": "PIC = le collaborateur Sale OP qui remplit la fiche de l'acheteur. La tarification et l'entité déterminent la colonne de prix ; la colonne du carnet de commandes fait de lui un acheteur dans les fiches ; la priorité de stock est l'ordre dans lequel le stock est servi.",
      "cycleNote": "Le calendrier des commandes et des ex-factory (programme de commandes mensuel 2026). Un cycle clôturé ne peut pas être modifié.",
      "etas": "ETA KR/JP/SIN · AUS · EU · USA",
      "etaLine": "{{a}} · {{au}} · {{eu}} · {{us}}",
      "edit_customer": "Modifier l'acheteur",
      "edit_customer_new": "Ajouter un acheteur",
      "edit_cycle": "Modifier la commande {{date}}",
      "f_customer_key": "Acheteur",
      "f_pic_user_id": "PIC (Sale OP)",
      "f_country": "Pays",
      "f_pricing": "Tarification",
      "f_entity": "Entité Helinox",
      "f_status": "Statut",
      "f_sold_to": "Sold-To (SAP)",
      "f_ship_to": "Ship-To (SAP)",
      "f_grid_order": "Colonne du carnet de commandes",
      "f_alloc_priority": "Priorité de stock",
      "f_remark": "Remarque",
      "f_sap_code": "Nouveau SKU# (code SAP)",
      "f_product": "Produit",
      "f_skin_color": "Coloris de la toile",
      "f_frame_color": "Coloris du cadre",
      "f_selling_sku": "SKU# de vente",
      "f_upc": "UPC",
      "f_line_category": "Catégorie",
      "f_lineup": "Gamme",
      "f_order_cycle": "Cycle de commande",
      "f_noos": "NOOS=Never Out of Stock (SKU permanent)",
      "f_product_category": "Catégorie de produit",
      "f_ex_factory_loc": "Lieu d'ex-factory",
      "f_carton_qty": "Qté par carton",
      "f_hts_usa": "Code HTS États-Unis",
      "f_hts_eu": "Code HTS Europe",
      "f_ctn_size": "Dimensions du carton (mm) / type",
      "f_frame_category": "Catégorie de cadre",
      "f_price_t1": "T1 FOB pour les entités globales et les clients Asie",
      "f_price_hema_dt": "T1 FOB uniquement pour les DT HEMA",
      "f_price_t2": "T2 FOB pour les non-distributeurs",
      "f_season": "Saison",
      "f_fc_due": "Échéance FC",
      "f_order_due": "Échéance de commande",
      "f_ex_factory": "Sortie usine",
      "f_items_note": "Articles",
      "f_eta_asia": "ETA KR/JP/SIN",
      "f_eta_aus": "ETA Australie",
      "f_eta_eu": "ETA Europe",
      "f_eta_usa": "ETA États-Unis"
    },
    "nav": {
      "aiPowered": "Les synthèses et réponses de ce portail sont rédigées par Claude, l'IA d'Anthropic",
      "report": "Rapport",
      "salesReport": "Rapport des ventes",
      "saleOperation": "Autres outils",
      "development": "Développement",
      "salesOperation": "Opérations commerciales",
      "production": "Production",
      "productSalesDashboard": "Tableau de bord des ventes par produit",
      "salesReportDashboard": "Performance commerciale",
      "marketingDashboard": "Tableau de bord marketing",
      "dataExplorer": "Explorateur de données",
      "salesDataLoad": "Mise à jour des données de ventes",
      "inventoryReport": "Global Inventory Report",
      "poleInventory": "Clôture du stock d'arceaux",
      "eusuStock": "Stock EUSU hors vente",
      "inventoryDashboard": "Tableau de bord du stock",
      "poleDashboard": "Tableau de bord du stock d'arceaux",
      "demandForecastDashboard": "Tableau de bord des prévisions de demande",
      "autoJobs": "Sales Op. Python",
      "dashboard": "Tableau de bord",
      "projectTracker": "Suivi des projets",
      "documents": "E-Docs",
      "documentLibrary": "Bibliothèque",
      "sampleTracker": "Suivi des échantillons",
      "partnerSamples": "Suivi des échantillons DAC",
      "ticketStation": "Ticket Station",
      "userManual": "Manuel d'utilisation",
      "projectApproval": "Approbation des projets",
      "nfcTokenPortal": "Portail de jetons NFC",
      "pricingCalculator": "Calculateur de prix Collab",
      "ceoOffice": "Bureau du CEO",
      "gtm": "GTM",
      "finance": "Finance",
      "cashSetup": "Configuration",
      "cashImport": "Soumettre",
      "cashApproval": "Approbation",
      "courierRequests": "Demandes de courrier express",
      "courierApproval": "Approbation courrier express",
      "courier": "Courrier express",
      "collabPricing": "Prix Collab",
      "arrangeOpen": "Organiser le menu",
      "arrangeTitle": "Organisez votre menu",
      "arrangeHint": "Faites glisser un dossier ou une entrée, ou utilisez les flèches. Vous seul voyez cet ordre.",
      "arrangeUp": "Monter {{name}}",
      "arrangeDown": "Descendre {{name}}",
      "arrangeDone": "Terminé",
      "arrangeCancel": "Annuler",
      "arrangeReset": "Réinitialiser",
      "arrangeResetHint": "Rétablir l'ordre d'origine du portail",
      "arrangeIsDefault": "C'est déjà l'ordre d'origine du portail",
      "arrangeFailed": "Impossible d'enregistrer l'ordre du menu",
      "arrangeUnfold": "Afficher les entrées de {{name}}",
      "arrangeFold": "Masquer les entrées de {{name}}",
      "hevnAdmin": "Administration HEVN",
      "driverLog": "Journal du chauffeur",
      "salesPlanning": "Planification des ventes",
      "splFormat": "Format de commande",
      "splOrders": "Fiches de commande",
      "splStock": "Allocation du stock",
      "splProduction": "Allocation aux usines",
      "splOverview": "Vue d'ensemble des commandes",
      "splSetup": "Configuration du planning",
      "cashWeekly": "Rapport de trésorerie hebdomadaire",
      "cashPlan": "Plan de trésorerie mensuel",
      "cashMonthEnd": "Rapprochement de fin de mois",
      "cashReport": "Rapport de trésorerie",
      "gtmProgrammes": "Programmes GTM",
      "gtmApproval": "Approbation GTM",
      "gtmTracker": "Suivi GTM",
      "ceoFolder": "CEO",
      "benchmarkLibrary": "Fiches de coûts Inline",
      "pricingApproval": "Approbation des prix",
      "costing": "Calcul des coûts",
      "opaSct": "OPA / SCT",
      "sctSummary": "Synthèse SCT"
    },
    "cash": {
      "title": "Configuration",
      "sub": "Les listes que lit chaque rapport de trésorerie : entités, comptes bancaires, semaines, taux de change, catégories de dépenses, et qui prépare, vérifie et approuve. Une modification n'entre en vigueur qu'une fois approuvée par le Group CFO.",
      "loading": "Chargement…",
      "tab_entity": "Entité",
      "tab_account": "Compte",
      "tab_user": "Utilisateur",
      "tab_period": "Période",
      "tab_fx": "Taux de change",
      "tab_expense": "Catégorie de dépenses",
      "tab_account_type": "Type de compte",
      "tab_role": "Rôle",
      "tab_notice": "Notification",
      "tab_flow": "Flux",
      "tab_changes": "Modifications en attente",
      "tab_history": "Historique",
      "tab_setting": "Paramètres",
      "tab_currency": "Devise",
      "f_code": "Code",
      "f_name": "Nom",
      "f_tax_code": "Numéro fiscal / code d'identification",
      "f_legal_address": "Adresse légale",
      "f_country": "Pays",
      "f_ho_address": "Adresse du siège",
      "f_acc_mail": "E-mail administration / comptabilité",
      "f_min_balance_sgd": "Solde minimum (SGD)",
      "f_status": "Statut",
      "f_seq": "Ordre",
      "f_account_id": "ID du compte",
      "f_entity_code": "Entité",
      "f_account_no": "N° de compte",
      "f_currency": "Devise",
      "f_bank_name": "Nom de la banque",
      "f_account_type": "Type de compte",
      "f_restricted": "Restreint",
      "f_fixed_deposit": "Dépôt à terme",
      "f_remarks": "Remarques",
      "f_user_code": "Code",
      "f_mail": "E-mail",
      "f_role_key": "Rôle",
      "f_year": "Année",
      "f_week": "Semaine",
      "f_week_ending": "Fin de semaine (vendredi)",
      "f_submit_deadline": "Date limite de soumission",
      "f_category_type": "Type",
      "f_describe": "Description",
      "f_type_name": "Type",
      "f_default_restricted": "Par défaut : restreint",
      "f_default_fd": "Par défaut : dépôt à terme",
      "f_action": "Action",
      "f_right_scope": "Droit",
      "f_restriction": "Restriction (séparation des tâches)",
      "f_notice_id": "ID de la notification",
      "f_header": "En-tête",
      "f_content": "Contenu",
      "f_report": "Rapport",
      "f_send_to_role": "Envoyer à (rôle)",
      "f_send_day": "Jour d'envoi",
      "f_send_time": "Heure d'envoi",
      "f_setting_value": "Valeur",
      "f_rate": "Taux",
      "f_week_code": "Semaine",
      "f_trigger_key": "Déclencheur",
      "tab_log": "Journal des notifications",
      "trg_report_open": "Rapport hebdomadaire ouvert (planifié)",
      "trg_due_soon": "Rappel d'échéance (planifié)",
      "trg_missing": "Soumission manquante (planifié)",
      "trg_plan_update": "Mise à jour du plan à 13 semaines (planifié)",
      "trg_month_open": "Rapprochement de fin de mois ouvert (planifié)",
      "trg_upload_errors": "L'import contient des erreurs",
      "trg_submitted": "Envoyé pour vérification",
      "trg_reviewed": "Vérifié",
      "trg_approved": "Approuvé par le Group CFO",
      "trg_closed": "Clôturé par le CEO",
      "trg_returned": "Renvoyé",
      "trg_below_min": "Solde inférieur au minimum",
      "trg_setup_submitted": "Configuration envoyée pour approbation",
      "mailHeld": "E-mails suspendus",
      "mailLive": "E-mails actifs",
      "mailHeldLine": "Les e-mails du Cash Report sont SUSPENDUS pendant la construction du module : chaque notification ci-dessous a été générée et consignée, et aucune n'a été envoyée à qui que ce soit.",
      "mailLiveLine": "Les e-mails du Cash Report sont actifs : les notifications ci-dessous ont été envoyées.",
      "logRun": "Exécuter les notifications planifiées maintenant",
      "logRunAt": "Exécuter comme à cet instant",
      "logAtWhy": "Laissez vide pour l'instant, ou choisissez un moment pour voir ce qui partirait alors (uniquement tant que les e-mails sont suspendus). Heure du serveur.",
      "logRan_one": "Exécuté comme au {{at}} : {{count}} notification générée.",
      "logRan_other": "Exécuté comme au {{at}} : {{count}} notifications générées.",
      "logEmpty": "Aucun e-mail du Cash Report n'a encore été généré.",
      "logWhen": "Quand",
      "logStatus": "Statut",
      "logWhat": "Notification",
      "logFor": "Entité · période",
      "logTo": "À",
      "logSubject": "Objet",
      "log_held": "Suspendu",
      "log_sent": "Envoyé",
      "log_failed": "Échec",
      "log_claimed": "Envoi en cours…",
      "log_tester": "Envoyé au testeur",
      "testAs": "Tester en tant que",
      "testOff": "Désactivé — mes propres rôles",
      "testOnNote": "Test en tant que {{role}} : chaque étape effectuée est enregistrée comme « (test en tant que {{role}}) ». Disponible uniquement tant que les e-mails Cash sont suspendus.",
      "testOffNote": "Pendant la construction : jouez le rôle du préparateur ou du vérificateur pour faire parcourir à un rapport ses deux étapes.",
      "logSim": "simulé",
      "logSimWhy": "Généré par Exécuter comme à un instant choisi. N'utilise pas la vraie notification de ce jour-là.",
      "s_base_currency": "Devise de base",
      "s_rate_source": "Source des taux",
      "s_rate_date": "Date des taux",
      "state_clean": "En vigueur",
      "state_draft": "Brouillon — non envoyé",
      "state_submitted": "En attente du Group CFO",
      "bandClean": "Tout ce qui figure dans ces onglets est approuvé et en vigueur.",
      "bandEmpty": "Rien n'a encore été approuvé. Importez le classeur de configuration pour commencer, puis envoyez-le au Group CFO.",
      "bandCounts": "{{insert}} nouveau(x) · {{update}} modifié(s) · {{delete}} supprimé(s) — pas en vigueur tant que le Group CFO n'a pas approuvé",
      "sentBy": "envoyé par {{by}} le {{at}}",
      "returned": "Renvoyé par {{by}} le {{at}} :",
      "bootstrap": "La liste des utilisateurs ne contient pas encore de ligne approuvée : vous agissez donc en tant qu'administrateur Cash Report parce que vous êtes administrateur du portail. Cela prend fin dès que la première liste est approuvée.",
      "provisional": "Rien n'est encore approuvé : vous voyez donc cet écran avec le rôle que vous attribue la liste d'utilisateurs proposée ({{roles}}). Il devient définitif dès que le Group CFO approuve la liste.",
      "import": "Importer Excel",
      "send": "Envoyer au Group CFO",
      "approve": "Approuver",
      "notePh": "Note pour le Group CFO (facultatif)",
      "fixFirst": "Les lignes comportant une erreur de contrôle des données doivent être corrigées avant l'envoi.",
      "sent": "Envoyé au Group CFO. Rien ne change tant qu'il n'est pas approuvé.",
      "approved": "Approuvé — les modifications sont maintenant en vigueur.",
      "rejected": "Renvoyé à l'administrateur avec votre motif.",
      "imported": "Importé : {{insert}} nouveau(x), {{update}} modifié(s), {{same}} déjà identique(s). Ils sont dans le brouillon, pas encore en vigueur.",
      "sumErrors_one": "{{count}} ligne avec une erreur de contrôle des données",
      "sumErrors_other": "{{count}} lignes avec une erreur de contrôle des données",
      "sumWarns_one": "{{count}} ligne avec un avertissement",
      "sumWarns_other": "{{count}} lignes avec un avertissement",
      "onlyIssues": "Uniquement les lignes avec un message de contrôle des données",
      "onlyChanged": "Uniquement les lignes modifiées",
      "rows_one": "{{count}} ligne",
      "rows_other": "{{count}} lignes",
      "search": "Rechercher…",
      "clear": "Effacer",
      "addRow": "Ajouter une ligne",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "edit": "Modifier",
      "remove": "Retirer",
      "undo": "Annuler cette modification",
      "was": "Valeur approuvée",
      "choose": "Choisir…",
      "auto": "attribué à l'enregistrement",
      "autoHint": "Le code d'une nouvelle ligne est attribué par le portail (Entity-01, EC-0001, N-001…) et n'est jamais réutilisé.",
      "dataCheck": "Contrôle des données",
      "chkOk": "OK",
      "chkError": "Erreur",
      "chkWarn": "Avertissement",
      "op_insert": "Nouveau",
      "op_update": "Modifié",
      "op_delete": "Suppression",
      "noRows": "Aucune ligne.",
      "yes": "Oui",
      "no": "Non",
      "week": "Semaine",
      "allWeeks": "Toutes les semaines",
      "year": "Année",
      "addYear": "Ajouter toutes les semaines de",
      "addWeeks": "Ajouter des semaines",
      "weeksAdded": "{{count}} semaines de {{year}} ajoutées au brouillon.",
      "fxHint": "Taux = unités de la devise de base pour 1 unité de la devise, donc montant en SGD = montant en devise étrangère × taux. Un taux par semaine ; le Template 1 lit celui de sa propre semaine.",
      "newCurrency": "p. ex. CHF",
      "addCurrency": "Ajouter une devise",
      "editRates": "Modifier les taux",
      "saveRates": "Enregistrer {{count}} cellules",
      "fxSync": "Synchroniser depuis NetSuite",
      "fxSyncTitle": "Lit le taux du vendredi de chaque semaine depuis NetSuite. Ils sont appliqués immédiatement, sans passer par le Group CFO ; un taux saisi ici n'est pas modifié.",
      "fxLastSync": "Dernier taux reçu de NetSuite : {{when}}",
      "fxNeverSynced": "Pas encore synchronisé depuis NetSuite",
      "fxSynced": "NetSuite : {{written}} taux écrits, {{unchanged}} déjà à jour, sur {{weeks}} semaines.",
      "fxKeptTyped": "{{n}} taux saisis dans Configuration ont été conservés ({{list}}).",
      "fxMissing": "NetSuite n'a pas de taux pour {{n}} ({{list}}).",
      "fxFromNetsuite": "Depuis NetSuite — taux du {{day}}",
      "fxBase": "Devise de base",
      "fxTyped": "Saisi dans Configuration et approuvé — la synchronisation NetSuite n'y touche pas",
      "flowReport": "Rapport",
      "step": "Étape {{n}}",
      "rep_weekly": "Rapport de trésorerie hebdomadaire",
      "rep_13w": "Plan de trésorerie à 13 semaines",
      "rep_month": "Rapprochement de fin de mois",
      "rep_setup": "Configuration",
      "flowPrep": "Préparateur : prépare",
      "flowReview": "Réviseur : relit et valide",
      "flowCfo": "Group CFO : approuve",
      "flowCeo": "CEO : approuve et clôture",
      "flowAdmin": "Admin : effectue la Configuration",
      "flowNote": "Les trois rapports suivent ce circuit (Finance › Rapport de trésorerie : Rapport de trésorerie hebdomadaire, Plan de trésorerie à 13 semaines, Rapprochement de fin de mois) — la validation du Réviseur est la dernière étape, et le rapport apparaît dans le Rapport de trésorerie dès qu'elle est donnée. L'onglet Notification indique ce qui est envoyé, à qui et quand — un jour et une heure d'envoi pour les envois planifiés, un Événement pour ceux déclenchés par une étape — et le journal des notifications affiche chaque e-mail généré.",
      "noChanges": "Aucune modification en attente.",
      "list": "Liste",
      "code": "Code",
      "change": "Modification",
      "what": "Ce qui change",
      "by": "Par",
      "noHistory": "Aucune modification approuvée pour le moment.",
      "histLine": "{{n}} modifications · envoyées par {{by}} {{at}} · approuvées par {{cfo}} {{on}}",
      "histBuild": "{{n}} modifications · appliquées pour la mise en place par {{by}} {{on}} — NON approuvées par le Group CFO"
    },
    "cashr": {
      "title": "Rapport de trésorerie",
      "reviewedOnly": "Seuls les rapports validés par leur Réviseur affichent des chiffres ici."
    },
    "cashw": {
      "h_balance": "Solde ({{ccy}})",
      "h_balanceOrig": "Solde (devise du compte)",
      "h_amountIn": "Montant ({{ccy}})",
      "baseLabel": "Afficher en",
      "baseWhy": "Chaque montant est converti depuis le SGD au taux de la semaine dans Configuration (NetSuite, vendredi) ; le solde d'un compte reste dans sa propre devise.",
      "baseRate": "Affiché au taux de la semaine dans Configuration : 1 {{ccy}} = {{rate}} SGD.",
      "noBaseRate": "Pas encore de taux {{ccy}} pour cette semaine dans Configuration — affiché en SGD.",
      "balanceWhy": "Afficher la trésorerie par compte bancaire",
      "balanceNote": "Solde = la trésorerie détenue par les banques à la fin de la semaine. Disponible = Solde − Restreint − Dépôt à terme. Le solde d'un compte est dans sa devise, comme sur le relevé ; tous les autres montants sont convertis au taux de la semaine dans Configuration (NetSuite). La variation porte sur les entités ayant déclaré les deux semaines.",
      "tot_balance": "Solde",
      "title": "Rapport de trésorerie · Hebdomadaire",
      "sub": "Chaque entité importe le Template 1 de la semaine sur l'écran Soumettre ; le rapport passe ensuite du Préparateur au Réviseur et s'affiche ici dès que le Réviseur l'a validé. Tous les chiffres sont en SGD et calculés par le portail à partir des données saisies.",
      "prevWeek": "Semaine précédente",
      "nextWeek": "Semaine suivante",
      "weekLine": "Semaine se terminant le {{end}} · rapport attendu le {{due}}",
      "closedWeek": "Clôturée",
      "noRates": "Pas encore de taux de change pour cette semaine dans Configuration — il arrive de NetSuite dès que le taux du vendredi est publié. D'ici là, les chiffres ne peuvent pas être affichés en SGD et aucun rapport ne peut être envoyé.",
      "h_entity": "Entité",
      "h_opening": "Ouverture",
      "h_inflow": "Entrées",
      "h_outflow": "Sorties",
      "h_closing": "Clôture",
      "h_restricted": "Restreint",
      "h_fd": "Dépôt à terme",
      "h_available": "Disponible",
      "h_change": "Variation vs précédente",
      "h_belowMin": "Sous le solde minimum",
      "h_status": "Statut",
      "h_no": "N°",
      "h_category": "Catégorie",
      "h_memo": "Mémo",
      "h_amount": "Montant en SGD",
      "h_account": "Compte",
      "h_ccy": "Devise",
      "h_closingStmt": "Clôture (relevé)",
      "h_diff": "Écart",
      "h_rate": "Taux vers SGD",
      "h_closingSgd": "Clôture en SGD",
      "h_files": "Fichiers",
      "h_kind": "Type",
      "h_other": "Autre entité",
      "h_ref": "Référence",
      "groupNote": "Hors opérations des entités entre elles",
      "groupCount": "{{n}} entités sur {{of}} validées",
      "unmatched": "Intragroupe non compensé : {{amt}} SGD",
      "unmatchedWhy": "Ce que les entités déclarent avoir reçu l'une de l'autre et s'être payé mutuellement ne s'équilibre pas à zéro — un côté ne l'a pas encore déclaré, ou le montant est en transit. La clôture est la trésorerie détenue par les banques ; elle n'est donc pas égale à Ouverture + Entrées − Sorties, à hauteur de ce montant.",
      "nothingYet": "Aucune entité n'a encore importé de fichier cette semaine.",
      "yearTitle": "Toutes les semaines de {{year}}",
      "yearPick": "Année",
      "h_weekEntity": "Entité / Compte",
      "h_bank": "Banque",
      "h_acctNo": "N° de compte",
      "h_acctType": "Type de compte",
      "h_acctFlag": "Restreint / Dépôt à terme",
      "weekTitle": "Semaine {{code}} · se terminant le {{end}}",
      "weekOpenWhy": "Ouvrir ou fermer les entités de cette semaine",
      "weekPickWhy": "En faire la semaine affichée — ses graphiques, son Top 3 et ses rapports",
      "weekNothing": "Rien de déclaré",
      "yearLoading": "Chargement du reste de l'année…",
      "yearNote": "Une ligne GROUP par semaine de l'année ; cliquez sur ▸ pour ouvrir les entités d'une semaine, sur le ▸ d'une entité pour ses comptes, et sur un code de semaine pour en faire la semaine affichée.",
      "origClosing": "Clôture en {{ccy}} : {{amt}}",
      "inCcy": "En {{ccy}}",
      "origWhy": "En {{ccy}}, la devise propre du compte, comme sur le relevé bancaire.",
      "notUploaded": "Pas encore importé.",
      "notReviewed": "Pas encore validé — ses chiffres s'affichent dès que le Réviseur l'a validé.",
      "expandWhy": "Afficher la trésorerie par compte bancaire",
      "errorsN_one": "{{count}} erreur de Contrôle des données",
      "errorsN_other": "{{count}} erreurs de Contrôle des données",
      "below": "Sous le seuil",
      "belowWhy": "La trésorerie disponible est inférieure au solde minimum de {{min}} SGD défini pour cette entité.",
      "noMinWhy": "Aucun solde minimum n'est défini pour cette entité dans Configuration.",
      "interGroup": "Opérations intragroupe",
      "interGroupWhy": "Avec d'autres entités Helinox — exclues de la ligne GROUP.",
      "restrictedTag": "Restreint",
      "fdTag": "Dépôt à terme",
      "noTxn": "Aucune opération",
      "sgdNote": "SGD = la devise propre du compte × le taux de la semaine dans Configuration (NetSuite). La clôture d'un compte dans sa propre devise figure sur sa ligne. Les Entrées et Sorties excluent les virements intra-entité ; Disponible = Clôture − Restreint − Dépôt à terme.",
      "topTitle": "Top 3",
      "top_spend": "Top 3 des principales dépenses de la semaine",
      "top_payable": "Top 3 des paiements dus la semaine prochaine",
      "noTops": "Aucune entité n'a encore déclaré cette semaine",
      "expandAll": "Tout développer",
      "collapseAll": "Tout réduire",
      "st_none": "Non importé",
      "st_open": "Préparé — non envoyé",
      "st_returned": "Renvoyé",
      "st_submitted": "Chez le Réviseur",
      "st_reviewed": "Validé",
      "st_approved": "Approuvé",
      "st_closed": "Clôturé",
      "by_submitted": "envoyé par {{by}} {{at}}",
      "by_reviewed": "validé par {{by}} {{at}}",
      "by_approved": "approuvé par {{by}} {{at}}",
      "by_closed": "clôturé par {{by}} {{at}}",
      "by_returned": "renvoyé par {{by}} {{at}}",
      "weekEnding": "semaine se terminant le {{d}}",
      "step_prep": "Préparateur",
      "step_review": "Réviseur",
      "step_cfo": "Group CFO",
      "step_ceo": "CEO",
      "notYet": "Pas encore",
      "returnedBy": "Renvoyé par {{by}} le {{at}} :",
      "weekClosed": "Cette semaine est clôturée dans Configuration — son rapport peut être consulté, mais pas importé.",
      "weekClosedReturned": "Cette semaine est clôturée dans Configuration, mais un rapport renvoyé peut encore être corrigé et envoyé de nouveau.",
      "selfBlocked": "Vous avez importé cette version ou effectué une étape précédente sur ce rapport ; l'étape « {{step}} » doit donc être réalisée par quelqu'un d'autre.",
      "tooBig": "Un fichier ne peut pas dépasser 3,5 Mo. Enregistrez le relevé bancaire en PDF plus léger, ou joignez-le en plusieurs parties.",
      "changeOver_one": "Sur la {{count}} entité ayant déclaré les deux semaines",
      "changeOver_other": "Sur les {{count}} entités ayant déclaré les deux semaines",
      "template": "Télécharger le modèle",
      "upload": "Importer un fichier",
      "uploadAgain": "Importer à nouveau",
      "notePh": "Note pour le Réviseur (facultatif)",
      "submit": "Envoyer au Réviseur",
      "fixFirst": "Corrigez les erreurs du Contrôle des données avant l'envoi.",
      "btn_review": "Relire et valider",
      "btn_approve": "Approuver",
      "btn_close": "Approuver et clôturer",
      "sendBack": "Renvoyer",
      "reopen": "Rouvrir pour correction",
      "reopenWhy": "Validé. La réouverture le renvoie au Préparateur avec votre motif ; ses chiffres quittent le Rapport de trésorerie jusqu'à une nouvelle validation.",
      "done_submit": "Envoyé au Réviseur.",
      "done_review": "Relu et validé — il apparaît désormais dans le Rapport de trésorerie.",
      "done_approve": "Approuvé — il est maintenant chez le CEO.",
      "done_close": "Approuvé et clôturé.",
      "done_return": "Renvoyé au Préparateur avec votre motif.",
      "mailHeld": "(Aucun e-mail n'a été envoyé : les e-mails du Rapport de trésorerie sont suspendus pendant la mise en place du module.)",
      "uploadedOk": "Version {{v}} importée.",
      "replacedOk": "Version {{v}} importée — elle a passé le Contrôle des données et remplace la version {{old}} chez le Réviseur.",
      "correctWhileReview": "Chez le Réviseur (version {{v}}). Vous pouvez encore la corriger, ci-dessous ou en important un fichier corrigé : une fois enregistrée, si son Contrôle des données est réussi, elle remplace la version lue par le Réviseur.",
      "uploadedErrors_one": "Version {{v}} importée — {{count}} erreur de Contrôle des données à corriger avant l'envoi.",
      "uploadedErrors_other": "Version {{v}} importée — {{count}} erreurs de Contrôle des données à corriger avant l'envoi.",
      "nothingUploaded": "Rien de saisi pour le moment.",
      "sumErrors_one": "{{count}} erreur de Contrôle des données",
      "sumErrors_other": "{{count}} erreurs de Contrôle des données",
      "sumWarns_one": "{{count}} avertissement",
      "sumWarns_other": "{{count}} avertissements",
      "versionLine": "Version {{v}} affichée",
      "accountsTitle": "Comptes",
      "transfersTitle": "Virements",
      "filesTitle": "Relevés bancaires et captures d'écran",
      "versionsTitle": "Versions — importées ou saisies",
      "historyTitle": "Historique et commentaires",
      "current": "Dans le circuit",
      "rateFrom_setup": "Taux issu de Configuration",
      "rateFrom_base": "Devise de base",
      "tot_opening": "Ouverture",
      "tot_inflow": "Entrées",
      "tot_outflow": "Sorties",
      "tot_closing": "Clôture",
      "tot_restricted": "Restreint",
      "tot_fixed_deposit": "Dépôt à terme",
      "tot_available": "Disponible",
      "tr_internal": "Intra-entité",
      "tr_group": "Intragroupe",
      "kind_statement": "Relevé",
      "kind_balance": "Capture du solde",
      "kind_other": "Autre",
      "wholeEntity": "Toute l'entité",
      "attach": "Joindre un fichier",
      "attached": "Fichier joint.",
      "removeFile": "Supprimer ce fichier",
      "noFiles": "Aucun fichier joint.",
      "commentPh": "Écrire un commentaire…",
      "comment": "Commenter",
      "noEvents": "Rien ne s'est encore passé.",
      "waitingYou": "En attente de votre action",
      "waitingOpen": "Ouvrez-le dans Approbation pour décider",
      "ev_upload": "a importé la version {{v}} depuis un fichier",
      "ev_entry": "a enregistré la version {{v}}, corrigée sur le Portal",
      "changesAgainst": "Modifié par rapport à la version {{v}} — {{n}}",
      "noChange": "Aucun chiffre modifié par rapport à la version {{v}}.",
      "moreChanges": "Afficher {{n}} de plus",
      "fewerChanges": "Afficher moins",
      "changesCut": "…et {{n}} de plus.",
      "ev_discard": "a annulé la version {{v}}",
      "cancelled": "Annulé",
      "ev_submit": "a envoyé la version {{v}} au Réviseur",
      "ev_review": "a relu et validé",
      "ev_approve": "l'a approuvé",
      "ev_close": "l'a approuvé et clôturé",
      "ev_return": "l'a renvoyé",
      "ev_comment": "a commenté",
      "ev_file": "a joint un fichier",
      "ev_unfile": "a supprimé un fichier"
    },
    "cashp": {
      "title": "Rapport de trésorerie · Plan de trésorerie à 13 semaines",
      "sub": "Chaque entité planifie treize semaines à l'avance en SGD (Template 2), et le plan est confronté à ce que disent ensuite ses Rapports de trésorerie hebdomadaires. Un nouveau plan chaque semaine ; les mêmes deux étapes que le rapport hebdomadaire.",
      "startsLine": "Plan débutant {{week}} (semaine se terminant le {{end}}), jusqu'à {{last}}",
      "h_week": "N° de semaine",
      "h_end": "Fin de semaine",
      "h_planOpen": "Ouverture (clôture précédente)",
      "h_planIn": "Entrées prévues",
      "h_planOut": "Sorties prévues",
      "h_planClose": "Clôture prévue (attendue)",
      "h_actIn": "Entrées réelles",
      "h_actOut": "Sorties réelles",
      "h_actClose": "Clôture réelle",
      "h_variance": "Écart vs plan (clôture)",
      "h_weekly": "Rapport hebdomadaire",
      "h_reported": "Déclaré",
      "h_comment": "Commentaire",
      "h_planClose13": "Clôture prévue, semaine 13",
      "h_planOpen1": "Ouverture, semaine 1",
      "h_planIn13": "Entrées prévues, 13 semaines",
      "h_planOut13": "Sorties prévues, 13 semaines",
      "noReviewed": "Aucun plan validé pour le moment",
      "reportedOf": "{{n}} déclarés",
      "noPlan": "Aucune entité n'a encore importé de plan débutant cette semaine.",
      "openWhy": "Ouvrir ou fermer son plan pour toute l'année",
      "groupPlanned": "Plans validés : {{n}} entités sur {{of}}",
      "listHint": "Où en est le plan de chaque entité pour cette semaine. Le graphique et le tableau ci-dessus suivent la sélection.",
      "pickLabel": "Afficher",
      "pickGroup": "GROUP (toutes les entités)",
      "pickGroupWhy": "toutes les entités, additionnées",
      "filtersTitle": "Filtrer le plan",
      "filterEntities": "Entités",
      "filtersHint": "Choisissez GROUP, une entité ou plusieurs (elles s'additionnent), puis l'année. Le graphique et le tableau de 53 semaines ci-dessous suivent les deux.",
      "oneYear": "Les plans couvrent une seule année pour l'instant",
      "weeksShown": "{{count}} semaines sur {{of}}",
      "h_planFrom": "Issu du plan",
      "planFromWhy": "Lu depuis le plan débutant {{week}} — le plan le plus récent couvrant cette semaine",
      "plannedBy_one": "{{count}} entité",
      "plannedBy_other": "{{count}} entités",
      "yearOf": "toutes les semaines de {{year}}",
      "yearNote": "Toutes les semaines de l'année. Une semaine est lue depuis le plan le plus récent qui la couvre — une semaine écoulée depuis le plan déposé pour elle, une semaine à venir depuis la prévision la plus récente — et « Issu du plan » nomme ce plan.",
      "groupTitle_one": "GROUP — {{count}} entité planifiée",
      "groupTitle_other": "GROUP — somme des {{n}} entités ayant planifié cette semaine",
      "groupNote": "GROUP additionne les entités ayant planifié cette semaine. Un réel n'est compté que lorsque chacune d'elles a déclaré cette semaine, de sorte qu'un écart ne compare jamais les réels de certaines entités à tous leurs plans.",
      "entityNote": "Les réels sont les chiffres propres du Rapport de trésorerie hebdomadaire en SGD (entrées et sorties hors virements intra-entité, clôture = clôtures des banques). Écart = clôture réelle − clôture prévue.",
      "panelHeading": "Plan débutant {{week}}",
      "opening": "Trésorerie d'ouverture (SGD)",
      "closing13": "Clôture prévue, semaine 13 (SGD)"
    },
    "cashm": {
      "title": "Rapport de trésorerie · Rapprochement de fin de mois",
      "sub": "Chaque entité rapproche tous ses comptes en fin de mois (Template 3) : la clôture du relevé bancaire mensuel avec la clôture de fin de semaine de son Rapport de trésorerie hebdomadaire (la dernière fin de semaine au plus tard à la fin du mois), et ce qui a bougé entre les deux dates. Rapprochement = Écart − Entrées + Sorties, et il doit être égal à 0. Les mêmes deux étapes que le rapport hebdomadaire.",
      "monthLine": "{{month}} · fin de mois {{end}}",
      "open": "Ouvrir pour rapprochement",
      "notEnded": "Pas encore terminé",
      "notEndedLine": "Ce mois n'est pas encore terminé — son rapprochement s'ouvre dès qu'il l'est.",
      "ruleHead": "Fin de semaine : {{week}} ({{end}}).",
      "h_reconciled": "Comptes rapprochés",
      "h_totalSgd": "Clôture de fin de mois (SGD)",
      "h_monthEnd": "Clôture de fin de mois",
      "h_weekEnd": "Clôture de fin de semaine ({{week}})",
      "h_variance": "Écart",
      "netOff": "Compensation",
      "statusGroup": "Statut",
      "h_netIn": "Entrées compensées",
      "h_netOut": "Sorties compensées",
      "h_reconcile": "Rapprochement",
      "accountsTitle": "Comptes",
      "reconciled": "Comptes rapprochés",
      "totalSgd": "Clôture de fin de mois (SGD)",
      "unconvertedWhy": "Les comptes sans taux dans Configuration pour la fin de semaine sont exclus du total en SGD.",
      "monthEndOn": "fin de mois {{d}}",
      "st_submitted": "Préparé",
      "st_reviewed": "Validé",
      "st_approved": "Approuvé",
      "st_closed": "Clôturé",
      "unconverted": "{{n}} sans taux",
      "allReconciled": "Les {{n}} sont rapprochés",
      "reportNote": "La ligne de chaque entité indique sa clôture de fin de mois en SGD ainsi que qui a préparé et validé son rapprochement ; ses comptes suivent, dans leur propre devise. Cliquez sur une entité pour ouvrir son rapprochement."
    },
    "cashq": {
      "title": "Approbation",
      "sub": "Rapports envoyés par les Préparateurs : Rapport de trésorerie hebdomadaire, Plan de trésorerie à 13 semaines et Rapprochement de fin de mois. Sélectionnez-en un pour le lire, puis validez-le ou renvoyez-le. Une fois validé par le Réviseur, le rapport apparaît dans le Rapport de trésorerie. Un rapport renvoyé reste dans En cours jusqu'à ce qu'il soit envoyé de nouveau.",
      "tab_waiting": "En attente de votre action",
      "tab_progress": "En cours",
      "tab_closed": "Validés",
      "rows_one": "{{count}} rapport",
      "rows_other": "{{count}} rapports",
      "clear": "Réinitialiser le tri et les filtres",
      "colReport": "Rapport",
      "colEntity": "Entité",
      "colPeriod": "Période",
      "colStatus": "Statut",
      "colSentBy": "Envoyé par",
      "colSentAt": "Envoyé le",
      "colUpdated": "Dernière modification",
      "empty_waiting": "Rien n'attend votre décision.",
      "empty_progress": "Aucun rapport n'est en cours d'étapes ni de retour chez son Préparateur.",
      "empty_closed": "Aucun rapport n'a encore été validé.",
      "notListed": "Ce rapport n'est pas dans votre file — il n'a peut-être pas encore été envoyé, ou vous ne pouvez pas le voir."
    },
    "cashi": {
      "title": "Soumettre",
      "sub": "Téléchargez chaque modèle pour votre entité, remplissez-le, importez-le, vérifiez-le et envoyez-le au Réviseur.",
      "entity": "Entité",
      "yoursOne": "Votre entité, d'après la liste des utilisateurs dans Configuration.",
      "yoursMany": "Vous êtes Préparateur de {{n}} entités — choisissez celle que vous saisissez.",
      "notPreparer": "Vous n'êtes Préparateur d'aucune entité dans la liste des utilisateurs du Rapport de trésorerie : vous pouvez consulter et télécharger ici, mais pas importer. Les Préparateurs sont désignés dans Configuration › Utilisateur.",
      "noEntity": "Aucune entité à afficher.",
      "checkPassed": "Contrôle des données réussi",
      "saveOrCancel": "Enregistrez ou annulez d'abord vos modifications, puis importez.",
      "openReport": "Ouvrir le {{report}}",
      "pointer": "Ce rapport s'importe et s'envoie sur l'écran Soumettre ({{tpl}}).",
      "pointerReturned": "Renvoyé au Préparateur — il se corrige et se renvoie sur l'écran Soumettre.",
      "goImport": "Ouvrir Soumettre",
      "pointerDecide": "Ce rapport attend votre décision — validez-le ou renvoyez-le dans Approbation.",
      "nothingYet": "Rien de saisi pour le moment — le Préparateur de l'entité importe {{tpl}} sur l'écran Soumettre."
    },
    "cashc": {
      "byEntity": "Trésorerie par entité ({{ccy}})",
      "byEntitySub": "Solde réparti en Disponible, Restreint et Dépôt à terme — {{n}} entités sur {{of}} validées cette semaine.",
      "trend": "Trésorerie GROUP, 12 dernières semaines ({{ccy}})",
      "trendSub": "Solde et Disponible des entités ayant déclaré chaque semaine — un trou correspond à une semaine sans déclaration.",
      "reported": "{{n}} sur {{of}} déclarés",
      "noneYet": "Aucune entité n'a encore déclaré.",
      "noTrend": "Aucune semaine de cette période n'a encore de rapport.",
      "planTitle": "Le plan — {{who}} (SGD)",
      "planSub": "Entrées prévues vers le haut, sorties prévues vers le bas ; la ligne en pointillés est la clôture prévue, la ligne pleine la clôture réelle du Rapport de trésorerie hebdomadaire.",
      "monthCash": "Trésorerie de fin de mois par entité (SGD)",
      "monthCashSub": "{{n}} entités sur {{of}} ont déclaré ce mois-ci.",
      "noRateAll": "Affiché en SGD dès que les taux de change de {{week}} sont dans Configuration — aucun des comptes déclarés ne peut encore être converti.",
      "noRateSome": "Non représenté — pas encore de taux de change pour {{week}} : {{list}}.",
      "recon": "Comptes rapprochés",
      "reconSub": "Par entité : comptes dont le Rapprochement est 0, et comptes présentant un écart.",
      "reconciled": "Rapprochés",
      "difference": "Avec un écart",
      "accounts_one": "{{count}} compte",
      "accounts_other": "{{count}} comptes"
    },
    "cashf": {
      "inputTitle": "Saisie — {{tpl}}",
      "enterHere": "Saisir sur le Portal",
      "editHere": "Modifier sur le Portal",
      "inputClosed": "Seul le Préparateur de l'entité importe ce rapport, tant qu'il est ouvert ou renvoyé.",
      "field1": "Champ 1 — Flux de trésorerie réel de l'entité (SGD)",
      "field2": "Champ 2 — Compte de l'entité : somme de toutes les opérations",
      "field3": "Champ 3 — Virements intra-entité (entre les comptes propres de l'entité)",
      "field4": "Champ 4 — Opérations intragroupe (avec une autre entité Helinox)",
      "field5": "Champ 5 — Top 3 des principales dépenses de la semaine",
      "field6": "Champ 6 — Top 3 des paiements dus la semaine prochaine",
      "f1Entity": "Entité",
      "f1Overall": "Global",
      "f1Group": "Opérations intragroupe",
      "f1NoRate": "Le Champ 1 est calculé en SGD dès que la devise de chaque compte a le taux de cette semaine dans Configuration › Taux de change.",
      "h_rate": "Taux de change",
      "h_noTxn": "Confirmation sans opération",
      "h_restrictedAcct": "Compte restreint",
      "h_fdAcct": "Dépôt à terme",
      "h_upStatement": "Importer le relevé",
      "h_upBalance": "Importer la capture du solde",
      "h_entity": "Entité",
      "h_no": "N°",
      "h_category": "Catégorie",
      "h_memo": "Mémo",
      "h_amountSgd": "Montant en SGD",
      "fromSetup": "Selon le type de compte dans Configuration",
      "rateFromSetup": "Taux de cette semaine issu de Configuration",
      "rateMissing": "Pas de taux {{ccy}} pour cette semaine dans Configuration › Taux de change (synchronisé depuis NetSuite) — il ne peut pas être saisi ici",
      "closingCalc": "Clôture = Ouverture + Entrées − Sorties",
      "closingFiled": "Le fichier importé indiquait une Clôture de {{v}} — Ouverture + Entrées − Sorties donne le chiffre affiché. L'enregistrement ici conserve le chiffre calculé.",
      "closingDiff": "Ouverture + Entrées − Sorties diffère de cette Clôture de {{d}}",
      "memoPh": "De quoi il s'agit — aussi long que nécessaire",
      "f4None": "Aucune opération intragroupe cette semaine.",
      "rateOpt": "Taux vers SGD (facultatif)",
      "noTxn": "Aucune opération",
      "check": "Contrôle",
      "ok": "OK",
      "diff": "Écart {{d}}",
      "notNumber": "Pas un nombre",
      "noTxnAmounts": "Aucune opération, mais des montants saisis",
      "upStatement": "Relevé",
      "upBalance": "Solde",
      "addRow": "Ajouter une ligne",
      "removeRow": "Supprimer cette ligne",
      "save": "Enregistrer comme nouvelle version",
      "cancel": "Annuler la modification",
      "cancelImport": "Annuler l'import",
      "cancelBack": "Retire la version {{v}} et remet le rapport sur la version {{back}}.",
      "cancelEmpty": "Retire la version {{v}} — le rapport redevient vide, prêt pour un nouvel import.",
      "discardedBack": "Version {{v}} annulée — retour à la version {{back}}.",
      "discardedEmpty": "Version {{v}} annulée — le rapport est de nouveau vide.",
      "noChanges": "Aucune modification pour le moment — modifiez un chiffre ou importez un fichier.",
      "saveHint": "L'enregistrement crée une nouvelle version et relance le Contrôle des données.",
      "payrollRule": "La paie est UN SEUL total. Ne saisissez jamais de noms d'employés ni de salaires individuels.",
      "savedOk": "Version {{v}} enregistrée.",
      "savedReplaced": "Version {{v}} enregistrée — elle a passé le Contrôle des données et remplace la version {{old}} chez le Réviseur.",
      "savedErrors_one": "Version {{v}} enregistrée — {{count}} erreur de Contrôle des données à corriger avant l'envoi.",
      "savedErrors_other": "Version {{v}} enregistrée — {{count}} erreurs de Contrôle des données à corriger avant l'envoi.",
      "openingFrom": "La clôture précédente de la première semaine est la clôture de votre Rapport de trésorerie hebdomadaire pour {{week}} — ne la corrigez que si elle est erronée.",
      "prepareDate": "Date de préparation",
      "entityGroup": "Entité / Groupe",
      "entityLabel": "Entité",
      "currency": "Devise",
      "currencySgd": "SGD — tous les chiffres de ce modèle",
      "planCloseExp": "Clôture prévue (attendue)",
      "prevWeek": "semaine précédente",
      "thisWeek": "cette semaine",
      "openingNone": "Pas de Rapport de trésorerie hebdomadaire pour la semaine précédente — saisissez la trésorerie d'ouverture."
    },
    "gtm": {
      "title": "Programmes GTM",
      "subtitle": "Rédigez un programme en répondant aux sept questions et envoyez-le pour relecture. L'approbateur décide dans GTM › Approbation.",
      "newProgramme": "Nouveau programme",
      "createTitle": "Démarrer un programme",
      "nameLabel": "Titre",
      "namePlaceholder": "p. ex. Sunset Chair (re) Home · Book Reading Edition",
      "create": "Créer",
      "cancel": "Annuler",
      "back": "Tous les programmes",
      "none": "Aucun programme pour le moment.",
      "openDecisions": "Décisions requises",
      "openVerifies": "À vérifier",
      "regionsWaiting": "Régions en attente de réponse",
      "committed": "Unités engagées",
      "ofTarget": "sur {{n}}",
      "editProgramme": "Modifier le programme",
      "headline": "Titre principal",
      "openItem": "Point ouvert",
      "openItems": "Décisions, travaux et vérifications",
      "noItems": "Rien sur cette question pour le moment.",
      "lineTitle": "De quoi s'agit-il",
      "lineDetail": "Détail",
      "inThisProgrammeHint": "Pourquoi il en fait partie, ou pourquoi il n'en fait pas partie — la phrase que le tableau imprime à côté.",
      "discardAsk": "Abandonner ce que vous avez saisi ?",
      "needed": "Encore requis : {{fields}}",
      "editTable": "Modifier le tableau",
      "editTableWhy": "Déverrouillez le tableau, modifiez autant de lignes que vous voulez, puis enregistrez-le en une seule fois",
      "editTableHint": "Saisissez librement — rien n'est écrit avant l'enregistrement, qui se fait en une seule fois : soit tout est pris en compte, soit rien ne change.",
      "saveTable": "Enregistrer le tableau",
      "saveTableN": "Enregistrer le tableau ({{n}})",
      "layerHead": "Ce qui se passe au-dessus des canaux de vente",
      "stage": "Étape",
      "role": "Rôle",
      "condition": "Condition",
      "addStage": "Ajouter une étape",
      "orderHead": "Ordre",
      "orderLabel": "L'ordre dans lequel cela se déroule",
      "step": "Étape",
      "stepDetail": "De quoi s'agit-il",
      "addStep": "Ajouter une étape",
      "savedN": "{{n}} modification(s) enregistrée(s).",
      "savedNothing": "Rien n'avait changé.",
      "regionsHint": "Les régions couvertes par ce programme, par ordre de priorité — faites glisser une ligne, ou utilisez les flèches, pour le modifier.",
      "sheetLocked": "Cliquez sur Modifier pour changer quoi que ce soit sur cette feuille.",
      "sheetOpen": "La feuille est ouverte — saisissez librement. Rien n'est écrit avant que vous cliquiez sur Enregistrer. Le déplacement d'une ligne s'enregistre immédiatement.",
      "acrossProgramme": "Sur l'ensemble du programme",
      "qOpenCount": "{{n}} encore ouverts",
      "removeYes": "Supprimer",
      "waitingOnYou": "En attente de votre décision",
      "rev_draft": "Non envoyé pour relecture",
      "rev_in_review": "Chez l'approbateur",
      "rev_approved": "Approuvé",
      "rev_rejected": "Rejeté",
      "approver": "Approbateur",
      "sentForReview": "Envoyé pour relecture",
      "approvedOn": "Approuvé",
      "rejectedOn": "Rejeté",
      "sendForReview": "Envoyer pour relecture",
      "reviewAgain": "Renvoyer pour relecture",
      "approve": "Approuver",
      "resubmit": "Soumettre à nouveau",
      "sent": "Envoyé",
      "view": "Voir",
      "kpiAll": "Tous les programmes",
      "kpiMine": "Mes programmes",
      "scopeMine": "Mes programmes",
      "scopeAll": "Tous les programmes",
      "noneMine": "Vous n'avez encore aucun programme — aucun que vous ayez créé, envoyé ou dont vous soyez responsable.",
      "showAll_one": "Afficher le {{count}} programme",
      "showAll_other": "Afficher les {{count}} programmes",
      "backApproval": "Approbation GTM",
      "approvalTitle": "Approbation GTM",
      "approvalSub": "Programmes qui vous sont envoyés pour décision. Les brouillons restent chez leurs auteurs et n'apparaissent jamais ici.",
      "approvalSubAdmin": "Programmes envoyés pour décision. En tant qu'admin, vous voyez la file de chaque approbateur ; les brouillons n'apparaissent jamais ici.",
      "tabWaiting": "En attente de décision",
      "tabApproved": "Approuvés",
      "tabRejected": "Rejetés",
      "emptyQueue_in_review": "Rien n'attend votre décision.",
      "emptyQueue_approved": "Rien d'approuvé pour le moment.",
      "emptyQueue_rejected": "Rien de rejeté.",
      "colSentBy": "Envoyé par",
      "colSentOn": "Envoyé le",
      "colDecidedOn": "Décidé le",
      "colCreatedBy": "Créé par",
      "colCreatedAt": "Créé le",
      "colUpdatedBy": "Modifié par",
      "colUpdatedAt": "Modifié le",
      "colManagerNote": "Note du manager",
      "colSkus": "SKU du projet",
      "skuHead": "SKU de projet liés",
      "skuHint": "Les SKU de projet lancés dans le cadre de ce programme. Le même lien est le champ GTM de chaque SKU dans Project Tracker.",
      "skuNone": "Aucun SKU de projet lié pour le moment.",
      "skuId": "ID du SKU de projet",
      "skuName": "Nom du SKU",
      "skuGroup": "Groupe de projet",
      "skuStatus": "Statut",
      "skuPh": "Sélectionnez ou saisissez un SKU de projet, p. ex. 9048 ou SKU-09048",
      "skuAdd": "Lier le SKU",
      "skuUnlink": "Délier ce SKU",
      "deleteLockedSent": "Envoyé pour relecture — il ne peut pas être supprimé tant que l'approbateur l'a en main.",
      "deleteLockedApproved": "Approuvé — un programme approuvé ne peut pas être supprimé.",
      "countAll_one": "{{count}} programme",
      "countAll_other": "{{count}} programmes",
      "countOf": "{{n}} programmes sur {{total}}",
      "searchPh": "Rechercher code, titre, responsable…",
      "clear": "Effacer",
      "noMatch": "Aucun programme ne correspond à ces filtres.",
      "loading": "Chargement…",
      "colNo": "N°",
      "colCode": "ID GTM",
      "colTitle": "Programme",
      "colStatus": "Statut",
      "colOwner": "Responsable",
      "colApprover": "Approbateur",
      "colLaunch": "Lancement",
      "colDecisions": "Décisions",
      "colVerify": "À vérifier",
      "colRegions": "Régions",
      "colAction": "Action",
      "reviewDone_submit": "Envoyé pour relecture.",
      "reviewDone_approve": "Approuvé.",
      "reviewDone_reject": "Rejeté.",
      "coverEyebrow": "Programme GTM",
      "printedOn": "Imprimé le",
      "coverStatus": "Relecture",
      "coverDecisionNote": "Note de décision",
      "exportPdf": "Exporter en PDF",
      "delete": "Supprimer",
      "deleteProgramme": "Supprimer ce programme",
      "deleteBody": "Cela supprime {{n}} lignes et {{photos}} photos qui en dépendent.",
      "deleteWarn": "Cette action est irréversible.",
      "exporting": "Exportation…",
      "pdf": "PDF",
      "addStop": "Ajouter une condition d'arrêt",
      "stopKind_manual": "Suivi manuel",
      "stopKind_commit_min": "Engagements régionaux sous un seuil",
      "stopKind_anchor_consent": "La personne de la région pilote n'est pas d'accord",
      "stopKindAsk": "Que doit lire le portail ?",
      "deleteYes": "Le supprimer",
      "measureHead": "Comment le succès est mesuré",
      "measureHint": "Ce que représente chaque mesure, et ce qui compte comme bon résultat.",
      "measureItem": "Mesure",
      "measureWhat": "Ce que c'est, et comment elle est jugée",
      "measurePh": "Défense, édition, inline…",
      "timelineHead": "Calendrier · Responsables",
      "timelineHint": "Comment ce programme est mené, et qui est responsable de chaque étape.",
      "timelineStep": "Étape",
      "timelineStage": "Phase",
      "timelineWho": "Ce qui se passe",
      "timelinePh": "Désigner un responsable, décisions, lancement…",
      "timelineWhen": "Prévu",
      "timelineNote": "À qui cela s'adresse",
      "stopWhere": "Où cela en est",
      "stopThreshold": "Seuil",
      "removeDoc": "Supprimer quand même",
      "removeDocWhy": "Cette ligne provient du plan directeur. Relancer l'import la fera réapparaître.",
      "keepIt": "La conserver",
      "specHead": "Éléments et contenu",
      "specHint": "Ce qui doit exister avant le lancement : chaque élément et son contenu. Ajoutez une ligne pour tout le reste.",
      "specItem": "Élément",
      "specItemPh": "Cadre, poche, prix…",
      "specA": "Inline",
      "specB": "Edition",
      "photosHead": "Photos",
      "photosHint": "Images auxquelles ce programme fait référence. Une légende indique ce que chacune désigne.",
      "discoverHead": "Comment les gens le découvrent",
      "discoverHint": "Ce qui se passe avant le lancement, le jour même et après.",
      "discoverPh": "Contenu, seeding, invitations…",
      "noLines": "Rien ici pour le moment.",
      "collapseAll": "Tout réduire",
      "expandAll": "Tout développer",
      "fieldTitle": "Titre",
      "stopHead": "Conditions d'arrêt (proposées)",
      "stopNone": "Aucune condition d'arrêt n'est définie.",
      "tripped": "Arrêt déclenché",
      "holding": "En cours",
      "addLine": "Ajouter une ligne",
      "lineKind": "Type",
      "persona": "Persona",
      "channel": "Canal",
      "inThisProgramme": "Dans ce programme",
      "remarks": "Remarques",
      "select": "Sélectionner",
      "selectHint": "Cochez une ligne, ou choisissez-la dans la zone Ajouter ci-dessous, pour la sélectionner. L'ordre des lignes sélectionnées est la priorité — faites glisser une ligne, ou utilisez les flèches, pour le modifier.",
      "regionsCount": "Régions de ce programme",
      "specContent": "Contenu",
      "timelineOwner": "Responsable",
      "discoverItem": "Élément",
      "discoverDetail": "Ce qui se passe",
      "trkTitle": "Suivi GTM",
      "trkSub": "Les programmes approuvés et leur avancement, étape par étape dans leur Calendrier · Responsables. Marquez une étape En cours ou Terminée au fil du travail ; une étape dépassant sa date prévue sans être terminée est signalée En retard.",
      "trkApproved": "Programmes approuvés",
      "trkStepsDone": "Étapes terminées",
      "trkOverdue": "En retard",
      "trkOnlyOverdue": "Afficher uniquement les programmes ayant une étape en retard",
      "trkSearch": "Rechercher programme, étape ou responsable…",
      "trkToday": "Aujourd'hui : {{day}}",
      "trkNone": "Aucun programme n'a encore été approuvé.",
      "trkApprovedBy": "Approuvé par",
      "trkStepsOf": "{{done}} étapes terminées sur {{total}}",
      "trkNoSteps": "Aucune étape de calendrier pour le moment",
      "trkOverdueN_one": "{{count}} en retard",
      "trkOverdueN_other": "{{count}} en retard",
      "trkNext": "Prochaine",
      "trkAllDone": "Toutes les étapes sont terminées",
      "trkStatus": "Statut",
      "trkDoneOn": "Terminée le",
      "trkNoStepsHint": "Ce programme n'a pas encore d'étapes de calendrier — ajoutez-les sous Calendrier · Responsables dans le programme.",
      "st_not_started": "Non démarrée",
      "st_in_progress": "En cours",
      "st_done": "Terminée",
      "trkProgress": "Avancement",
      "trkNextDue": "Échéance de la prochaine étape",
      "trkApprovedOn": "Approuvé",
      "listNew": "Nouveau : il sera ajouté à la liste pour la prochaine fois.",
      "listAllIn": "Tout ce qui figure dans la liste est déjà dans ce programme. Saisissez-en un nouveau.",
      "listDup": "Déjà sélectionné dans ce programme.",
      "listHave": "Déjà dans ce programme.",
      "listPick": "Choisissez dans la liste, ou saisissez-en un nouveau",
      "addPersona": "Ajouter un persona",
      "addChannel": "Ajouter un canal",
      "removeRow": "Supprimer",
      "removeAsk": "Supprimer « {{name}} » ? Cette action est irréversible.",
      "add": "Ajouter",
      "noteOnTable": "Note sur ce tableau",
      "noteOnTableHint": "Tout ce que le tableau ci-dessus ne peut pas dire — une réserve, ou ce qu'il laisse de côté.",
      "moveUp": "Monter",
      "moveDown": "Descendre",
      "targetAudience": "Personas sélectionnés — par ordre de priorité",
      "notATarget": "Non sélectionné",
      "channelsInUse": "Canaux sélectionnés — par ordre de priorité",
      "channelsOut": "Non sélectionné",
      "chStatus_green": "Statut du canal à l'échelle de l'entreprise : sain",
      "chStatus_amber": "Statut du canal à l'échelle de l'entreprise : à surveiller",
      "chStatus_red": "Statut du canal à l'échelle de l'entreprise : faible",
      "notYet": "Pas encore possible de répondre",
      "unmeasured": "Suivi manuel",
      "stopNote": "La personne qui pilote le programme indique où en est chaque condition.",
      "question": "Question {{n}}",
      "emptySection": "Pas encore de réponse.",
      "oneChange": "Une section modifiée",
      "nChanges": "{{count}} sections modifiées",
      "discard": "Abandonner",
      "edit": "Modifier",
      "save": "Enregistrer",
      "decision": "Décision requise",
      "verify": "À vérifier",
      "addDecision": "Ajouter une décision",
      "addVerify": "Ajouter un point à vérifier",
      "todo": "À faire",
      "addTodo": "Ajouter une tâche",
      "phaseFilter": "Phase de lancement",
      "allPhases": "Toutes les phases",
      "phaseHintOne": "Affichage de {{phase}} uniquement — {{hidden}} des {{all}} points ouverts sont masqués. Cliquez de nouveau dessus, ou sur Toutes les phases, pour les afficher.",
      "phaseWhy_all": "Tout ce qui, dans le plan, est lié à un moment précis",
      "phaseWhy_before": "Q5 — ce qui doit exister avant le début du travail, et les décisions encore ouvertes",
      "phaseWhy_pre": "Q6 — PRÉ-LANCEMENT : avant le jour du lancement",
      "phaseWhy_launch": "Q6 — LANCEMENT : le jour même",
      "phaseWhy_post": "Q6 — POST-LANCEMENT : une fois sorti",
      "workNone": "Rien de listé pour le moment.",
      "phase_before": "Avant le démarrage",
      "phase_pre": "Pré-lancement",
      "phase_launch": "Lancement",
      "phase_post": "Post-lancement",
      "noPhase": "Aucune phase",
      "owner": "Responsable",
      "noOwner": "Aucun responsable",
      "due": "Échéance",
      "noDue": "Aucune date",
      "answer": "Réponse",
      "answered": "Répondu",
      "dropped": "Abandonné",
      "open": "Ouvert",
      "remove": "Supprimer",
      "regionsHead": "Régions",
      "region": "Région",
      "person": "Personne",
      "replyStatus": "Réponse",
      "consent": "Accord",
      "commitQty": "Engagement",
      "replyDue": "Répondre avant le",
      "anchor": "Pilote",
      "note": "Note",
      "addRegion": "Ajouter une région",
      "metricsHead": "Comment le succès est mesuré",
      "metric": "Indicateur",
      "baseline": "Référence",
      "baselineWindow": "Période",
      "live": "Depuis",
      "takeBaseline": "Prendre la référence",
      "retakeBaseline": "Reprendre",
      "baselineTaken": "Prise {{when}}",
      "baselineNotTaken": "Non prise",
      "manualMetric": "Saisi à la main",
      "baselineWhy": "Figée le jour où elle est prise. Une commande Shopify peut être remboursée des mois plus tard : un chiffre qui se recalculerait lui-même bougerait sous la comparaison qu'il sert d'ancrage.",
      "units": "unités",
      "sourceDoc": "Document source",
      "status": "Statut",
      "launchTarget": "Lancement",
      "notSet": "Non défini",
      "saved": "Enregistré",
      "saveFailed": "Échec de l'enregistrement"
    },
    "account": {
      "profile": "Profil",
      "listUsers": "Liste des utilisateurs",
      "createUser": "Créer un utilisateur",
      "accessRequests": "Demandes d'accès",
      "rolesPermissions": "Rôles et autorisations",
      "portalInsights": "Statistiques du portail",
      "masterData": "Données de référence",
      "activityLog": "Journal d'activité",
      "logout": "Se déconnecter"
    },
    "quote": {
      "label": "Citation du jour"
    },
    "doc": {
      "title": "Bibliothèque",
      "subtitle": "Documents de l'entreprise — lisez-les ici, ou téléchargez une copie qui indique sa version. Le portail conserve toujours la version à jour.",
      "folders": "Dossiers",
      "allDocs": "Tous les documents",
      "unfiled": "Non classés",
      "newFolder": "Nouveau dossier",
      "newFolderIn": "Nouveau dossier dans {{name}}",
      "folderName": "Nom du dossier",
      "renameFolder": "Renommer",
      "deleteFolder": "Supprimer",
      "deleteFolderAsk": "Supprimer le dossier « {{name}} » ? Rien de ce qu'il contient n'est supprimé.",
      "folderField": "Dossier",
      "folderNone": "Non classé",
      "folderSaved": "Dossier enregistré.",
      "search": "Rechercher titre ou code…",
      "upload": "Importer",
      "refresh": "Actualiser",
      "none": "Aucun document n'a encore été partagé avec vous.",
      "noMatch": "Aucun résultat pour cette recherche.",
      "unread": "non lu",
      "acknowledged": "lu",
      "code": "Code",
      "docTitle": "Titre",
      "version": "Version",
      "updated": "Mis à jour",
      "status": "Statut",
      "changeNote": "Ce qui a changé",
      "uploadedBy": "Importé par",
      "author": "Auteur",
      "authorNone": "— non précisé —",
      "versionAuthor": "Auteur de cette version",
      "authorSame": "— identique à la version précédente —",
      "byAuthor": "par {{name}}",
      "authorHint": "Qui l'a rédigé. Pas nécessairement la personne qui l'importe.",
      "newDoc": "Nouveau document",
      "newVersion": "Importer une nouvelle version",
      "addingVersionTo": "Ajout d'une nouvelle version à",
      "findDocPh": "Saisissez un code ou un titre — HB-0001, handbook…",
      "findDocNone": "Aucun document ne correspond à « {{q}} ».",
      "currentlyAt": "actuellement {{version}} — la nouvelle est ajoutée, l'ancienne reste consultable dans l'historique ci-dessous",
      "kind": "Type",
      "codeAuto": "Attribué par le Portal",
      "summary": "Description courte",
      "everyone": "Toute personne pouvant ouvrir la bibliothèque peut le lire",
      "narrowHint": "Sinon, seuls vous et les autres administrateurs de la bibliothèque pouvez le lire tant que vous ne l'avez pas partagé.",
      "file": "Fichier",
      "fileKinds": "HTML, PDF, PNG, JPEG, Word, PowerPoint et Excel (.xlsx) se lisent tous ici. Le téléchargement donne toujours le fichier d'origine.",
      "noPreview": "Aucun navigateur ne peut afficher ce type de fichier dans la page. Il est conservé ici avec sa version et se télécharge sous le nom avec lequel il a été importé.",
      "download": "Télécharger",
      "imgBroken": "Cette image ne s'ouvre pas — le fichier est endommagé ou dans un format que le navigateur ne sait pas lire. Il reste conservé ici et se télécharge sous le nom avec lequel il a été importé.",
      "versionLabel": "Version",
      "versionAuto": "Laissé vide : le Portal poursuit à partir de la dernière",
      "versionFound": "Lue dans le document lui-même : {{version}}",
      "versionNotFound": "Aucune version trouvée sur la couverture du document — laissez vide pour v1.0, ou saisissez-la.",
      "changeNoteLabel": "Ce qui a changé (une ligne)",
      "uploading": "Importation…",
      "allDocuments": "Tous les documents",
      "history": "Historique des versions",
      "latest": "dernière",
      "view": "Ouvrir",
      "readingOld": "Vous lisez une version plus ancienne —",
      "backToLatest": "revenir à la dernière",
      "iHaveRead": "J'ai lu ce document",
      "recording": "Enregistrement…",
      "youAcknowledged": "Vous avez confirmé avoir lu {{version}}",
      "noVersion": "Aucune version n'a encore été importée.",
      "readers": "Qui l'a lu",
      "readersCount": "{{opened}} sur {{notified}} l'ont ouvert · {{acked}} confirmé(s)",
      "notified": "Notifié",
      "opened": "Ouvert",
      "confirmed": "Confirmé",
      "nobody": "Personne n'a encore été notifié.",
      "share": "Partager",
      "shareLink": "Copier le lien",
      "linkCopied": "Lien copié",
      "shareByEmail": "Envoyer par e-mail",
      "emails": "Adresses e-mail",
      "emailsHint": "Séparez-les par une virgule ou un espace.",
      "groups": "Groupes",
      "person": "Destinataire",
      "groupsNone": "Choisir des groupes…",
      "groupsClear": "Effacer",
      "addGroup": "Ajouter un groupe",
      "addGroupName": "Nom du groupe",
      "addGroupEmail": "Adresse e-mail du groupe",
      "addGroupSave": "Ajouter à la liste",
      "addGroupHint": "Toute personne qui partage un document verra désormais ce groupe.",
      "groupAdded": "« {{name}} » figure dans la liste.",
      "groupRemoved": "« {{name}} » a été retiré de la liste.",
      "removeGroupConfirm": "Retirer « {{name}} » de la liste de groupes de tout le monde ?",
      "sharers": "Qui peut partager",
      "sharersIntro": "Vous avez importé {{code}} : c'est à vous de l'envoyer. Toute personne que vous nommez ici peut l'envoyer aussi.",
      "sharersIntroAdmin": "{{owner}} a importé {{code}}. Vous pouvez l'envoyer en tant qu'administrateur, comme toute personne nommée ici.",
      "sharersNone": "Personne d'autre. Seuls {{owner}} et les administrateurs peuvent envoyer ce document.",
      "sharersAdd": "Ajouter quelqu'un",
      "sharersPick": "Choisir des personnes…",
      "sharersFind": "Saisissez un nom ou une adresse…",
      "sharersNoMatch": "Personne ne correspond.",
      "sharersAddN": "Accorder le partage ({{count}})",
      "sharersSaved": "Les personnes autorisées à partager ont été enregistrées.",
      "sharersUploader": "Auteur de l'import",
      "cannotShare": "Seuls {{owner}} et les administrateurs peuvent envoyer ce document.",
      "sendNote": "Note (facultative — par défaut, la note de modification)",
      "send": "Envoyer la notification",
      "sending": "Envoi…",
      "sentTo": "Envoyé à {{count}} destinataire(s).",
      "remove": "Supprimer",
      "edit": "Modifier",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "savedMsg": "Enregistré.",
      "noteOfVersion": "La note de modification appartient à {{version}}, la version figurant actuellement dans la liste.",
      "comments": "Commentaires",
      "noComments": "Pas encore de commentaire. La première question est souvent celle que quelqu'un d'autre se pose aussi.",
      "commentPlaceholder": "Posez une question sur ce document, ou répondez à quelqu'un…",
      "commentHint": "Toute personne pouvant ouvrir ce document voit votre commentaire. Ctrl+Entrée pour publier.",
      "post": "Publier",
      "posting": "Publication…",
      "commentGone": "Ce commentaire a été supprimé.",
      "deleteComment": "Supprimer",
      "deleteCommentTitle": "Supprimer ce commentaire ?",
      "deleteCommentBody": "Il disparaît pour tout le monde. Sa place dans la conversation reste, marquée comme supprimée.",
      "removeTitle": "Supprimer ce document ?",
      "removeConfirm": "Il disparaît de la liste de chacun et le lien ne s'ouvre plus. Le suivi de lecture est conservé, et le code n'est jamais attribué à un autre document.",
      "removedMsg": "{{code}} a été supprimé de la bibliothèque.",
      "cancel": "Annuler",
      "removed": "Supprimé."
    },
    "home": {
      "morning": "Bonjour",
      "afternoon": "Bonjour",
      "evening": "Bonsoir",
      "myWork": "Mon travail — {{role}}",
      "notLinkedToEmployee": "Ce compte du portail n'est pas encore lié à une fiche employé : aucun travail ne peut donc vous être associé. Demandez à un admin de le lier.",
      "notLinkedToSalesRep": "Ce compte n'est pas encore lié à un Sales Rep : vos projets ne peuvent donc pas vous être associés. Demandez à un admin de le lier.",
      "targetLaunch": "Mois de lancement cible",
      "ack": "Compris",
      "ackTitle": "Confirmez que vous avez pris connaissance de ce rejet — il n'apparaîtra plus sur cette carte",
      "lateThreshold": "En retard après (jours)",
      "saved": "Enregistré",
      "lateThresholdRange": "1-365",
      "save": "Enregistrer",
      "ackUndo": "Remettre",
      "seenCount": "{{n}} pris en compte — afficher",
      "viewAs": "Affichage",
      "allOf": "Tout le monde — {{role}}",
      "viewAll": "Tout le monde",
      "repNoAccount": "non lié à un compte",
      "openThisList": "Ouvrir cette liste dans Sample Tracker",
      "andMore": "+{{n}} de plus",
      "workload": {
        "title": "Charge de travail par semaine",
        "sub": "Un instantané chaque lundi — ce que chaque PIC avait en charge ce matin-là",
        "rounds": "Tours actifs",
        "projects": "Projets actifs",
        "pic": "Responsable",
        "change": "vs semaine dernière",
        "total": "Total",
        "reconstructed": "Cette semaine n'a pas été comptée le lundi matin — elle a été renseignée après coup.",
        "cellRounds": "En production {{prod}} · résultat en attente {{pending}} · RM en attente {{wait}}",
        "note": "Tours actifs = In Production + Pending Outcome. Une semaine marquée * n'a pas été comptée ce lundi-là — elle a été renseignée après coup."
      },
      "noModules": "Aucun module n'a encore été attribué à votre compte. Demandez l'accès à un administrateur."
    },
    "tc": {
      "colNo": "N°",
      "colAction": "Action",
      "stateActive": "Actif",
      "stateInactive": "Inactif",
      "title": "Codes de ticket",
      "subtitle": "La liste de référence derrière la liste déroulante des codes de ticket. {{n}} codes.",
      "readOnly": "— en lecture seule pour votre rôle.",
      "newCode": "Nouveau code",
      "exportExcel": "Exporter vers Excel",
      "searchPh": "Rechercher code, nom, phase, équipe…",
      "showInactive": "Afficher les inactifs",
      "clearTools": "Réinitialiser le tri et les filtres",
      "countOf": "{{n}} sur {{total}}",
      "loading": "Chargement…",
      "saving": "Enregistrement…",
      "btnEdit": "Modifier",
      "btnView": "Voir",
      "btnViewHint": "Voir ce code (lecture seule)",
      "btnClose": "Fermer",
      "formView": "Code de ticket {{code}}",
      "viewOnly": "Lecture seule",
      "btnSave": "Enregistrer",
      "btnCancel": "Annuler",
      "formNew": "Nouveau code de ticket",
      "formEdit": "Modifier {{code}}",
      "fCode": "Code",
      "fTeam": "Équipe",
      "fCase": "Cas",
      "fCategory": "Catégorie",
      "fName": "Nom du ticket",
      "fPhase": "Phase",
      "fAssignedTo": "Assigné à",
      "fGroupEmail": "E-mail du groupe",
      "fNote": "Note",
      "fActive": "Actif — un code inactif reste sur les tickets qui l'utilisent déjà, mais n'est plus proposé dans le formulaire Nouveau ticket",
      "phCase": "A / B / vide",
      "phName": "Demande de développement d'échantillon",
      "phTeamSearch": "Rechercher une équipe…",
      "everyCategory": "Toutes les catégories",
      "created": "{{code}} créé.",
      "saved": "{{code}} enregistré.",
      "nothingToExport": "Rien à exporter",
      "preparingExport": "Préparation de l'export Excel…",
      "exported": "{{n}} codes exportés",
      "exportFailed": "Échec de l'export",
      "exportInclInactive": "Codes inactifs inclus",
      "exportActiveOnly": "Codes actifs uniquement"
    },
    "pa": {
      "title": "Approbation des projets",
      "subtitle": "Un nouveau projet reste En attente tant qu'il n'est pas approuvé ici. Aucun ticket ne peut être émis sur un projet non approuvé.",
      "tabPending": "En attente",
      "tabApproved": "Approuvés",
      "tabRejected": "Rejetés",
      "tabSettings": "Paramètres",
      "loading": "Chargement…",
      "saving": "Enregistrement…",
      "working": "Traitement…",
      "countAll": "{{n}} projets",
      "countOf": "{{n}} projets sur {{total}}",
      "chartPick": "Graphique : {{label}} · {{n}} projets",
      "chartPickClear": "Afficher de nouveau tous les projets",
      "allTeams": "Toutes les équipes",
      "scopeHint": "Les projets de quelle équipe afficher",
      "clearTools": "Réinitialiser le tri et les filtres",
      "searchPh": "Rechercher projet, SKU, équipe, responsable…",
      "rejectedChip": "Rejeté · {{n}} SKU",
      "rejectedChipHint": "{{n}} SKU renvoyé(s) par l'approbateur — corrigez-les et cliquez sur Soumettre à nouveau.",
      "selected": "{{n}} sélectionné(s)",
      "decideSelected": "Décider pour la sélection",
      "clearSelection": "Effacer la sélection",
      "emptyFiltered": "Aucun projet ne correspond à la recherche ou aux filtres de colonnes.",
      "emptyPending": "Rien n'attend d'approbation.",
      "emptyTab": "Aucun projet {{tab}}.",
      "colNo": "N°",
      "colProjectId": "ID du groupe de projets",
      "colProjectName": "Nom du projet",
      "colTeam": "Équipe",
      "colManager": "Responsable",
      "colOwner": "Responsable",
      "colSalesRep": "Commercial",
      "colCategory": "Catégorie",
      "colSeason": "Saison",
      "colPartner": "Partenaire / Ligne",
      "colTargetLaunch": "Lancement cible",
      "colSkus": "SKU",
      "colRequestedBy": "Demandé par",
      "colRequestedAt": "Demandé le",
      "colManagerNote": "Note du manager",
      "colApprovedBy": "Approuvé par",
      "colApprovedAt": "Approuvé le",
      "colApprovedOpinion": "Avis d'approbation",
      "colRejectedBy": "Rejeté par",
      "colRejectedAt": "Rejeté le",
      "colReason": "Motif",
      "colAction": "Action",
      "btnView": "Voir",
      "btnApprove": "Approuver",
      "btnEdit": "Modifier",
      "btnResubmit": "Soumettre à nouveau",
      "btnCancel": "Annuler",
      "btnClose": "Fermer",
      "btnSaveChanges": "Enregistrer les modifications",
      "btnApproveN": "Approuver {{n}}",
      "btnRejectN": "Rejeter {{n}}",
      "notYourTeam": "Ce projet appartient à une autre équipe — seuls son responsable, le manager de cette équipe ou un admin peuvent le modifier.",
      "dlgResubmitTitle": "Soumettre à nouveau {{id}}",
      "dlgDecisionOne": "Décision sur {{id}}",
      "dlgDecisionBulk": "Décision sur {{n}} projets",
      "dlgStatus": "Statut d'approbation",
      "dlgAgree": "Accepter",
      "dlgReject": "Rejeter",
      "skuToggle": "Afficher les {{n}} SKU de ce projet",
      "skuNone": "Ce projet n'a pas encore de SKU.",
      "skuId": "SKU",
      "skuItem": "Article",
      "skuCategory": "Catégorie",
      "skuQty": "Qté",
      "skuPrice": "Cible",
      "skuExf": "EXF",
      "skuPic": "Développeur / Designer",
      "skuStatus": "Étape",
      "skuTba": "TBA",
      "skuState": "Approbation",
      "skuNote": "Note de l'approbateur",
      "skuSt_unsent": "Pas encore envoyé",
      "skuSt_waiting": "En attente",
      "skuSt_approved": "Approuvé",
      "skuSt_rejected": "Non approuvé",
      "skuPicked": "{{n}} SKU sélectionné(s)",
      "skuWithApprover": "Déjà envoyé — c'est à l'approbateur de décider.",
      "skuNotYours": "Pas encore envoyé — c'est l'équipe demandeuse qui l'envoie.",
      "skuDoneAlready": "Déjà décidé.",
      "skuNoneYours": "Rien ici n'attend votre action.",
      "submitPickFirst": "Cochez les SKU à envoyer, ou cochez le projet pour les envoyer tous.",
      "skuNotRefused": "Non refusé — il n'y a rien à renvoyer ici.",
      "resubmitSome": "Soumettre à nouveau {{n}}",
      "dlgBackHead": "Ce qui a changé sur chaque SKU ({{n}} renvoyés)",
      "dlgBackWas": "Non approuvé",
      "dlgBackWhy": "Ce qui a changé sur ce SKU",
      "skuMgrNote": "Note du manager",
      "submitSome": "Soumettre {{n}}",
      "submitSomeHint": "N'envoyer que les {{n}} SKU cochés ci-dessous ; les autres restent où ils sont.",
      "approveSome": "Statuer sur {{n}}",
      "approveSomeHint": "Statuer uniquement sur les {{n}} SKU cochés ci-dessous.",
      "dlgSkuHead": "Statuer sur chaque SKU ({{n}} en attente)",
      "dlgAllApprove": "Tout approuver",
      "dlgAllReject": "Tout rejeter",
      "dlgSkuWhy": "Pourquoi ce SKU n'est pas approuvé",
      "dlgSkuDefault": "Chaque SKU est approuvé sauf si vous le marquez ✕.",
      "dlgSkuYes": "Approuver",
      "dlgSkuNo": "Non approuvé",
      "dlgSkuUndo": "Remettre ce SKU en approuvé",
      "dlgWasApproved": "approuvé précédemment",
      "dlgWasRejected": "rejeté précédemment",
      "btnApproveSkus": "Approuver {{n}} SKU",
      "btnRejectSkus": "Rejeter {{n}} SKU",
      "btnPartial": "Approuver {{yes}}, rejeter {{no}}",
      "stPartial": "Partiellement approuvé",
      "dlgUnchangedTitle": "Rien n'a été modifié depuis le rejet.",
      "dlgUnchangedBody": "Corrigez ce que l'approbateur a demandé (Modifier sur la ligne), ou expliquez ci-dessous pourquoi il doit être approuvé en l'état — une note est obligatoire pour le renvoyer sans modification.",
      "dlgManagerOpinion": "Avis du responsable",
      "dlgApproverOpinion": "Avis de l'approbateur",
      "dlgPhReject": "Pourquoi ce projet n'est-il pas approuvé ? L'équipe le verra.",
      "dlgPhResubmitRequired": "Obligatoire — pourquoi doit-il être approuvé sans modification ?",
      "dlgPhResubmit": "Qu'est-ce qui a changé depuis le rejet ? (facultatif)",
      "dlgPhOptional": "Saisissez le contenu (facultatif)",
      "secProject": "Informations du projet",
      "secSku": "Informations du SKU",
      "fTeam": "Équipe",
      "fOwner": "Responsable du projet (Sales OP)",
      "fCategory": "Catégorie",
      "fSeason": "Saison",
      "fPartner": "Partenaire / Ligne",
      "fKeyword": "Mot-clé",
      "fTargetLaunch": "Lancement cible (mois)",
      "fCase": "Cas",
      "fEntity": "Entité",
      "selectTeam": "Sélectionner une équipe…",
      "selectOwner": "Sélectionner un responsable…",
      "pickTeamFirst": "Choisissez d'abord une équipe",
      "noMember": "Aucun membre dans cette équipe pour l'instant — à définir dans List Users",
      "addSku": "+ Ajouter un SKU",
      "noSkuYet": "Aucun SKU pour l'instant — ce n'est pas un problème. Des SKU peuvent être ajoutés à tout moment.",
      "skuSaveHint": "Les nouveaux SKU sont créés à l'enregistrement. La suppression d'un SKU existant est immédiate, sans attendre l'enregistrement.",
      "fillRequired": "Renseignez d'abord les champs obligatoires :",
      "couldNotSave": "Enregistrement impossible :",
      "rejectedBy": "Rejeté par {{who}} :",
      "managerNoteLabel": "Note du responsable :",
      "submit": "Soumettre",
      "submitSelected": "Soumettre la sélection à l'approbateur",
      "readyToSubmit": "{{n}} sur {{total}} prêts à soumettre",
      "nothingToSubmit": "Aucune sélection à soumettre — déjà envoyé, ou autre équipe.",
      "sent": "Envoyé",
      "submittedOn": "Soumis à l'approbateur {{when}}",
      "remind": "Relancer",
      "remindHint": "Envoyé {{when}} · {{n}} SKU toujours en attente de l'approbateur. Envoyer une relance.",
      "remindSent": "Relance envoyée à {{to}} — {{n}} SKU toujours en attente",
      "lockedSubmitted": "Déjà soumis — l'approbateur l'a en main, et l'e-mail qu'il a reçu affiche toujours les valeurs telles qu'envoyées.",
      "drop": "Supprimer",
      "dropTitle": "Supprimer ce projet",
      "dropSubmitted": "Déjà soumis — suppression impossible.",
      "dropHead": "Supprimer {{id}} ?",
      "dropChecking": "Vérification des éléments rattachés à ce projet…",
      "dropWarnOne": "1 SKU sera supprimé. Les tours d'échantillon sont conservés — ils restent dans Sample Tracker sans projet. Cette action est irréversible.",
      "dropWarnMany": "{{n}} SKU seront supprimés. Les tours d'échantillon sont conservés — ils restent dans Sample Tracker sans projet. Cette action est irréversible.",
      "dropTicketsOne": "1 ticket de ce projet sera annulé, et l'équipe destinataire en sera informée :",
      "dropTicketsMany": "{{n}} tickets de ce projet seront annulés, et l'équipe destinataire en sera informée :",
      "dropEmailed": "déjà envoyé par e-mail",
      "dropReason": "Pourquoi l'annule-t-on ? (figure dans l'e-mail)",
      "dropConfirm": "Supprimer le projet",
      "dropBusy": "Suppression…",
      "approverNoteLabel": "Note de l'approbateur :",
      "setTitle": "E-mail d'approbation",
      "setNote": "Destinataire de l'e-mail « projet à approuver ». Modifiable ici — aucun déploiement nécessaire.",
      "setApprover": "Approbateur (À)",
      "setCc": "Cc (séparés par des virgules)",
      "setGate": "Le contrôle d'approbation est activé (les nouveaux projets démarrent en attente et les tickets sont bloqués)",
      "setSave": "Enregistrer les paramètres d'approbation",
      "setSaved": "Paramètres d'approbation enregistrés."
    },
    "tour": {
      "title": "Guide de l'écran",
      "ciTabsT": "Un onglet par modèle",
      "ciTabsB": "Le modèle 1 est le Weekly Cash Report, le modèle 2 le 13 Weeks Cash Plan, le modèle 3 le Month-End Reconcile. Choisissez celui que vous soumettez.",
      "ciPeriodT": "Votre entité et la période",
      "ciPeriodB": "L'entité vous suit : elle provient de votre ligne Preparer dans la liste des utilisateurs du Cash Report, et une liste déroulante n'apparaît que si vous préparez plus d'une entité. Les flèches passent à la semaine (ou au mois) précédent ou suivant ; la ligne à côté indique l'échéance du rapport.",
      "ciStepsT": "Où en est ce rapport",
      "ciStepsB": "Preparer → Reviewer. Une étape s'allume une fois réalisée ; lorsque le Reviewer donne son accord, les chiffres du rapport s'affichent dans le Cash Report.",
      "ciTemplateT": "Télécharger le modèle",
      "ciTemplateB": "Le modèle Excel pour cette entité et cette période, avec ses comptes déjà renseignés. Remplissez-le puis importez-le — les chiffres ne se saisissent pas sur le Portal.",
      "ciImportT": "Importer le fichier",
      "ciImportB": "Importez le modèle rempli. Il devient une version : le Data Check s'exécute et ses chiffres s'affichent ci-dessous. Un mauvais fichier peut être annulé et le fichier corrigé importé à nouveau.",
      "ciFormT": "Corriger ici",
      "ciFormB": "Une fois le modèle importé, ses chiffres s'ouvrent ici. Corrigez un chiffre puis enregistrez : cela devient la version suivante, avec le même Data Check — inutile de réimporter le fichier.",
      "ciCheckT": "Le Data Check",
      "ciCheckB": "Chaque version est contrôlée. Une erreur doit être corrigée avant l'envoi du rapport ; un avertissement est transmis pour que le Reviewer le lise.",
      "ciSendT": "Envoyer au Reviewer",
      "ciSendB": "Ajoutez une note si le Reviewer doit savoir quelque chose, puis envoyez. Un rapport envoyé ne peut plus être modifié ; s'il est renvoyé, vous le corrigez ici et l'envoyez de nouveau.",
      "ciFilesT": "Relevés bancaires et captures d'écran",
      "ciFilesB": "Joignez le relevé ou la capture du solde de chaque compte. Toute personne qui révise ou approuve le rapport les voit.",
      "ciHistoryT": "Historique et commentaires",
      "ciHistoryB": "Chaque import, saisie, envoi et décision est listé ici avec son auteur et la date. Écrivez un commentaire pour poser ou répondre à une question sur ce rapport.",
      "ciTestAsT": "Tester en tant que",
      "ciTestAsB": "Pour les tests uniquement : tant que les e-mails Cash sont suspendus, jouez chaque rôle pour essayer tout le circuit. Chaque étape est enregistrée comme « test as … ».",
      "cqTabsT": "Trois onglets",
      "cqTabsB": "En attente de vous contient les rapports qui attendent votre revue, les plus anciens d'abord. En cours contient ceux qui ont un autre Reviewer, et ceux renvoyés au Preparer avec le motif. Approuvés contient les rapports que le Reviewer a acceptés — ce sont ceux que le Cash Report affiche.",
      "cqListT": "Tous les rapports envoyés, dans une seule liste",
      "cqListB": "Weekly Cash Report, 13 Weeks Cash Plan et Month-End Reconcile, pour toutes les entités et périodes. Chaque en-tête trie et filtre comme dans Excel. Cliquez sur une ligne pour ouvrir ce rapport en dessous ; cliquez à nouveau pour le fermer.",
      "cqDecideT": "Votre décision",
      "cqDecideB": "Review & agree est la dernière étape : une fois votre accord donné, les chiffres du rapport s'affichent dans le Cash Report. Le bouton ouvre une fenêtre où vous donnez votre accord, ou renvoyez le rapport au Preparer avec un motif. Un rapport accepté peut être rouvert ici pour correction, avec un motif. Un rapport renvoyé attend sous En cours jusqu'à ce qu'il soit renvoyé.",
      "cqCheckT": "Le Data Check",
      "cqCheckB": "Les erreurs auraient empêché le Preparer d'envoyer le rapport : un rapport envoyé n'en contient donc aucune. Les avertissements vous sont transmis pour lecture avant votre décision.",
      "cqBodyT": "Ce qui a été importé",
      "cqBodyB": "Les chiffres exactement tels que le Preparer les a importés depuis le modèle — Fields 1 à 6 du rapport hebdomadaire, les 13 semaines du plan, ou le rapprochement de chaque compte. Rien ne peut être modifié ici ; un chiffre erroné est renvoyé.",
      "cqFilesT": "Relevés bancaires et captures d'écran",
      "cqFilesB": "Ce que le Preparer a joint pour chaque compte. Ouvrez-les pour vérifier les chiffres par rapport à la banque.",
      "cqHistoryT": "Historique et commentaires",
      "cqHistoryB": "Qui a importé, envoyé et décidé, et quand. Écrivez un commentaire pour poser une question au Preparer sans renvoyer le rapport.",
      "crNewT": "Créer une demande",
      "crNewB": "Pour qui sont les marchandises, le transporteur et le compte Helinox facturé, l'origine et la destination, le poids, votre coût estimé et l'incoterm. Le contrôle des coûts à côté du formulaire compare votre estimation au tarif du contrat FedEx de HINC au fil de la saisie. Enregistrer le brouillon conserve un formulaire à moitié rempli ; Envoyer pour approbation l'adresse à l'approbateur.",
      "crListT": "Vos demandes",
      "crListB": "Une ligne par demande. Les cinq premières colonnes restent fixes pendant que les autres défilent latéralement. Cliquez sur une ligne pour lire la demande sous la forme où elle a été envoyée.",
      "crCheckT": "Le contrôle des coûts",
      "crCheckB": "Votre estimation comparée au tarif du contrat : Raisonnable (jusqu'à 15 % au-dessus), À revoir (jusqu'à 35 %) ou Potentiellement élevé. Un trajet ou un transporteur que le contrat ne couvre pas est vérifié manuellement.",
      "crStatusT": "Où en est la demande",
      "crStatusB": "Brouillon (non envoyé), En attente (chez l'approbateur), Approuvé, Rejeté ou Retiré.",
      "crNoteT": "Note du responsable",
      "crNoteB": "Ce que l'approbateur a écrit avec sa décision. Cliquez dessus pour la lire en entier.",
      "crActT": "Ce que vous pouvez faire",
      "crActB": "Voir · Modifier (un brouillon, une demande rejetée ou retirée, ou encore en attente — l'enregistrer informe l'approbateur de ce qui a changé) · Soumettre un brouillon · Dupliquer en une nouvelle demande · Supprimer toute demande non approuvée. Un bouton grisé en donne la raison au survol.",
      "crqTabsT": "Trois onglets",
      "crqTabsB": "En attente de décision est votre file ; Approuvées et Rejetées conservent ce qui a été décidé.",
      "crqListT": "Les demandes",
      "crqListB": "Qui a demandé, de quelle entité, le trajet et le transporteur. Les cinq premières colonnes restent fixes. Cliquez sur une ligne pour lire la demande avec son contrôle des coûts.",
      "crqNoteT": "Note du responsable",
      "crqNoteB": "Ce que vous avez écrit avec la décision ; le demandeur la voit aussi dans sa liste.",
      "crqActT": "Voir · Modifier · Approuver",
      "crqActB": "Modifier corrige une demande en attente — elle reste en attente et le demandeur reçoit par e-mail ce qui a changé. Approuver ouvre la décision ; Rejeter s'y trouve et exige un motif.",
      "crqRatesT": "Tarifs",
      "crqRatesB": "Le fichier de tarifs du contrat FedEx lu par le contrôle des coûts, son import, la surcharge carburant et les deux seuils.",
      "crTabsT": "Trois rapports",
      "crTabsB": "Le Weekly Cash Report, le 13 Weeks Cash Plan et le Month-End Reconcile. Seuls les chiffres acceptés par le Reviewer sont affichés ici ; un rapport encore chez son Preparer ou son Reviewer apparaît comme une ligne indiquant où il se trouve.",
      "crPeriodT": "La période",
      "crPeriodB": "Choisissez une semaine (ou un mois dans l'onglet Month-End) ; les flèches passent à la précédente ou à la suivante. La ligne à côté indique l'échéance du rapport.",
      "crChartsT": "Les graphiques",
      "crChartsWB": "La trésorerie par entité, répartie en Available, Restricted et Fixed deposit, et la trésorerie du GROUP sur les 12 dernières semaines. Survolez une barre ou un point pour voir ses chiffres.",
      "crChartsPB": "Encaissements prévus vers le haut, décaissements prévus vers le bas ; la ligne en pointillés est la clôture prévue, la ligne pleine la clôture réelle du Weekly Cash Report.",
      "crChartsMB": "Trésorerie de fin de mois par entité, avec le nombre de comptes rapprochés et le nombre de comptes présentant un écart.",
      "crWeekT": "GROUP, puis chaque entité",
      "crWeekB": "La première ligne est le GROUP ; chaque entité suit en SGD. Cliquez sur la ligne d'une entité pour ouvrir sa ligne intragroupe et ses comptes — les colonnes Bank, Account No., Type of account et Restricted / Fixed deposit apparaissent alors, et chaque compte est affiché dans sa propre devise, tel qu'importé.",
      "crExpandT": "Ouvrir ou replier toutes les entités",
      "crExpandB": "Tout développer ouvre chaque entité jusqu'à ses comptes ici et son Top 3 en dessous ; Tout réduire les referme.",
      "crTopT": "Top 3",
      "crTopB": "Les trois principales dépenses de la semaine et les trois dettes à payer de la semaine suivante de chaque entité, en SGD. Une entité qui n'a rien importé figure aussi dans la liste, afin que personne ne soit oublié.",
      "crFiltersT": "Les deux filtres",
      "crFiltersB": "Entités : GROUP, une entité, ou plusieurs cochées ensemble (elles s'additionnent). Année : quelle année de semaines afficher. Le graphique et le tableau en dessous suivent les deux.",
      "crPlanTableT": "Chaque semaine de l'année",
      "crPlanTableB": "Une ligne par semaine. Une semaine écoulée se lit dans le plan déposé pour elle, une semaine à venir dans le plan le plus récent ; la colonne From plan l'indique. Les chiffres réels proviennent du Weekly Cash Report une fois accepté. La semaine affichée est en surbrillance, et chaque en-tête trie et filtre comme dans Excel.",
      "crPlanListT": "Qui a planifié cette semaine",
      "crPlanListB": "Le plan de chaque entité pour la semaine affichée : sa clôture prévue à la semaine 13 et l'état d'avancement du plan.",
      "crMonthT": "Le rapprochement",
      "crMonthB": "La ligne de chaque entité indique sa clôture de fin de mois en SGD, ainsi que qui l'a préparée et révisée ; ses comptes suivent, dans leur propre devise. Reconcile doit être à 0 sur chaque compte.",
      "crWaitingT": "En attente de vous",
      "crWaitingB": "Un rapport dont la prochaine étape vous revient porte ce badge. Cliquez dessus pour ouvrir le rapport dans Approval, où vous l'acceptez ou le renvoyez.",
      "step": "Étape {{n}} sur {{of}}",
      "next": "Suivant",
      "back": "Retour",
      "done": "Terminé",
      "skip": "Passer",
      "stCreateT": "Créer un nouvel échantillon ici",
      "stCreateB": "Choisissez le SKU de projet auquel l'échantillon est destiné. Seuls les SKU qui n'en ont pas encore sont listés, car un SKU porte exactement un échantillon. Vous n'avez plus besoin de passer par Project Tracker pour cela.",
      "stRoundT": "Ajouter un tour à un échantillon existant",
      "stRoundB": "P1, P2, P3, etc. Saisissez d'abord l'ID d'échantillon, le Base ID ou le nom du style pour trouver l'échantillon — tout le reste s'ouvre une fois que vous l'avez choisi.",
      "stTrialT": "Un échantillon sans projet",
      "stTrialB": "L'exception, pour un travail qui n'est pas encore devenu un SKU de projet. Il reçoit un numéro TSMP au lieu d'un numéro SMP.",
      "stCardsT": "Les cartes servent de filtre",
      "stCardsB": "Cliquez sur l'une d'elles et le tableau ci-dessous n'affiche que ces éléments. Cliquez à nouveau pour l'effacer. La rangée du haut compte les échantillons, celle du dessous compte les tours.",
      "stFiltersT": "Affiner davantage",
      "stFiltersB": "Par développeur, designer ou site R&D, ou en saisissant dans la zone de recherche. Effacer remet tout en place, y compris les filtres des en-têtes de colonnes.",
      "stRowT": "Un échantillon s'ouvre sur ses tours",
      "stRowB": "Cliquez sur la flèche d'une ligne pour voir tous les tours de ce Base ID. Tout développer les ouvre en une fois.",
      "stExportT": "L'emporter dans Excel",
      "stExportB": "Exporte exactement ce que le tableau affiche, filtres compris."
    },
    "st": {
      "tabAll": "Tous les échantillons",
      "tabSummary": "Synthèse par échantillon",
      "tagTrial": "Essai",
      "pillProject": "Échantillons de projet (SMP)",
      "pillTrial": "Échantillons d'essai (TSMP)",
      "pillBoth": "Les deux",
      "pillCtrlHint": "Ctrl / ⌘ + clic pour afficher celui-ci avec l'autre",
      "hintTrial": "Échantillons ponctuels sans SKU de projet. Leur Base ID est TSMP, et non SMP.",
      "titleTracker": "Suivi des échantillons",
      "titleSummary": "Synthèse par échantillon",
      "hintTracker": "Cliquez sur une carte pour mettre à jour le tableau - cliquez sur une ligne d'échantillon pour développer les tours",
      "hintSummary": "Une ligne par Base ID / produit avec le dernier calendrier et le statut du tour",
      "groupSample": "Échantillon / Base ID",
      "groupRounds": "Tours / Workflow",
      "totalSamples": "Total des échantillons",
      "totalSamplesSub": "Tous les échantillons, tous statuts",
      "inProgressSamples": "Échantillons en cours",
      "confirmedSamples": "Échantillons confirmés",
      "reworkSamples": "Échantillons en Rework",
      "droppedSamples": "Échantillons abandonnés",
      "onHoldSamples": "Échantillons en pause",
      "totalRounds": "Total des tours",
      "totalRoundsSub": "Tous les tours, tous statuts",
      "inProgressRounds": "Tours en cours",
      "confirmedRounds": "Tours confirmés",
      "reworkRounds": "Tours en Rework",
      "droppedRounds": "Tours abandonnés",
      "onHoldRounds": "Tours en pause",
      "pendingOutcome": "Résultat en attente",
      "pendingOutcomeSub": "Date de fin, pas de résultat",
      "rmWaiting": "Attente RM",
      "rmWaitingSub": "Matériaux non prêts",
      "inProduction": "En production",
      "inProductionSub": "RM prêt, non terminé",
      "allRounds": "Tous les tours",
      "allDevelopers": "Tous les développeurs",
      "allDesigners": "Tous les designers",
      "allLocations": "Tous les sites R&D",
      "allStatus": "Tous les statuts",
      "searchPlaceholder": "Rechercher un ID ou un article...",
      "clear": "Effacer",
      "newRound": "+ Nouveau tour",
      "csButton": "+ Créer un échantillon",
      "tourButton": "Guide",
      "tourReopen": "Me guider sur cet écran",
      "csTitle": "Créer un échantillon",
      "csIntro": "Choisissez le SKU de projet auquel cet échantillon est destiné. Seuls les SKU sans échantillon sont listés — un SKU porte exactement un échantillon.",
      "csSearch": "Rechercher un projet, un code SKU ou un style…",
      "csCount": "{{skus}} SKU dans {{projects}} projet(s)",
      "csNone": "Chaque SKU actif a déjà un échantillon.",
      "csNoMatch": "Aucun résultat.",
      "csMore": "et {{n}} autres — affinez la recherche pour les voir",
      "trButton": "+ Échantillon d'essai (hors projet)",
      "trTitleNew": "Nouvel échantillon d'essai",
      "trAddNewSample": "Ajouter un nouvel échantillon",
      "trTitle": "Échantillon d'essai — sans projet",
      "trSub": "Pour un échantillon ponctuel sans SKU de projet. Le Base ID est émis en TSMP, et non en SMP.",
      "trStylePh": "Saisissez le nom du style / de l'article",
      "trStyleHint": "Saisi ci-dessus — un échantillon d'essai n'a pas de SKU de projet d'où le tirer",
      "expandAll": "Tout développer",
      "collapseAll": "Tout réduire",
      "exportExcel": "Exporter vers Excel",
      "backToBase": "Retour à la vue par Base ID",
      "colBaseId": "Base ID",
      "colStyleItem": "Style / Article",
      "colRound": "Tour",
      "colSeason": "Saison",
      "colLocation": "Site R&D",
      "colDeveloper": "Développeur",
      "colDesigner": "Designer",
      "colProjectId": "ID du SKU de projet",
      "colRequestDate": "Date de demande",
      "colDevelopmentDue": "Échéance de développement",
      "colRmReady": "RM prête",
      "colRoundDue": "Échéance du tour",
      "colSampleFinish": "Date de fin de l'échantillon",
      "colReceived": "Reçu",
      "colComment": "Commentaire",
      "colQty": "Qté",
      "colRounds": "Tours",
      "colStatus": "Statut",
      "colDday": "D-day",
      "colDdayHint": "D-DAY = aujourd'hui − échéance de développement. Une valeur positive signifie que l'échantillon a ce nombre de jours de retard ; une valeur négative signifie qu'il reste ce nombre de jours.",
      "colDaysWaiting": "Jours d'attente",
      "goToProject": "Ouvrir ce SKU dans Project Tracker",
      "colRemarks": "Remarques",
      "colActions": "Actions",
      "colRework": "Reprise",
      "ptNo": "N°",
      "ptId": "ID",
      "ptProjectItem": "Projet / Article",
      "ptNotYours": "Seul le responsable du projet, le responsable de l'équipe ou un admin peut modifier ce projet.",
      "ptNotYourSku": "Seul le développeur auquel ce SKU est attribué, le responsable du projet ou le responsable de l'équipe peut le modifier.",
      "ptDeleteNotYours": "Seul le responsable du projet, le responsable de l'équipe ou un admin peut supprimer un SKU.",
      "ptCompletedLocked": "Ce SKU est Complete et la Production en a été informée — il ne peut plus être modifié ni supprimé.",
      "ptTicketNotYours": "Seul le responsable du projet, le responsable de l'équipe ou un admin peut émettre des tickets sur ce projet.",
      "ptTeam": "Équipe",
      "ptOwner": "Responsable du projet",
      "ptCategory": "Catégorie",
      "ptCase": "Cas",
      "ptEntity": "Entité",
      "ptItemCategory": "Catégorie d'article",
      "ptFrameColor": "Couleur du cadre",
      "ptQty": "QTY",
      "ptAssigned": "Attribué",
      "ptAllocation": "Allocation",
      "ptStatus": "Statut",
      "ptSalesRep": "Commercial",
      "ptWhere": "Statut du projet",
      "ptWhereComplete": "Terminé",
      "ptWhereDropped": "Abandonné",
      "ptWhereActive": "Actif",
      "ptAiHead": "Synthèse de Claude",
      "ptAiWriting": "Synthèse en cours…",
      "ptStart": "Début",
      "ptExfDate": "Date EXF",
      "ptTargetPrice": "Prix cible (USD)",
      "ptLaunchDate": "Date de lancement",
      "ptWeeksLeft": "Semaines restantes",
      "ptProgress": "Avancement",
      "ptRemark": "Remarque",
      "ptSampleId": "ID d'échantillon",
      "ptAction": "Action",
      "ptTitle": "Suivi des projets",
      "ptHint": "Gérez et suivez tous les projets de développement",
      "ptGroups": "Groupes de projets",
      "ptProjectComplete": "Projets terminés",
      "ptProjectCompleteSub": "tous les SKU Complete (ou Dropped)",
      "ptProjectDropped": "Projets abandonnés",
      "ptProjectDroppedSub": "tous les SKU sont Dropped",
      "ptProjectActive": "Projets actifs",
      "ptProjectActiveSub": "contient encore un SKU non terminé",
      "ptSkus": "SKU de projet",
      "ptComplete": "SKU terminés",
      "ptDrop": "SKU abandonnés",
      "ptActive": "SKU actifs",
      "ptPriority": "Priorité des SKU",
      "ptViewProject": "Voir ce projet (lecture seule)",
      "ptViewSku": "Voir ce SKU (lecture seule)",
      "ptViewTag": "Lecture seule",
      "rmTitleView": "Tour d'échantillon",
      "viewRound": "Voir ce tour (lecture seule)",
      "viewBase": "Voir ce Base ID (lecture seule)",
      "tkView": "Voir ce ticket (lecture seule)",
      "tkTitleView": "Ticket",
      "viewClose": "Fermer",
      "ptViewHint": "Lecture seule — rien ici ne peut être modifié ni enregistré.",
      "ptViewClose": "Fermer",
      "ptOnTrack": "SKU dans les temps",
      "ptConcern": "SKU à surveiller",
      "ptDelayed": "SKU en retard",
      "ptOnHold": "SKU en pause",
      "ptShipFinished": "SKU expédié",
      "ptAllTeams": "Toutes les équipes",
      "ptAllOwners": "Tous les responsables",
      "ptByMember": "Par membre",
      "ptByMemberTitle": "Charge de travail par responsable de projet",
      "ptByMemberHint": "Cliquez sur une ligne pour filtrer le tracker sur ce responsable. Les totaux suivent les filtres ci-dessus.",
      "ptOverdueExf": "EXF en retard",
      "ptAllCategories": "Toutes les catégories",
      "ptAllAssignees": "Tous les assignés",
      "ptAllAllocation": "Toutes les allocations",
      "ptSearch": "Rechercher un projet / article...",
      "ptExpandAll": "Tout développer",
      "ptCollapseAll": "Tout réduire",
      "ptColumns": "Colonnes",
      "ptReport": "Rapport",
      "ptNewProject": "+ Nouveau projet",
      "ptExpand": "Développer",
      "ptCollapse": "Réduire",
      "ptNoProjects": "Aucun projet trouvé.",
      "stgLdSoff": "L/D S/OFF",
      "stgProto": "Proto",
      "stgCounter": "Counter",
      "stgCosting": "Chiffrage",
      "stgHandOffMeeting": "Réunion de passation",
      "stgPpsPpm": "PPS/PPM",
      "stgProduction": "Production",
      "stgFinalInspection": "Inspection finale",
      "stgExfShipment": "Statut d'expédition",
      "stgPayment": "Paiement",
      "stgPoStatus": "Statut du PO",
      "pfNewProject": "Nouveau projet",
      "pfProjectInfo": "Informations du projet",
      "pfProjectInfoHint": "Informations de base, calendrier, statut, étapes et échantillons liés",
      "pfCategory": "Catégorie",
      "pfSelectCategory": "Sélectionner une catégorie...",
      "dgpTitle": "Supprimer le projet {{id}} ?",
      "dgpChecking": "Vérification des éléments rattachés à ce projet…",
      "dgpSkus": "{{n}} SKU seront supprimés.",
      "dgpRounds": "Les tours d'échantillon ne sont PAS supprimés — ils restent dans Sample Tracker sans lien avec un projet.",
      "dgpTickets": "{{n}} ticket(s) seront annulés, et les équipes concernées en seront informées.",
      "dgpUndo": "Cette action est irréversible depuis le portail.",
      "dgpConfirm": "Supprimer le projet",
      "dt1Title": "Supprimer le ticket {{id}} ?",
      "dt1Emailed": "Ce ticket a déjà été envoyé par e-mail à {{to}}. Le supprimer annule la demande, et ces personnes en seront informées — avec le motif ci-dessous.",
      "dt1NotEmailed": "Ce ticket n'a jamais été envoyé par e-mail : personne en dehors du portail n'en a connaissance. Le supprimer ne notifie personne.",
      "dt1ReasonHint": "Cette ligne est ce que l'équipe destinataire lit pour comprendre pourquoi sa demande a disparu.",
      "dt1Confirm": "Supprimer le ticket",
      "dt1ConfirmMail": "Supprimer et notifier",
      "dtTitle": "Supprimer {{id}} — il a des tickets",
      "dtLead": "Ces {{n}} ticket(s) appartiennent à ce projet. Le supprimer les annule, et les équipes qui les ont reçus en seront informées :",
      "dtNeverEmailed": "jamais envoyé par e-mail",
      "dtReason": "Pourquoi est-il supprimé ?",
      "dtReasonPh": "p. ex. le partenaire a annulé la collaboration",
      "dtReasonHint": "Cette ligne figure dans l'e-mail d'annulation — c'est ce que l'équipe destinataire lit pour comprendre pourquoi sa demande a disparu.",
      "dtConfirm": "Supprimer et annuler les tickets",
      "gmSkuOnlyHint": "Votre équipe ne peut modifier que la section SKU — les informations du projet ci-dessus relèvent de Sales OP.",
      "pfReadOnlyHere": "Lecture seule ici — modifiez-le depuis Modifier le groupe de projets",
      "bmHint": "Ce qui appartient au Base ID lui-même, et non à un tour : ses photos et le nom du style que chacun de ses tours reprend ({{rounds}} tour(s) ici).",
      "bmStyleHint": "Le renommage s'applique à tous les tours de ce Base ID en une seule écriture.",
      "bmRename": "Renommer le style",
      "rmBasePhotos": "Photos de l'échantillon (Base ID)",
      "rmPhotoRequired": "Obligatoire",
      "rmPhotoNewBase": "Ce style est nouveau : l'enregistrement crée donc un nouveau Base ID — il faut au moins une photo de l'échantillon. La photo appartient au Base ID, les tours suivants ne la redemanderont pas.",
      "rmPhotoExistingBase": "Ce style existe déjà sous {{baseId}}, qui a ses propres photos. Rien à ajouter ici.",
      "rmPhotoNoStyle": "Saisissez d'abord le style / l'article. Un nouveau style crée un nouveau Base ID, qui nécessite une photo.",
      "pfPurpose": "Objectif du projet",
      "pfPurposePh": "pourquoi nous le faisons, et où il sera vendu.",
      "pfPurposeHint": "Le Sales OP Manager doit vérifier avec le Sales rep. Le CEO lit cette ligne pour décider go / no-go.",
      "pfNote": "Note",
      "pfTeam": "Équipe",
      "pfOwner": "Responsable du projet (Sales OP)",
      "pfHandover": "Vous confiez ce projet à {{who}}. Une fois enregistré, vous ne pourrez plus le modifier — seuls {{who}}, {{mgr}} ou un admin le pourront.",
      "pfHandoverMgr": "le responsable de l'équipe",
      "pfYear": "Année",
      "pfYearPick": "Sélectionner l'année…",
      "pfSeasonParts": "Saison",
      "pfSeasonMax2": "Facultatif — deux au maximum",
      "pfSeasonCode": "Code du projet : {{code}}",
      "seasonSpring": "Printemps",
      "seasonSummer": "Été",
      "seasonFall": "Automne",
      "seasonWinter": "Hiver",
      "pfSeason": "Saison",
      "pfPartner": "Partenaire / Ligne",
      "pfKeyword": "Mot-clé",
      "pfTargetLaunch": "Lancement cible (mois)",
      "pfNameHint": "Généré par le système. Le PRJ-ID reste la clé permanente ; c'est ce nom que les gens lisent.",
      "pfSelectTeam": "Sélectionner une équipe…",
      "pfSelectOwner": "Sélectionner un responsable…",
      "pfPickTeamFirst": "Choisissez d'abord une équipe",
      "gmTitle": "Modifier le groupe de projets",
      "gmSaveGroup": "Enregistrer le groupe",
      "gmSaveTickets": "Enregistrer les tickets",
      "pfProjectName": "Nom du projet",
      "pfProjectNamePh": "p. ex. 25 PARTICULIER",
      "pfCase": "Cas",
      "pfSelectCase": "Sélectionner un cas...",
      "pfEntity": "Entité",
      "pfSelectEntity": "Sélectionner une entité...",
      "pfSkuInfo": "Informations du SKU",
      "pfAddSku": "+ Ajouter un SKU",
      "mvBtn": "Déplacer des SKU depuis un projet",
      "mvBtnTitle": "Reprendre des SKU approuvés d'un autre projet de cette équipe — ils conservent leur approbation",
      "mvNeedTeam": "Choisissez d'abord l'équipe du projet",
      "mvNotManager": "Seul un admin ou le responsable de cette équipe peut déplacer des SKU",
      "mvHead": "Déplacer des SKU approuvés dans ce projet",
      "mvIntro": "Choisissez un projet de la même équipe et cochez ses SKU approuvés. Ils sont déplacés à l'enregistrement de ce formulaire, avec leur ID de SKU, leur approbation, leurs échantillons et leurs étapes — rien ne retourne au CEO. Les tickets déjà émis restent sur le projet d'origine. Le développeur, le designer et les responsables du projet reçoivent un e-mail.",
      "mvSource": "Les prendre depuis",
      "mvSearch": "Rechercher un projet ou un SKU",
      "mvSearchPh": "N° PRJ, nom du projet, n° de SKU ou nom de l'article…",
      "mvNoMatch": "Aucun résultat — essayez un mot plus court.",
      "mvPicked": "{{n}} coché(s)",
      "mvChoose": "Choisir un projet…",
      "mvLoading": "Chargement…",
      "mvApprovedN": "{{n}} approuvé(s)",
      "mvNone": "Aucun autre projet de cette équipe n'a de SKU approuvé.",
      "mvAllTaken": "Tous les SKU approuvés de ce projet sont déjà sélectionnés.",
      "mvAll": "Tout cocher",
      "mvColItem": "Article",
      "mvColApproved": "Approuvé",
      "mvColDeveloper": "Développeur",
      "mvColDesigner": "Designer",
      "mvCancel": "Annuler",
      "mvAdd": "Ajouter {{n}} SKU",
      "mvListHead": "Déplacement à l'enregistrement — {{n}} SKU",
      "mvFrom": "depuis {{id}}",
      "mvApprovedBy": "approuvé par {{who}}",
      "mvRemove": "Ne pas déplacer celui-ci",
      "mvSaveHint": "Rien n'a encore été déplacé : ces SKU sont déplacés dans ce projet à l'enregistrement du formulaire.",
      "mvTeamChanged": "Ces SKU proviennent d'un projet d'une autre équipe que celle choisie ci-dessus — retirez-les ou remettez l'équipe précédente.",
      "pfSkuHint": "Chaque SKU est enregistré comme son propre article PRJ sous un projet PG. Développez un SKU pour modifier ses informations, ses étapes initiales et son échantillon lié.",
      "pfUnassigned": "Non attribué",
      "pfNoCategory": "Sans catégorie",
      "pfQty": "QTY",
      "pfStageChip": "étape",
      "pfRemoveSku": "Retirer le SKU",
      "pfDuplicateSku": "Dupliquer ce SKU",
      "pfApprovalNoteHead": "Enregistré en attente d'approbation — pas encore envoyé à l'approbateur.",
      "pfApprovalNoteBody": "Ouvrez Project Approval et cliquez sur Soumettre pour envoyer la demande. Les tickets pourront être émis une fois le projet approuvé.",
      "pfDeveloper": "Développeur",
      "pfDesigner": "Designer",
      "pfNoDesigner": "Aucun designer",
      "ptDesigner": "Designer",
      "ptAllSalesReps": "Tous les Sales Reps",
      "ptAllDesigners": "Tous les designers",
      "pfAssignedTo": "Attribué à",
      "pfAllocation": "Allocation",
      "pfProductCategory": "Catégorie de produit",
      "pfFrameColor": "Couleur du cadre",
      "pfFrameColorPh": "Rechercher ou ajouter une couleur…",
      "pfItemName": "Nom de l'article / SKU",
      "pfItemNamePh": "p. ex. Backpack 17L",
      "pfEstQty": "QTY estimée",
      "pfStartDate": "Date de début",
      "pfExfShipDate": "Date d'expédition EXF",
      "pfTargetPrice": "Prix cible (USD)",
      "pfLaunchDate": "Date de lancement",
      "pfProjectStatus": "Statut du projet",
      "pfRemark": "Remarque",
      "pfInitialStages": "Étapes initiales du processus",
      "pfPctComplete": "terminé",
      "pfStageHint": "Choisissez un statut dans la liste ou saisissez le vôtre — utilisez jj/mm/aaaa pour une date. Une case laissée vide est enregistrée en Pending.",
      "pfRepeatOrder": "Commande répétée",
      "pfRepeatOrderHint": "Un modèle déjà développé, commandé de nouveau — pas d'échantillon proto ni counter, pas de validation L/D ni de réunion de passation : ces quatre étapes sont donc réglées sur Complete.",
      "pfStagePh": "Pending ou jj/mm/aaaa",
      "pfStageAuto": "Auto — d'après l'échantillon lié",
      "pfLinkSample": "Lier un échantillon (facultatif)",
      "pfLinkSampleHint": "Un ou plusieurs ID d'échantillon / Base ID, séparés par des virgules. Choisir un échantillon le lie à cet article PRJ.",
      "pfLinkSamplePh": "Sélectionner ou saisir un ID d'échantillon / Base ID",
      "pfGtm": "Programme GTM (facultatif)",
      "pfGtmHint": "Le programme GTM sous lequel ce SKU est lancé. Il apparaît aussi dans la feuille GTM",
      "pfGtmPh": "Sélectionner ou saisir un code GTM, p. ex. GTM-26-001",
      "pfTickets": "Tickets",
      "pfTicketsAdded": "{{count}} ticket(s) ajouté(s)",
      "pfNoTicketYet": "Aucun ticket ajouté",
      "pfAllReceivingTeams": "Toutes les équipes destinataires",
      "pfAddTicket": "＋ Ajouter un ticket…",
      "pfTicketHint": "Seuls les codes correspondant à l'équipe, au cas et à la catégorie de ce projet sont proposés, regroupés par phase. Choisissez une équipe destinataire, puis « ＋ Ajouter un ticket ». Les nouveaux tickets sont créés à l'enregistrement du groupe.",
      "pfClearTickets": "Effacer les tickets",
      "pfPhotosOnSku": "Les photos sont jointes à chaque SKU ci-dessus — ouvrez un SKU et utilisez Ajouter des photos.",
      "pfTicketEmpty": "Aucun ticket ajouté — choisissez des tickets avec « ＋ Ajouter un ticket ».",
      "pfCancel": "Annuler",
      "pfSaving": "Enregistrement...",
      "pfAddProject": "Ajouter le projet",
      "pfDiscardTitle": "Abandonner ce projet ?",
      "pfDiscardBody": "Ce que vous avez saisi n'est pas encore enregistré. Si vous fermez le formulaire, tout sera perdu.",
      "pfDiscardKeep": "Continuer la modification",
      "pfDiscardConfirm": "Abandonner",
      "dgEditTitle": "Abandonner vos modifications ?",
      "dgEditBody": "Ce que vous avez modifié ici n'est pas encore enregistré. Si vous fermez le formulaire, les modifications seront perdues.",
      "pfSaveChanges": "Enregistrer les modifications",
      "pfViewSample": "Voir l'échantillon lié",
      "pfSampleBtn": "Échantillon",
      "pfNewSku": "Nouveau SKU",
      "pfEditPrefix": "Modifier",
      "pfGroupLevelHint": "Informations au niveau du groupe — à modifier depuis le groupe de projets",
      "pfNewTag": "Nouveau",
      "pfSaveAddSku": "Ajouter le SKU",
      "thSortFilter": "Trier et filtrer",
      "thSortAZ": "Trier de A à Z",
      "thSortOldNew": "Trier du plus ancien au plus récent",
      "thSortZA": "Trier de Z à A",
      "thSortNewOld": "Trier du plus récent au plus ancien",
      "thSearch": "Rechercher...",
      "thSelectAll": "(Tout sélectionner)",
      "thNoMatches": "Aucun résultat",
      "thOk": "OK",
      "thCancel": "Annuler",
      "thBlanks": "(Vides)",
      "thFiltered": "Filtré — {{count}} valeur(s) conservée(s)",
      "pgSharedHint": "Informations de base communes à tous les SKU de ce groupe",
      "pgPrjItems": "article(s) PRJ",
      "pgSkuHint": "Chaque SKU est son propre article PRJ sous ce projet PG. Cliquez sur un SKU pour modifier ses informations, ses étapes et son échantillon lié.",
      "pgNoSku": "Aucun SKU dans ce groupe pour l'instant.",
      "pgRemoveSku": "Retirer ce SKU du groupe",
      "rmTitleNew": "Nouveau tour",
      "rmTitleNewSample": "Nouvel échantillon",
      "rmTitleEdit": "Modifier le tour existant",
      "rmTitleAdvance": "Tour suivant (requis par Advance)",
      "tkFiles": "Fichiers joints",
      "tfPick": "Cliquez pour joindre un fichier",
      "tfHint": "PDF, Excel, CSV, Word, images — jusqu'à {{max}} Mo chacun, envoyés avec l'e-mail du ticket",
      "tfUploading": "Importation…",
      "tfRemove": "Retirer ce fichier",
      "tfTotal": "{{n}} fichier(s), {{size}} — ils partent en pièces jointes de l'e-mail du ticket",
      "tfSaveFirst": "Ce ticket ne peut pas recevoir de fichiers.",
      "tfDraftNote": "ils sont joints à l'enregistrement du ticket",
      "tfTooBig": "{{name}} fait {{mb}} Mo ; la limite est de {{max}} Mo par fichier.",
      "rmPickSample": "Sélectionnez un échantillon existant auquel ajouter un tour",
      "rmPickSampleSub": "— saisissez l'ID d'échantillon, le Base ID ou le nom du style",
      "rmPickPh": "p. ex. SMP-2601-P1 ou SMP-2601...",
      "rmPickRequired": "Choisissez l'échantillon auquel appartient ce tour — un tour est toujours ajouté à un échantillon existant.",
      "rmPickFirst": "Commencez ici. Saisissez l'ID d'échantillon — le reste du formulaire s'ouvre dès qu'un échantillon est sélectionné.",
      "rmStyleFromSample": "Provient de l'échantillon choisi ci-dessus",
      "rmStyleFromSku": "Provient du SKU de projet auquel cet échantillon est destiné",
      "rmStylePlaceholder": "Choisissez un échantillon ci-dessus",
      "rmSalesTeam": "Équipe commerciale",
      "rmProjectOwner": "Responsable du projet",
      "rmProjectName": "Projet",
      "rmNoLinkedSku": "Non lié à un SKU",
      "rmClear": "Effacer",
      "rmAddingTo": "Ajout d'un tour à",
      "rmChange": "Changer",
      "rmAdvanceNote": "est en cours de passage à Advance, ce qui signifie que le développement passe au tour suivant. Renseignez ce tour et enregistrez — les deux sont enregistrés ensemble.",
      "rmAdvanceNoteSub": "Si vous annulez, le résultat Advance n'est pas enregistré non plus et le tour reste tel qu'il était.",
      "rmDupWarn": "Doublon possible : {{sampleId}} a déjà le tour « {{round}} » pour ce style (résultat : {{outcome}}).",
      "rmDupOpen": "ouvrir",
      "rmOwnership": "Responsabilité des champs :",
      "rmHevnFills": "Rempli par HEVN",
      "rmHincFills": "Rempli par HINC Design",
      "rmBothTeams": "Les deux équipes",
      "rmAutoGen": "Généré automatiquement",
      "rmMandatory": "= Champ obligatoire",
      "rmSampleIdent": "Identification de l'échantillon",
      "rmStyleItem": "Style / Article",
      "rmStyleHint": "Choisissez un style existant ou saisissez-en un nouveau — le Base ID est attribué automatiquement",
      "rmStylePh": "p. ex. Chair Zero LT",
      "rmBaseId": "Base ID",
      "rmAutoAssigned": "Attribué automatiquement",
      "rmSampleId": "ID d'échantillon",
      "rmSampleIdHint": "Base ID + Tour + Option (auto)",
      "rmRound": "Tour",
      "rmOption": "Option",
      "rmOptionHint": "Uniquement si la construction diffère",
      "rmOptionPh": "Tissu / Maille (vide pour les variantes de couleur)",
      "rmCategory": "Catégorie",
      "rmSeason": "Saison",
      "rmDevelopmentDue": "Échéance de développement",
      "rmDevDueHint": "Obligatoire — jaune dans la feuille",
      "rmTargetPrice": "Prix cible (USD)",
      "rmLinkedSku": "SKU de projet lié",
      "rmOptional": "Facultatif",
      "rmLinkedSkuHint": "Lier cet échantillon à un SKU de projet",
      "rmSearchProject": "Rechercher un projet...",
      "rmReviewType": "Type de revue",
      "rmHevn": "HEVN",
      "rmRequiresDesigner": "Nécessite une revue du designer",
      "rmInternalOnly": "Revue interne HEVN uniquement",
      "rmInternalNote": "Utilisez la date de revue et les remarques pour l'enregistrement de la revue interne HEVN. Ce tour n'est pas compté dans la charge du designer ni dans les retours en attente.",
      "rmDesignerNote": "La revue du designer conserve le circuit actuel de revue et de résultat HINC.",
      "rmInternalReview": "Revue interne HEVN",
      "rmRequestDate": "Date de demande",
      "rmInternalReqHint": "Même champ que la date de demande dans HINC Design Review — c'est la date de la revue interne",
      "rmRemarks": "Remarques",
      "rmInternalRemarksPh": "Notes éventuelles sur cette revue interne...",
      "rmSamplePlan": "Plan de l'échantillon",
      "rmDeveloper": "Développeur",
      "rmDeveloperPh": "Sélectionner ou saisir un nom...",
      "rmEitherName": "Un développeur ou un designer — l'un ou l'autre.",
      "rmLocation": "Site R&D",
      "rmRmReady": "Date RM Ready",
      "rmRmReadyHint": "Cochez Prévu s'il s'agit d'une date planifiée ; décochez une fois les matériaux / la spécification prêts.",
      "pfNeedOwner": "Ce projet n'a pas encore de responsable de projet : on ne peut donc pas y émettre de ticket — l'e-mail partirait avec « Project Owner: - » et l'équipe destinataire ne saurait pas qui contacter. Ouvrez le projet avec le crayon sur sa ligne, définissez le responsable du projet, enregistrez, puis revenez ici.",
      "pfNeedOwnerShort": "Définissez d'abord le responsable du projet",
      "rmMaterials": "Liste des matériaux",
      "rmMaterialsHint": "Toutes les colonnes ici appartiennent au SKU et se modifient sur le SKU — une seule liste, pas une copie : un matériau ajouté là-bas apparaît dans chaque tour. La date RM ready fait exception : elle appartient à ce tour et est enregistrée avec lui.",
      "rmMaterialsNoSku": "Pas encore de liste de matériaux — la liste appartient à un SKU de projet, et ce tour n'est lié à aucun. Renseignez SKU de projet lié ci-dessus et ses matériaux apparaîtront ici.",
      "rmExpectedDate": "Date prévue",
      "rmSampleFinish": "Date de fin de l'échantillon",
      "rmQty": "QTY",
      "rmActualCost": "Coût réel (USD)",
      "rmAutoCalc": "Calculé automatiquement (lecture seule) :",
      "rmMakeDays": "Jours de fabrication",
      "rmShipDays": "Jours d'expédition",
      "rmRoundCycle": "Cycle du tour",
      "rmDday": "D-day",
      "rmHincReview": "HINC Design Review",
      "rmHincDesigner": "Designer HINC",
      "rmHincReqHint": "Date à laquelle HINC a demandé cet échantillon",
      "rmRoundDue": "Échéance du tour",
      "rmRoundDueHint": "Objectif de HINC pour l'achèvement de l'échantillon",
      "rmReceivedDate": "Date de réception",
      "rmReceivedHint": "Date à laquelle HINC a reçu l'échantillon",
      "rmReviewDate": "Date de revue (date du commentaire)",
      "rmReviewDateHint": "Date à laquelle HINC a donné son retour",
      "rmRoundOutcome": "Résultat du tour",
      "rmOutcomeHint": "Défini après la réunion hebdomadaire de commentaires",
      "rmNotSetYet": "— pas encore défini —",
      "rmOutcomePick": "Sélectionnez un résultat pour voir sa signification.",
      "rmReworkTitle": "Rework — motif obligatoire",
      "rmReworkReason": "Motif du Rework",
      "rmSelectAll": "(sélectionnez tout ce qui s'applique)",
      "rmRoundRemarksPh": "Notes éventuelles sur ce tour...",
      "rmSaving": "Enregistrement...",
      "rmSaveChanges": "Enregistrer les modifications",
      "rmSaveAdvance": "Enregistrer Advance + nouveau tour",
      "rmAddNewRound": "Ajouter un nouveau tour",
      "rmCancel": "Annuler",
      "rmCancelAdvance": "Annuler (abandonner aussi Advance)",
      "tkTitle": "Ticket Station",
      "tkHint": "Suivez les tickets de projet, le suivi par les responsables, les échéances et les mises à jour de statut.",
      "tkAll": "Tous les tickets",
      "tkDone": "Clos",
      "tkCancelled": "Annulé",
      "tkPending": "Ouvert",
      "tkOverdue": "En retard",
      "tkAllRequesters": "Tous les demandeurs",
      "tkAllTeams": "Toutes les équipes destinataires",
      "tkAllSopTeams": "Toutes les équipes Sales OP",
      "tkAllPriority": "Toutes les priorités",
      "tkSearch": "Rechercher un ticket / projet...",
      "tkNewTicket": "+ Nouveau ticket",
      "tkTabTickets": "Ticket Station",
      "tkManageCodes": "Codes de ticket",
      "tkColTicketId": "ID du ticket",
      "tkColTicket": "Ticket",
      "tkColProject": "Projet",
      "tkColProjectName": "Nom du projet",
      "tkColTeam": "Équipe destinataire",
      "tkColRequester": "Demandeur",
      "tkColType": "Type",
      "tkColPriority": "Priorité",
      "tkColDue": "Échéance",
      "tkColCreatedBy": "Créé par",
      "tkColCreatedAt": "Créé le",
      "tkColUpdatedBy": "Modifié par",
      "tkColUpdatedAt": "Modifié le",
      "tkColNote": "Note",
      "tkColAssigneeReply": "Réponse de l'assigné",
      "tkLinkNotSent": "Envoyez d'abord le ticket — personne dans l'équipe destinataire ne sait encore qu'il existe, il n'y a donc personne pour répondre via ce lien.",
      "tkColDescription": "Description",
      "tkColAssigneeNote": "Note de l'assigné",
      "tkColEmailSent": "E-mail envoyé",
      "tkExportEmpty": "Rien à exporter — aucun ticket ne correspond aux filtres actuels.",
      "tkManagerStatus": "Statut du responsable",
      "tkRemind": "Relancer",
      "tkRemindHint": "Prévenir par e-mail l'équipe destinataire que ce ticket est toujours ouvert",
      "tkSend": "Envoyer",
      "tkSendHint": "Ce ticket n'a jamais été envoyé par e-mail — envoyez la demande à l'équipe destinataire",
      "tkSendDone": "Ticket {{id}} envoyé par e-mail à {{to}}.",
      "tkSendFailed": "Échec de l'envoi : {{err}}",
      "tkDdayHint": "D-DAY = aujourd'hui − échéance. Une valeur positive signifie que le ticket a ce nombre de jours de retard. Une fois le ticket Done ou Cancelled, la valeur est figée au jour de sa clôture.",
      "tkNotYourTeam": "Seuls l'auteur de ce ticket, le responsable du projet, le responsable de cette équipe ou un admin peuvent le modifier.",
      "tkExpandAll": "Tout développer",
      "tkCollapseAll": "Tout réduire",
      "tkTicketsSingular": "ticket",
      "tkTicketsPlural": "tickets",
      "tkNoProject": "(sans projet)",
      "tkEdit": "Modifier le ticket",
      "tkDuplicate": "Dupliquer le ticket",
      "tkDelete": "Supprimer le ticket",
      "tkOpenLink": "Ouvrir le lien public de statut",
      "tkLink": "Lien",
      "tkNoTickets": "Aucun ticket trouvé.",
      "tkTitleNew": "Nouveau ticket",
      "tkTitleEdit": "Modifier le ticket",
      "tkTitleDup": "Dupliquer le ticket",
      "tkAuto": "Auto",
      "tkProjectGroup": "Groupe de projets",
      "tkSearchGroup": "Rechercher un groupe de projets...",
      "tkAutoFromGroup": "Auto depuis le groupe de projets",
      "tkSelectTeam": "Sélectionner l'équipe destinataire...",
      "tkTicketCode": "Code du ticket",
      "tkSelectCode": "Sélectionner le type de ticket convenu...",
      "tkTicketName": "Nom du ticket",
      "tkSelectTypeFirst": "Sélectionnez un type de ticket",
      "tkDescription": "Description",
      "tkDescriptionPh": "Détail du ticket / résultat attendu",
      "tkRequesterPh": "Auto selon l'utilisateur connecté",
      "tkGroupEmail": "E-mail du groupe",
      "tkGroupEmailPh": "Auto selon l'équipe destinataire",
      "tkDueDate": "Échéance",
      "tkSentAt": "Envoyé par e-mail le",
      "tkAttachment": "Lien de la pièce jointe",
      "tkAttachmentPh": "Collez le lien Drive / du fichier",
      "tkNotePh": "Note interne ou dernière mise à jour",
      "tkSendAfterSave": "Envoyer l'e-mail après l'enregistrement",
      "tkSent": "Envoyé",
      "tkNotSent": "Non envoyé",
      "tkEmailSubject": "Objet de l'e-mail",
      "tkSystemGenerated": "généré par le système",
      "tkEmailCc": "Cc de l'e-mail",
      "tkEmailMessage": "Message de l'e-mail",
      "tkReadOnly": "lecture seule",
      "tkEmailMessagePh": "Message de l'e-mail",
      "tkGeneratedNote": "L'objet et le message de l'e-mail sont générés automatiquement et ne peuvent pas être modifiés.",
      "tkSendEmail": "Envoyer l'e-mail",
      "tkDeleteTicket": "Supprimer le ticket",
      "tkSaveTicket": "Enregistrer le ticket",
      "tkNoDueDate": "Pas d'échéance",
      "tkRemoveTicket": "Retirer le ticket",
      "tkOptionalNote": "Note facultative",
      "tkWillSend": "Sera envoyé à l'enregistrement",
      "tkQueued": "En file d'envoi",
      "tkQueuedCancelTitle": "En file d'envoi — cliquez pour annuler",
      "tkSendBlocked": "Renseignez d'abord les champs obligatoires ci-dessus — l'e-mail ne peut pas être envoyé sans eux",
      "tkSendTitle": "Le ticket est créé à l'enregistrement, l'e-mail est donc envoyé juste après"
    },
    "rt": {
      "bold": "Gras (Ctrl+B)",
      "italic": "Italique (Ctrl+I)",
      "underline": "Souligné (Ctrl+U)",
      "strike": "Barré",
      "colour": "Couleur du texte",
      "bullets": "Liste à puces",
      "numbers": "Liste numérotée",
      "clear": "Effacer la mise en forme",
      "cDefault": "Par défaut",
      "cRed": "Rouge",
      "cOrange": "Orange",
      "cGreen": "Vert",
      "cBlue": "Bleu",
      "cPurple": "Violet",
      "cGrey": "Gris"
    },
    "nfc": {
      "stDraft": "NON SOUMIS",
      "stWaiting": "EN ATTENTE D'APPROBATION",
      "stApproved": "APPROUVÉ",
      "stRejected": "REJETÉ",
      "replOk": "OK",
      "replNotFound": "Introuvable",
      "replReplaced": "Déjà remplacé",
      "replDuplicate": "Doublon",
      "notSignedIn": "(non connecté)",
      "role": "Rôle",
      "manager": "Responsable",
      "coordinator": "Coordinateur",
      "unassigned": "non attribué",
      "loading": "Chargement…",
      "noAccessTitle": "Pas d'accès",
      "noAccessBody": "n'a pas reçu de rôle Coordinator/Manager pour le portail NFC. Contactez Special Project pour être ajouté.",
      "accountWord": "Compte",
      "createTitle": "Créer une demande d'émission de tokens",
      "tabIssuance": "Émission de tokens",
      "tabReplacement": "Remplacer un NFC défectueux",
      "labelType": "Type d'étiquette",
      "labelNfc": "Étiquette NFC",
      "labelQr": "Étiquette QR thermocollante",
      "projectName": "Nom du projet",
      "batchName": "Nom du lot",
      "qty": "Quantité (QTY)",
      "qtyPh": "Obligatoire sauf en cas d'import d'articles",
      "style": "Style / Produit",
      "stylePh": "p. ex. Chair One (re)",
      "color": "Couleur",
      "vendor": "Fournisseur",
      "vendorPh": "p. ex. Metric / TheSang",
      "code": "Code",
      "codePh": "p. ex. 10001555",
      "importTitle": "Importer plusieurs articles (facultatif)",
      "importReplTitle": "Importer les tokens NFC défectueux",
      "downloadTemplate": "Télécharger le modèle CSV",
      "chooseCsv": "Choisir un CSV",
      "noFile": "Aucun fichier sélectionné",
      "importSummary": "{{count}} article(s) chargé(s), QTY totale {{qty}}. Vérifiez et modifiez avant de soumettre.",
      "importInvalid": "Certaines lignes sont invalides (Projet + Lot + Qté requis).",
      "importEmpty": "Aucun fichier d'import chargé — laissez vide pour utiliser les champs d'article unique ci-dessus.",
      "replSummary": "{{count}} token(s) défectueux chargé(s). Vérifiez avant de soumettre.",
      "replChecking": "Vérification par rapport au registre…",
      "warning": "Avertissement :",
      "oldToken": "Ancien token / URL NFC",
      "reason": "Motif",
      "notes": "Notes",
      "status": "Statut",
      "checking": "Vérification…",
      "notChecked": "Non vérifié",
      "replEmpty": "Aucun token défectueux chargé — téléchargez le modèle, puis importez un CSV pour commencer.",
      "optional": "Facultatif",
      "saving": "Enregistrement…",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "myRequests": "Mes demandes",
      "reload": "Recharger",
      "colId": "ID",
      "colProject": "Projet",
      "colBatch": "Lot",
      "colQty": "Qté",
      "colItems": "Articles",
      "colLabel": "Étiquette",
      "colVendor": "Fournisseur",
      "colCode": "Code",
      "colStatus": "Statut",
      "colUpdated": "Mis à jour",
      "colFile": "Fichier",
      "colAction": "Action",
      "colOld": "Ancien",
      "colNew": "Nouveau",
      "colOutput": "Sortie",
      "colRequestedBy": "Demandé par",
      "colEmail": "E-mail",
      "colAddedBy": "Ajouté par",
      "downloadOrder": "Télécharger le fichier de commande",
      "viewDetail": "Voir le détail",
      "edit": "Modifier",
      "submitApproval": "Soumettre pour approbation",
      "delete": "Supprimer",
      "reject": "Rejeter",
      "noRequests": "Aucune demande pour l'instant.",
      "reviewTitle": "Revue de la demande",
      "accessTitle": "Gérer l'accès au portail",
      "accessHint": "Accordez ou retirez l'accès Coordinator / Manager à ce portail NFC. Les changements prennent effet au prochain chargement du portail par l'utilisateur.",
      "grantAccess": "Accorder l'accès",
      "noUsers": "Aucun utilisateur attribué pour l'instant.",
      "detailTitle": "Détail de la demande",
      "lblNotes": "NOTES",
      "lblOutputFile": "FICHIER DE SORTIE",
      "openOutput": "Ouvrir la sortie",
      "lblDecisionNote": "NOTE DE DÉCISION",
      "replItems": "Articles de remplacement",
      "items": "Articles",
      "close": "Fermer",
      "genTitle": "Génération des tokens",
      "genLead": "est en cours d'approbation. Gardez cet onglet ouvert et",
      "genLeadBold": "ne cliquez pas de nouveau sur Approuver",
      "requestWord": "Demande",
      "working": "En cours...",
      "rejectTitle": "Rejeter la demande",
      "rejectReason": "Motif (envoyé au demandeur)",
      "rejectReasonPh": "Pourquoi est-elle rejetée ?",
      "rejectReasonReq": "Veuillez saisir un motif de rejet.",
      "rejectBtn": "Rejeter la demande",
      "deleteTitle": "Supprimer la demande",
      "deleteBody": "Supprimer la demande {{id}} ? Seules les demandes en brouillon ou rejetées peuvent être supprimées.",
      "nReplacements": "{{count}} remplacement(s)",
      "nItems": "{{count}} article(s)",
      "single": "Unique",
      "nCodes": "{{count}} code(s)",
      "flashCleared": "Formulaire de demande effacé.",
      "flashSubmitted": "Demande {{id}} soumise pour approbation.",
      "flashDraft": "Demande {{id}} enregistrée en brouillon.",
      "flashLoadedEdit": "{{id}} chargée pour modification.",
      "flashDeleted": "Demande {{id}} supprimée.",
      "flashApproved": "Demande {{id}} approuvée — {{qty}} tokens générés.",
      "flashGranted": "{{role}} accordé à {{email}}.",
      "flashRevoked": "{{role}} retiré à {{email}}.",
      "flashEmailReq": "Veuillez saisir une adresse e-mail.",
      "flashLoadedFile": "{{name}} chargé.",
      "flashRejected": "Demande {{id}} rejetée.",
      "progStarting": "Démarrage de l'approbation...",
      "progCompleted": "Terminé",
      "progGenerated": "{{qty}} tokens générés",
      "progSavedImport": "Import enregistré chargé"
    },
    "dd": {
      "title": "Tableau de bord",
      "scopeNote": "Échantillons de projet uniquement — les échantillons d'essai (TSMP) sont exclus de tous les chiffres de cette page. Sample Tracker liste les deux.",
      "loading": "Chargement du tableau de bord…",
      "retry": "Réessayer",
      "noData": "Aucune donnée",
      "totalRounds": "Total des tours",
      "acrossSamples": "sur {{count}} échantillons",
      "avgRoundsSample": "Tours moy. / échantillon",
      "higherSpinning": "plus élevé = plus de tâtonnements",
      "reworkRatio": "Taux de Rework",
      "mainKpi": "KPI principal",
      "pastDue": "Échéance de développement dépassée",
      "pastDueSub": "{{unit}} avec D-day ≥ 0",
      "reworkByRoom": "Taux de Rework par atelier de développement",
      "reworkAttribution": "Imputation du Rework (bidirectionnelle)",
      "hevnCaused": "HEVN (cause)",
      "hincCaused": "HINC (cause)",
      "external": "Externe",
      "hevnRatio": "Part imputée à HEVN",
      "stuckTime": "Indicateur de blocage",
      "avgCommentDiffers": "Jours moy. de commentaire — tours « differs »",
      "avgCommentAdvance": "Jours moy. de commentaire — tours Advance",
      "avgCommentAll": "Jours moy. de commentaire — tous",
      "spinning": "Échantillons qui tournent en rond (4 tours ou plus)",
      "sampleSpeed": "Rapidité des échantillons",
      "sampleSpeedNote": "RM Ready Date = la date à laquelle le tissu / les matériaux / la spécification sont prêts et l'atelier d'échantillons peut commencer à fabriquer l'échantillon. La rapidité des échantillons se compte de la RM Ready Date à la date de fin de l'échantillon ; les tours sans date de disponibilité réelle, ou avec une date de disponibilité prévue dans le futur, restent en RM Waiting et sont exclus.",
      "avgMakeHevn": "Jours de fabrication moy. (HEVN R&D)",
      "avgMakeTs": "Jours de fabrication moy. (TS)",
      "avgMakeMs": "Jours de fabrication moy. (MS)",
      "avgMakeTotal": "Jours de fabrication moy. (Total)",
      "byDeveloper": "Par développeur — détail complet",
      "colDeveloper": "Développeur",
      "colSamples": "Échantillons",
      "colRounds": "Tours",
      "colRework": "Reprise",
      "colReworkRate": "Taux de Rework",
      "colAvgRounds": "Tours moy.",
      "colAvgMakeDays": "Jours de fabrication moy.",
      "colPending": "En attente"
    }
  }
};

export default fr;
